/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * AI Shoot Lab API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptLegalConsentBody,
  AcceptLegalConsentResponse,
  AddModelReferenceImageBody,
  AdminGetInfluencerPhotoshootModelDefaultsParams,
  AdminGetPartyPhotoshootModelDefaultsParams,
  AdminGetPlanContentModelDefaultsParams,
  AdminListUserGeneratedImages200,
  AdminListUserGeneratedImagesParams,
  AdminPlan,
  AdminPlanChangeEventList,
  AdminPrompt,
  AdminUpdateRiskLevelBody,
  AdminUserPhotoshoot,
  AiFilterAdmin,
  AiFilterCost,
  AiFilterPublic,
  AiFilterSettingsAdmin,
  AiFilterSettingsPublic,
  AiFilterUserLimits,
  AnalyzeAiFilterImageBody,
  AnalyzeAiFilterImageResponse,
  AnalyzeReferenceBody,
  ApplyAiFilterBody,
  ApplyAiFilterResponse,
  ApplyPhotoDirectorEntryBody,
  ArtDirectionResult,
  AssignPlanBody,
  AuditLogImageActionBody,
  AuditLogListResponse,
  AuditLogSettings,
  AuthUser,
  AutoGenerateBody,
  AutoPostSettingsResponse,
  AutoPostingConnectResponse,
  AutoPostingEnabledPlatformsResponse,
  AutoPostingTabResponse,
  BillingSocialConnectorsResponse,
  BodyReferencePublic,
  BodyshotGeneration,
  BodyshotGenerationCreateBody,
  BodyshotSaveToLibraryBody,
  BodyshotSelectBody,
  BodyshotSettings,
  BodyshotSettingsUpdateBody,
  BodyshotUserSettings,
  CancelAllUserModelHeadshots200,
  CancelUserModelHeadshot200,
  CardGenerationResult,
  CommitModelEditSession200,
  CreateAgeRangeBody,
  CreateAiFilterBody,
  CreateArchetypeBody,
  CreateBodyTypeBody,
  CreateEthnicityBody,
  CreateGenderBody,
  CreateInfluencerBody,
  CreateInfluencerLocationBody,
  CreateInfluencerLocationImageBody,
  CreateLegalDocumentBody,
  CreateMannequinBody,
  CreateModelProfileBody,
  CreatePetModelBody,
  CreatePhotoshootBody,
  CreateProductBody,
  CreateShotCardBody,
  CreateStyleGuideBody,
  CreateUserAiFilterBody,
  CreateUserModelBody,
  CreateUserPetModels201,
  DeleteAdminMannequin200,
  DeleteAgeRange200,
  DeleteArchetype200,
  DeleteBodyType200,
  DeleteEthnicity200,
  DeleteGender200,
  DeleteModelEditSession200,
  DeleteUserModel200,
  DeleteUserModelImage200,
  DressMannequinBody,
  DressMannequinResult,
  DressModelBody,
  DressModelResult,
  EditImageBody,
  EditImageResponse,
  EmailGlobalSettings,
  EmailTemplate,
  EmailTemplateDetail,
  EmailTemplateListResponse,
  EmailTemplatePreviewResponse,
  ErrorResponse,
  FaceSmashUserModelImagesBody,
  FinalizeUploadBody,
  FinalizeUploadResponse,
  FinalizeUserModel200,
  GenerateImagesResult,
  GenerateMoreUserModelHeadshotsBody,
  GeneratePhotoshootFromImageBody,
  GeneratePhotoshootFromImageResult,
  GenerateVideoBody,
  GeneratedImage,
  GetAiFilterCostParams,
  GetEnabledAspectRatios200,
  GetShotCardAiFilterStatusParams,
  GetUserModelCreditRate200,
  GetVideoCostPreviewParams,
  GrantAdminRoleBody,
  GrantAdminRoleResponse,
  GrantComplimentaryBody,
  GrantComplimentaryResponse,
  HealthStatus,
  ImageModelsResponse,
  Influencer,
  InfluencerAnalyticsResponse,
  InfluencerLocation,
  InfluencerLocationImage,
  InfluencerPhotoshootCost,
  InfluencerPhotoshootRequestBody,
  InfluencerPhotoshootSettings,
  InfluencerPhotoshootSettingsUpdateBody,
  InfluencerReferenceImageSetting,
  InvitationDetails,
  InvitationResponse,
  InviteAdminBody,
  InviteComplimentaryBody,
  InviteUserBody,
  KeepUserModelImage200,
  LegalConsentStatus,
  LegalDocType,
  LegalDocument,
  LegalDocumentAcceptanceCount,
  ListActiveAgeRanges200Item,
  ListActiveArchetypes200Item,
  ListActiveBodyTypes200Item,
  ListActiveBodyTypesParams,
  ListActiveEthnicities200Item,
  ListActiveGenders200Item,
  ListAuditLogsParams,
  ListBodyReferencesParams,
  ListPlatformStyleGuidesParams,
  ListStyleGuidesParams,
  ListUsers200,
  ListUsersParams,
  LoginBody,
  MagicLinkInvitationResponse,
  MagicLinkRequestBody,
  MagicLinkVerifyBody,
  Mannequin,
  MannequinWithStar,
  MarkAllUserNotificationsRead200,
  MarkUserNotificationRead200,
  MessageResponse,
  ModelAgeRange,
  ModelArchetype,
  ModelBodyType,
  ModelEditSession,
  ModelEditSessionCommitBody,
  ModelEditSessionCreateBody,
  ModelEditSessionUpdateBody,
  ModelEthnicity,
  ModelGender,
  ModelOrganisationAssignment,
  ModelProfileWithImages,
  ModelReferenceImage,
  OptimizePromptBody,
  Organisation,
  OrganisationInput,
  PartyPhotoshootCost,
  PartyPhotoshootRequestBody,
  PartyPhotoshootSettings,
  PartyPhotoshootSettingsUpdateBody,
  PendingInvitation,
  PermanentDeleteAuditLogImage200,
  Photoshoot,
  PhotoshootDetail,
  PhotoshootJobStatus,
  PhotoshootSummary,
  PlanContentAutoAssignBody,
  PlanContentAutoAssignResult,
  PlanContentBatchLifecycleBody,
  PlanContentBatchLifecycleResult,
  PlanContentBodyReferenceBody,
  PlanContentCreatePostFromDescendantBody,
  PlanContentCustomDressBody,
  PlanContentCustomDressCost,
  PlanContentDialogConfig,
  PlanContentDressBody,
  PlanContentDressCost,
  PlanContentEditedDescendant,
  PlanContentGenerateBody,
  PlanContentGeneratePartyBody,
  PlanContentGenerateResponse,
  PlanContentGetCustomDressCostParams,
  PlanContentGetDressCostParams,
  PlanContentInfluencerPhotoshootCostParams,
  PlanContentListScheduledPostsParams,
  PlanContentManualPost,
  PlanContentManualPostCreateBody,
  PlanContentModelDefaults,
  PlanContentPartyConfig,
  PlanContentPartyCustomDressBody,
  PlanContentPartyDressBody,
  PlanContentPartyLineageCheck,
  PlanContentPartyLineageCheckBatchBody,
  PlanContentPartyLineageCheckBatchResponse,
  PlanContentPartyPhotoshootCostParams,
  PlanContentPost,
  PlanContentPostTextUpdate,
  PlanContentReorderApprovedBody,
  PlanContentReorderScheduledItemsBody,
  PlanContentResolveCancellationBody,
  PlanContentRiskLevel,
  PlanContentScheduleSettings,
  PlanContentScheduleSettingsUpdateBody,
  PlanContentScheduledPost,
  PlanContentScheduledPostCreateBody,
  PlanContentScheduledPostMoveBody,
  PlanContentScheduledPostOccurrence,
  PlanContentScheduledPostUpdateBody,
  PlanContentSettings,
  PlanContentSettingsUpdateBody,
  PlatformSettings,
  PreviewEmailTemplateBody,
  Product,
  ProductWithShootCount,
  PromoteModelToInfluencerBody,
  ReassignInfluencerBody,
  RefreshUserStripe200,
  RegenerateUserModelImage200,
  RegisterBody,
  ReorderAdminMannequins200,
  ReorderAiFiltersBody,
  ReorderBody,
  ReorderInfluencerLocationImagesBody,
  ReorderInfluencerLocationsBody,
  ReorderMannequinsBody,
  ReorderUserModelImagesBody,
  RequestUploadUrlBody,
  RequestUploadUrlResponse,
  ResponsibleUseAcknowledgementResponse,
  RestoreAuditLogImageResponse,
  RetryUserModelFaceSmash200,
  RetryUserModelProfileAnalysis200,
  RetryUserModelSideHeadshot200,
  RunAutoPostBatchResponse,
  SafeClothesActiveStatus,
  SetInfluencerReferenceImageActiveBody,
  ShotCard,
  ShotCardAiFilterStatusResponse,
  ShotCardApplyAiFilterBody,
  ShotCardApplyAiFilterResponse,
  ShotCardCustomDressBody,
  ShotCardCustomDressCost,
  ShotCardWithImages,
  StarMannequin200,
  StyleGuide,
  StyleSummaryResponse,
  TestSendEmailBody,
  TestSendEmailResponse,
  UnstarMannequin200,
  UpdateAgeRangeBody,
  UpdateAiFilterBody,
  UpdateAiFilterSettingsBody,
  UpdateArchetypeBody,
  UpdateAuditLogSettingsBody,
  UpdateAutoPostSettingsBody,
  UpdateAutoPostingTabBody,
  UpdateBodyTypeBody,
  UpdateEmailGlobalSettingsBody,
  UpdateEmailTemplateBody,
  UpdateEthnicityBody,
  UpdateGenderBody,
  UpdateGeneratedImageBody,
  UpdateInfluencerBody,
  UpdateInfluencerLocationBody,
  UpdateInfluencerLocationImageBody,
  UpdateMannequinBody,
  UpdateModelProfileBody,
  UpdateModelReferenceImageBody,
  UpdatePhotoshootBody,
  UpdateProductBody,
  UpdatePromptBody,
  UpdateSettingsBody,
  UpdateShotCardBody,
  UpdateUserAiFilterBody,
  UpdateUserBody,
  UpdateUserModelBody,
  UserAdmin,
  UserConsentList,
  UserNotification,
  UserPlan,
  VideoAiCost,
  VideoCostCreateBody,
  VideoCostMissingResponse,
  VideoCostPreview,
  VideoCostUpdateBody,
  VideoDirectorGenerateOptionsBody,
  VideoDirectorGenerateOptionsResponse,
  VideoDirectorModelsResponse,
  VideoGenerateResponse,
  VideoModelToggleBody,
  VideoModelToggleResponse,
  VideoSettings,
  VideoSettingsUpdateBody,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/v1/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/v1/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register via invitation token
 */
export const getRegisterUrl = () => {
  return `/api/v1/auth/register`;
};

export const register = async (
  registerBody: RegisterBody,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerBody),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterBody> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterBody>;
export type RegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register via invitation token
 */
export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterBody> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Login with email and password
 */
export const getLoginUrl = () => {
  return `/api/v1/auth/login`;
};

export const login = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginBody),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginBody>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login with email and password
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Request a magic link email
 */
export const getRequestMagicLinkUrl = () => {
  return `/api/v1/auth/magic-link/request`;
};

export const requestMagicLink = async (
  magicLinkRequestBody: MagicLinkRequestBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getRequestMagicLinkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(magicLinkRequestBody),
  });
};

export const getRequestMagicLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMagicLink>>,
    TError,
    { data: BodyType<MagicLinkRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestMagicLink>>,
  TError,
  { data: BodyType<MagicLinkRequestBody> },
  TContext
> => {
  const mutationKey = ["requestMagicLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestMagicLink>>,
    { data: BodyType<MagicLinkRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestMagicLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestMagicLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestMagicLink>>
>;
export type RequestMagicLinkMutationBody = BodyType<MagicLinkRequestBody>;
export type RequestMagicLinkMutationError = ErrorType<unknown>;

/**
 * @summary Request a magic link email
 */
export const useRequestMagicLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMagicLink>>,
    TError,
    { data: BodyType<MagicLinkRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestMagicLink>>,
  TError,
  { data: BodyType<MagicLinkRequestBody> },
  TContext
> => {
  return useMutation(getRequestMagicLinkMutationOptions(options));
};

/**
 * @summary Verify magic link token and login
 */
export const getVerifyMagicLinkUrl = () => {
  return `/api/v1/auth/magic-link/verify`;
};

export const verifyMagicLink = async (
  magicLinkVerifyBody: MagicLinkVerifyBody,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getVerifyMagicLinkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(magicLinkVerifyBody),
  });
};

export const getVerifyMagicLinkMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyMagicLink>>,
    TError,
    { data: BodyType<MagicLinkVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyMagicLink>>,
  TError,
  { data: BodyType<MagicLinkVerifyBody> },
  TContext
> => {
  const mutationKey = ["verifyMagicLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyMagicLink>>,
    { data: BodyType<MagicLinkVerifyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyMagicLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyMagicLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyMagicLink>>
>;
export type VerifyMagicLinkMutationBody = BodyType<MagicLinkVerifyBody>;
export type VerifyMagicLinkMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Verify magic link token and login
 */
export const useVerifyMagicLink = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyMagicLink>>,
    TError,
    { data: BodyType<MagicLinkVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyMagicLink>>,
  TError,
  { data: BodyType<MagicLinkVerifyBody> },
  TContext
> => {
  return useMutation(getVerifyMagicLinkMutationOptions(options));
};

/**
 * @summary Get current session user
 */
export const getGetSessionUrl = () => {
  return `/api/v1/auth/session`;
};

export const getSession = async (options?: RequestInit): Promise<AuthUser> => {
  return customFetch<AuthUser>(getGetSessionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSessionQueryKey = () => {
  return [`/api/v1/auth/session`] as const;
};

export const getGetSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSessionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({
    signal,
  }) => getSession({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSession>>
>;
export type GetSessionQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current session user
 */

export function useGetSession<
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Logout
 */
export const getLogoutUrl = () => {
  return `/api/v1/auth/logout`;
};

export const logout = async (
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Get invitation details by token
 */
export const getGetInvitationUrl = (token: string) => {
  return `/api/v1/auth/invitation/${token}`;
};

export const getInvitation = async (
  token: string,
  options?: RequestInit,
): Promise<InvitationDetails> => {
  return customFetch<InvitationDetails>(getGetInvitationUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetInvitationQueryKey = (token: string) => {
  return [`/api/v1/auth/invitation/${token}`] as const;
};

export const getGetInvitationQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvitation>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInvitation>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvitationQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitation>>> = ({
    signal,
  }) => getInvitation(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvitation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvitationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvitation>>
>;
export type GetInvitationQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get invitation details by token
 */

export function useGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitation>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInvitation>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvitationQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List user's products
 */
export const getListProductsUrl = () => {
  return `/api/v1/products`;
};

export const listProducts = async (
  options?: RequestInit,
): Promise<ProductWithShootCount[]> => {
  return customFetch<ProductWithShootCount[]>(getListProductsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListProductsQueryKey = () => {
  return [`/api/v1/products`] as const;
};

export const getListProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listProducts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProductsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({
    signal,
  }) => listProducts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProducts>>
>;
export type ListProductsQueryError = ErrorType<unknown>;

/**
 * @summary List user's products
 */

export function useListProducts<
  TData = Awaited<ReturnType<typeof listProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listProducts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProductsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a product
 */
export const getCreateProductUrl = () => {
  return `/api/v1/products`;
};

export const createProduct = async (
  createProductBody: CreateProductBody,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getCreateProductUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProductBody),
  });
};

export const getCreateProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: BodyType<CreateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<CreateProductBody> },
  TContext
> => {
  const mutationKey = ["createProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProduct>>,
    { data: BodyType<CreateProductBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createProduct(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProduct>>
>;
export type CreateProductMutationBody = BodyType<CreateProductBody>;
export type CreateProductMutationError = ErrorType<unknown>;

/**
 * @summary Create a product
 */
export const useCreateProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: BodyType<CreateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<CreateProductBody> },
  TContext
> => {
  return useMutation(getCreateProductMutationOptions(options));
};

/**
 * @summary Get a product
 */
export const getGetProductUrl = (id: number) => {
  return `/api/v1/products/${id}`;
};

export const getProduct = async (
  id: number,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getGetProductUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProductQueryKey = (id: number) => {
  return [`/api/v1/products/${id}`] as const;
};

export const getGetProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getProduct>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({
    signal,
  }) => getProduct(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProduct>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProduct>>
>;
export type GetProductQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a product
 */

export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getProduct>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProductQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a product
 */
export const getUpdateProductUrl = (id: number) => {
  return `/api/v1/products/${id}`;
};

export const updateProduct = async (
  id: number,
  updateProductBody: UpdateProductBody,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getUpdateProductUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProductBody),
  });
};

export const getUpdateProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { id: number; data: BodyType<UpdateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: number; data: BodyType<UpdateProductBody> },
  TContext
> => {
  const mutationKey = ["updateProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProduct>>,
    { id: number; data: BodyType<UpdateProductBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProduct(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProduct>>
>;
export type UpdateProductMutationBody = BodyType<UpdateProductBody>;
export type UpdateProductMutationError = ErrorType<unknown>;

/**
 * @summary Update a product
 */
export const useUpdateProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { id: number; data: BodyType<UpdateProductBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: number; data: BodyType<UpdateProductBody> },
  TContext
> => {
  return useMutation(getUpdateProductMutationOptions(options));
};

/**
 * @summary Delete a product
 */
export const getDeleteProductUrl = (id: number) => {
  return `/api/v1/products/${id}`;
};

export const deleteProduct = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteProductUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProduct>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProduct>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProduct(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProduct>>
>;

export type DeleteProductMutationError = ErrorType<unknown>;

/**
 * @summary Delete a product
 */
export const useDeleteProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProduct>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteProductMutationOptions(options));
};

/**
 * @summary List photoshoots for a product
 */
export const getListPhotoshootsUrl = (productId: number) => {
  return `/api/v1/products/${productId}/photoshoots`;
};

export const listPhotoshoots = async (
  productId: number,
  options?: RequestInit,
): Promise<PhotoshootSummary[]> => {
  return customFetch<PhotoshootSummary[]>(getListPhotoshootsUrl(productId), {
    ...options,
    method: "GET",
  });
};

export const getListPhotoshootsQueryKey = (productId: number) => {
  return [`/api/v1/products/${productId}/photoshoots`] as const;
};

export const getListPhotoshootsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPhotoshoots>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listPhotoshoots>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPhotoshootsQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPhotoshoots>>> = ({
    signal,
  }) => listPhotoshoots(productId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!productId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPhotoshoots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPhotoshootsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPhotoshoots>>
>;
export type ListPhotoshootsQueryError = ErrorType<unknown>;

/**
 * @summary List photoshoots for a product
 */

export function useListPhotoshoots<
  TData = Awaited<ReturnType<typeof listPhotoshoots>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listPhotoshoots>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPhotoshootsQueryOptions(productId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a photoshoot
 */
export const getCreatePhotoshootUrl = (productId: number) => {
  return `/api/v1/products/${productId}/photoshoots`;
};

export const createPhotoshoot = async (
  productId: number,
  createPhotoshootBody: CreatePhotoshootBody,
  options?: RequestInit,
): Promise<Photoshoot> => {
  return customFetch<Photoshoot>(getCreatePhotoshootUrl(productId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPhotoshootBody),
  });
};

export const getCreatePhotoshootMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhotoshoot>>,
    TError,
    { productId: number; data: BodyType<CreatePhotoshootBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPhotoshoot>>,
  TError,
  { productId: number; data: BodyType<CreatePhotoshootBody> },
  TContext
> => {
  const mutationKey = ["createPhotoshoot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPhotoshoot>>,
    { productId: number; data: BodyType<CreatePhotoshootBody> }
  > = (props) => {
    const { productId, data } = props ?? {};

    return createPhotoshoot(productId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePhotoshootMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPhotoshoot>>
>;
export type CreatePhotoshootMutationBody = BodyType<CreatePhotoshootBody>;
export type CreatePhotoshootMutationError = ErrorType<unknown>;

/**
 * @summary Create a photoshoot
 */
export const useCreatePhotoshoot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhotoshoot>>,
    TError,
    { productId: number; data: BodyType<CreatePhotoshootBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPhotoshoot>>,
  TError,
  { productId: number; data: BodyType<CreatePhotoshootBody> },
  TContext
> => {
  return useMutation(getCreatePhotoshootMutationOptions(options));
};

/**
 * @summary Get a photoshoot with all details
 */
export const getGetPhotoshootUrl = (id: number) => {
  return `/api/v1/photoshoots/${id}`;
};

export const getPhotoshoot = async (
  id: number,
  options?: RequestInit,
): Promise<PhotoshootDetail> => {
  return customFetch<PhotoshootDetail>(getGetPhotoshootUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPhotoshootQueryKey = (id: number) => {
  return [`/api/v1/photoshoots/${id}`] as const;
};

export const getGetPhotoshootQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhotoshoot>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getPhotoshoot>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhotoshootQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhotoshoot>>> = ({
    signal,
  }) => getPhotoshoot(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhotoshoot>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPhotoshootQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhotoshoot>>
>;
export type GetPhotoshootQueryError = ErrorType<unknown>;

/**
 * @summary Get a photoshoot with all details
 */

export function useGetPhotoshoot<
  TData = Awaited<ReturnType<typeof getPhotoshoot>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getPhotoshoot>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPhotoshootQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a photoshoot
 */
export const getUpdatePhotoshootUrl = (id: number) => {
  return `/api/v1/photoshoots/${id}`;
};

export const updatePhotoshoot = async (
  id: number,
  updatePhotoshootBody: UpdatePhotoshootBody,
  options?: RequestInit,
): Promise<Photoshoot> => {
  return customFetch<Photoshoot>(getUpdatePhotoshootUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePhotoshootBody),
  });
};

export const getUpdatePhotoshootMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePhotoshoot>>,
    TError,
    { id: number; data: BodyType<UpdatePhotoshootBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePhotoshoot>>,
  TError,
  { id: number; data: BodyType<UpdatePhotoshootBody> },
  TContext
> => {
  const mutationKey = ["updatePhotoshoot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePhotoshoot>>,
    { id: number; data: BodyType<UpdatePhotoshootBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePhotoshoot(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePhotoshootMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePhotoshoot>>
>;
export type UpdatePhotoshootMutationBody = BodyType<UpdatePhotoshootBody>;
export type UpdatePhotoshootMutationError = ErrorType<unknown>;

/**
 * @summary Update a photoshoot
 */
export const useUpdatePhotoshoot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePhotoshoot>>,
    TError,
    { id: number; data: BodyType<UpdatePhotoshootBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePhotoshoot>>,
  TError,
  { id: number; data: BodyType<UpdatePhotoshootBody> },
  TContext
> => {
  return useMutation(getUpdatePhotoshootMutationOptions(options));
};

/**
 * @summary Delete a photoshoot
 */
export const getDeletePhotoshootUrl = (id: number) => {
  return `/api/v1/photoshoots/${id}`;
};

export const deletePhotoshoot = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePhotoshootUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePhotoshootMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhotoshoot>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePhotoshoot>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePhotoshoot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePhotoshoot>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePhotoshoot(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePhotoshootMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePhotoshoot>>
>;

export type DeletePhotoshootMutationError = ErrorType<unknown>;

/**
 * @summary Delete a photoshoot
 */
export const useDeletePhotoshoot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhotoshoot>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePhotoshoot>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeletePhotoshootMutationOptions(options));
};

/**
 * @summary Check whether an active Safe Clothes entry exists
 */
export const getGetSafeClothesActiveStatusUrl = () => {
  return `/api/v1/safe-clothes/active-status`;
};

export const getSafeClothesActiveStatus = async (
  options?: RequestInit,
): Promise<SafeClothesActiveStatus> => {
  return customFetch<SafeClothesActiveStatus>(
    getGetSafeClothesActiveStatusUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSafeClothesActiveStatusQueryKey = () => {
  return [`/api/v1/safe-clothes/active-status`] as const;
};

export const getGetSafeClothesActiveStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getSafeClothesActiveStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getSafeClothesActiveStatus>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSafeClothesActiveStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSafeClothesActiveStatus>>
  > = ({ signal }) => getSafeClothesActiveStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSafeClothesActiveStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSafeClothesActiveStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSafeClothesActiveStatus>>
>;
export type GetSafeClothesActiveStatusQueryError = ErrorType<unknown>;

/**
 * @summary Check whether an active Safe Clothes entry exists
 */

export function useGetSafeClothesActiveStatus<
  TData = Awaited<ReturnType<typeof getSafeClothesActiveStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getSafeClothesActiveStatus>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSafeClothesActiveStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Process style guide photos with AI
 */
export const getProcessStyleGuideUrl = (id: number) => {
  return `/api/v1/photoshoots/${id}/process-style`;
};

export const processStyleGuide = async (
  id: number,
  options?: RequestInit,
): Promise<StyleSummaryResponse> => {
  return customFetch<StyleSummaryResponse>(getProcessStyleGuideUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getProcessStyleGuideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStyleGuide>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processStyleGuide>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["processStyleGuide"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processStyleGuide>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return processStyleGuide(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessStyleGuideMutationResult = NonNullable<
  Awaited<ReturnType<typeof processStyleGuide>>
>;

export type ProcessStyleGuideMutationError = ErrorType<unknown>;

/**
 * @summary Process style guide photos with AI
 */
export const useProcessStyleGuide = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStyleGuide>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof processStyleGuide>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getProcessStyleGuideMutationOptions(options));
};

/**
 * @summary Auto-generate shot cards with AI art direction
 */
export const getAutoGeneratePhotoshootUrl = (id: number) => {
  return `/api/v1/photoshoots/${id}/auto-generate`;
};

export const autoGeneratePhotoshoot = async (
  id: number,
  autoGenerateBody: AutoGenerateBody,
  options?: RequestInit,
): Promise<ShotCard[]> => {
  return customFetch<ShotCard[]>(getAutoGeneratePhotoshootUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(autoGenerateBody),
  });
};

export const getAutoGeneratePhotoshootMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autoGeneratePhotoshoot>>,
    TError,
    { id: number; data: BodyType<AutoGenerateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof autoGeneratePhotoshoot>>,
  TError,
  { id: number; data: BodyType<AutoGenerateBody> },
  TContext
> => {
  const mutationKey = ["autoGeneratePhotoshoot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof autoGeneratePhotoshoot>>,
    { id: number; data: BodyType<AutoGenerateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return autoGeneratePhotoshoot(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AutoGeneratePhotoshootMutationResult = NonNullable<
  Awaited<ReturnType<typeof autoGeneratePhotoshoot>>
>;
export type AutoGeneratePhotoshootMutationBody = BodyType<AutoGenerateBody>;
export type AutoGeneratePhotoshootMutationError = ErrorType<unknown>;

/**
 * @summary Auto-generate shot cards with AI art direction
 */
export const useAutoGeneratePhotoshoot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autoGeneratePhotoshoot>>,
    TError,
    { id: number; data: BodyType<AutoGenerateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof autoGeneratePhotoshoot>>,
  TError,
  { id: number; data: BodyType<AutoGenerateBody> },
  TContext
> => {
  return useMutation(getAutoGeneratePhotoshootMutationOptions(options));
};

/**
 * @summary List saved style guides (user's own, non-platform)
 */
export const getListStyleGuidesUrl = (params?: ListStyleGuidesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/style-guides?${stringifiedParams}`
    : `/api/v1/style-guides`;
};

export const listStyleGuides = async (
  params?: ListStyleGuidesParams,
  options?: RequestInit,
): Promise<StyleGuide[]> => {
  return customFetch<StyleGuide[]>(getListStyleGuidesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListStyleGuidesQueryKey = (params?: ListStyleGuidesParams) => {
  return [`/api/v1/style-guides`, ...(params ? [params] : [])] as const;
};

export const getListStyleGuidesQueryOptions = <
  TData = Awaited<ReturnType<typeof listStyleGuides>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStyleGuidesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listStyleGuides>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStyleGuidesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStyleGuides>>> = ({
    signal,
  }) => listStyleGuides(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStyleGuides>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStyleGuidesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStyleGuides>>
>;
export type ListStyleGuidesQueryError = ErrorType<unknown>;

/**
 * @summary List saved style guides (user's own, non-platform)
 */

export function useListStyleGuides<
  TData = Awaited<ReturnType<typeof listStyleGuides>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStyleGuidesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listStyleGuides>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStyleGuidesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save a new style guide
 */
export const getCreateStyleGuideUrl = () => {
  return `/api/v1/style-guides`;
};

export const createStyleGuide = async (
  createStyleGuideBody: CreateStyleGuideBody,
  options?: RequestInit,
): Promise<StyleGuide> => {
  return customFetch<StyleGuide>(getCreateStyleGuideUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStyleGuideBody),
  });
};

export const getCreateStyleGuideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStyleGuide>>,
    TError,
    { data: BodyType<CreateStyleGuideBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStyleGuide>>,
  TError,
  { data: BodyType<CreateStyleGuideBody> },
  TContext
> => {
  const mutationKey = ["createStyleGuide"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStyleGuide>>,
    { data: BodyType<CreateStyleGuideBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createStyleGuide(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStyleGuideMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStyleGuide>>
>;
export type CreateStyleGuideMutationBody = BodyType<CreateStyleGuideBody>;
export type CreateStyleGuideMutationError = ErrorType<unknown>;

/**
 * @summary Save a new style guide
 */
export const useCreateStyleGuide = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStyleGuide>>,
    TError,
    { data: BodyType<CreateStyleGuideBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStyleGuide>>,
  TError,
  { data: BodyType<CreateStyleGuideBody> },
  TContext
> => {
  return useMutation(getCreateStyleGuideMutationOptions(options));
};

/**
 * @summary List platform style guides visible to all users
 */
export const getListPlatformStyleGuidesUrl = (
  params?: ListPlatformStyleGuidesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/style-guides/platform?${stringifiedParams}`
    : `/api/v1/style-guides/platform`;
};

export const listPlatformStyleGuides = async (
  params?: ListPlatformStyleGuidesParams,
  options?: RequestInit,
): Promise<StyleGuide[]> => {
  return customFetch<StyleGuide[]>(getListPlatformStyleGuidesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPlatformStyleGuidesQueryKey = (
  params?: ListPlatformStyleGuidesParams,
) => {
  return [
    `/api/v1/style-guides/platform`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListPlatformStyleGuidesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPlatformStyleGuides>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPlatformStyleGuidesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listPlatformStyleGuides>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPlatformStyleGuidesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPlatformStyleGuides>>
  > = ({ signal }) =>
    listPlatformStyleGuides(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPlatformStyleGuides>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPlatformStyleGuidesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPlatformStyleGuides>>
>;
export type ListPlatformStyleGuidesQueryError = ErrorType<unknown>;

/**
 * @summary List platform style guides visible to all users
 */

export function useListPlatformStyleGuides<
  TData = Awaited<ReturnType<typeof listPlatformStyleGuides>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPlatformStyleGuidesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listPlatformStyleGuides>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPlatformStyleGuidesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a style guide by ID
 */
export const getGetStyleGuideUrl = (id: number) => {
  return `/api/v1/style-guides/${id}`;
};

export const getStyleGuide = async (
  id: number,
  options?: RequestInit,
): Promise<StyleGuide> => {
  return customFetch<StyleGuide>(getGetStyleGuideUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetStyleGuideQueryKey = (id: number) => {
  return [`/api/v1/style-guides/${id}`] as const;
};

export const getGetStyleGuideQueryOptions = <
  TData = Awaited<ReturnType<typeof getStyleGuide>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getStyleGuide>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStyleGuideQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStyleGuide>>> = ({
    signal,
  }) => getStyleGuide(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStyleGuide>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStyleGuideQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStyleGuide>>
>;
export type GetStyleGuideQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a style guide by ID
 */

export function useGetStyleGuide<
  TData = Awaited<ReturnType<typeof getStyleGuide>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getStyleGuide>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStyleGuideQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Promote a style guide to platform (admin only)
 */
export const getPromoteStyleGuideUrl = (id: number) => {
  return `/api/v1/style-guides/${id}/promote`;
};

export const promoteStyleGuide = async (
  id: number,
  options?: RequestInit,
): Promise<StyleGuide> => {
  return customFetch<StyleGuide>(getPromoteStyleGuideUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPromoteStyleGuideMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteStyleGuide>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteStyleGuide>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["promoteStyleGuide"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteStyleGuide>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return promoteStyleGuide(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteStyleGuideMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoteStyleGuide>>
>;

export type PromoteStyleGuideMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Promote a style guide to platform (admin only)
 */
export const usePromoteStyleGuide = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteStyleGuide>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoteStyleGuide>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPromoteStyleGuideMutationOptions(options));
};

/**
 * @summary Remove a style guide from platform (admin only)
 */
export const getUnpromoteStyleGuideUrl = (id: number) => {
  return `/api/v1/style-guides/${id}/unpromote`;
};

export const unpromoteStyleGuide = async (
  id: number,
  options?: RequestInit,
): Promise<StyleGuide> => {
  return customFetch<StyleGuide>(getUnpromoteStyleGuideUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getUnpromoteStyleGuideMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unpromoteStyleGuide>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unpromoteStyleGuide>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["unpromoteStyleGuide"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unpromoteStyleGuide>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unpromoteStyleGuide(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnpromoteStyleGuideMutationResult = NonNullable<
  Awaited<ReturnType<typeof unpromoteStyleGuide>>
>;

export type UnpromoteStyleGuideMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Remove a style guide from platform (admin only)
 */
export const useUnpromoteStyleGuide = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unpromoteStyleGuide>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unpromoteStyleGuide>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getUnpromoteStyleGuideMutationOptions(options));
};

/**
 * @summary List shot cards for a photoshoot
 */
export const getListShotCardsUrl = (photoshootId: number) => {
  return `/api/v1/photoshoots/${photoshootId}/cards`;
};

export const listShotCards = async (
  photoshootId: number,
  options?: RequestInit,
): Promise<ShotCardWithImages[]> => {
  return customFetch<ShotCardWithImages[]>(getListShotCardsUrl(photoshootId), {
    ...options,
    method: "GET",
  });
};

export const getListShotCardsQueryKey = (photoshootId: number) => {
  return [`/api/v1/photoshoots/${photoshootId}/cards`] as const;
};

export const getListShotCardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listShotCards>>,
  TError = ErrorType<unknown>,
>(
  photoshootId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listShotCards>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListShotCardsQueryKey(photoshootId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listShotCards>>> = ({
    signal,
  }) => listShotCards(photoshootId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!photoshootId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listShotCards>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListShotCardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listShotCards>>
>;
export type ListShotCardsQueryError = ErrorType<unknown>;

/**
 * @summary List shot cards for a photoshoot
 */

export function useListShotCards<
  TData = Awaited<ReturnType<typeof listShotCards>>,
  TError = ErrorType<unknown>,
>(
  photoshootId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listShotCards>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListShotCardsQueryOptions(photoshootId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a shot card
 */
export const getCreateShotCardUrl = (photoshootId: number) => {
  return `/api/v1/photoshoots/${photoshootId}/cards`;
};

export const createShotCard = async (
  photoshootId: number,
  createShotCardBody: CreateShotCardBody,
  options?: RequestInit,
): Promise<ShotCard> => {
  return customFetch<ShotCard>(getCreateShotCardUrl(photoshootId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createShotCardBody),
  });
};

export const getCreateShotCardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createShotCard>>,
    TError,
    { photoshootId: number; data: BodyType<CreateShotCardBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createShotCard>>,
  TError,
  { photoshootId: number; data: BodyType<CreateShotCardBody> },
  TContext
> => {
  const mutationKey = ["createShotCard"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createShotCard>>,
    { photoshootId: number; data: BodyType<CreateShotCardBody> }
  > = (props) => {
    const { photoshootId, data } = props ?? {};

    return createShotCard(photoshootId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateShotCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createShotCard>>
>;
export type CreateShotCardMutationBody = BodyType<CreateShotCardBody>;
export type CreateShotCardMutationError = ErrorType<unknown>;

/**
 * @summary Create a shot card
 */
export const useCreateShotCard = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createShotCard>>,
    TError,
    { photoshootId: number; data: BodyType<CreateShotCardBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createShotCard>>,
  TError,
  { photoshootId: number; data: BodyType<CreateShotCardBody> },
  TContext
> => {
  return useMutation(getCreateShotCardMutationOptions(options));
};

/**
 * @summary Update a shot card
 */
export const getUpdateShotCardUrl = (id: number) => {
  return `/api/v1/cards/${id}`;
};

export const updateShotCard = async (
  id: number,
  updateShotCardBody: UpdateShotCardBody,
  options?: RequestInit,
): Promise<ShotCard> => {
  return customFetch<ShotCard>(getUpdateShotCardUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateShotCardBody),
  });
};

export const getUpdateShotCardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShotCard>>,
    TError,
    { id: number; data: BodyType<UpdateShotCardBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateShotCard>>,
  TError,
  { id: number; data: BodyType<UpdateShotCardBody> },
  TContext
> => {
  const mutationKey = ["updateShotCard"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateShotCard>>,
    { id: number; data: BodyType<UpdateShotCardBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateShotCard(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateShotCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateShotCard>>
>;
export type UpdateShotCardMutationBody = BodyType<UpdateShotCardBody>;
export type UpdateShotCardMutationError = ErrorType<unknown>;

/**
 * @summary Update a shot card
 */
export const useUpdateShotCard = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShotCard>>,
    TError,
    { id: number; data: BodyType<UpdateShotCardBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateShotCard>>,
  TError,
  { id: number; data: BodyType<UpdateShotCardBody> },
  TContext
> => {
  return useMutation(getUpdateShotCardMutationOptions(options));
};

/**
 * @summary Delete a shot card
 */
export const getDeleteShotCardUrl = (id: number) => {
  return `/api/v1/cards/${id}`;
};

export const deleteShotCard = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteShotCardUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteShotCardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShotCard>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteShotCard>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteShotCard"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteShotCard>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteShotCard(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteShotCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteShotCard>>
>;

export type DeleteShotCardMutationError = ErrorType<unknown>;

/**
 * @summary Delete a shot card
 */
export const useDeleteShotCard = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShotCard>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteShotCard>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteShotCardMutationOptions(options));
};

/**
 * @summary Reorder shot cards
 */
export const getReorderShotCardsUrl = (id: number) => {
  return `/api/v1/cards/${id}/reorder`;
};

export const reorderShotCards = async (
  id: number,
  reorderBody: ReorderBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getReorderShotCardsUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderBody),
  });
};

export const getReorderShotCardsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderShotCards>>,
    TError,
    { id: number; data: BodyType<ReorderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderShotCards>>,
  TError,
  { id: number; data: BodyType<ReorderBody> },
  TContext
> => {
  const mutationKey = ["reorderShotCards"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderShotCards>>,
    { id: number; data: BodyType<ReorderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reorderShotCards(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderShotCardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderShotCards>>
>;
export type ReorderShotCardsMutationBody = BodyType<ReorderBody>;
export type ReorderShotCardsMutationError = ErrorType<unknown>;

/**
 * @summary Reorder shot cards
 */
export const useReorderShotCards = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderShotCards>>,
    TError,
    { id: number; data: BodyType<ReorderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderShotCards>>,
  TError,
  { id: number; data: BodyType<ReorderBody> },
  TContext
> => {
  return useMutation(getReorderShotCardsMutationOptions(options));
};

/**
 * @summary Load a Photo Director Library image's AI prompt into a shot card
 */
export const getApplyPhotoDirectorEntryUrl = (id: number) => {
  return `/api/v1/cards/${id}/use-photo-director-entry`;
};

export const applyPhotoDirectorEntry = async (
  id: number,
  applyPhotoDirectorEntryBody: ApplyPhotoDirectorEntryBody,
  options?: RequestInit,
): Promise<ShotCardWithImages> => {
  return customFetch<ShotCardWithImages>(getApplyPhotoDirectorEntryUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(applyPhotoDirectorEntryBody),
  });
};

export const getApplyPhotoDirectorEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyPhotoDirectorEntry>>,
    TError,
    { id: number; data: BodyType<ApplyPhotoDirectorEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyPhotoDirectorEntry>>,
  TError,
  { id: number; data: BodyType<ApplyPhotoDirectorEntryBody> },
  TContext
> => {
  const mutationKey = ["applyPhotoDirectorEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyPhotoDirectorEntry>>,
    { id: number; data: BodyType<ApplyPhotoDirectorEntryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return applyPhotoDirectorEntry(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyPhotoDirectorEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyPhotoDirectorEntry>>
>;
export type ApplyPhotoDirectorEntryMutationBody =
  BodyType<ApplyPhotoDirectorEntryBody>;
export type ApplyPhotoDirectorEntryMutationError = ErrorType<unknown>;

/**
 * @summary Load a Photo Director Library image's AI prompt into a shot card
 */
export const useApplyPhotoDirectorEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyPhotoDirectorEntry>>,
    TError,
    { id: number; data: BodyType<ApplyPhotoDirectorEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyPhotoDirectorEntry>>,
  TError,
  { id: number; data: BodyType<ApplyPhotoDirectorEntryBody> },
  TContext
> => {
  return useMutation(getApplyPhotoDirectorEntryMutationOptions(options));
};

/**
 * @summary Generate art direction for a card (Method B - Ask Art Director)
 */
export const getGenerateArtDirectionUrl = (id: number) => {
  return `/api/v1/cards/${id}/art-direction`;
};

export const generateArtDirection = async (
  id: number,
  options?: RequestInit,
): Promise<ArtDirectionResult> => {
  return customFetch<ArtDirectionResult>(getGenerateArtDirectionUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getGenerateArtDirectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateArtDirection>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateArtDirection>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["generateArtDirection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateArtDirection>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return generateArtDirection(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateArtDirectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateArtDirection>>
>;

export type GenerateArtDirectionMutationError = ErrorType<unknown>;

/**
 * @summary Generate art direction for a card (Method B - Ask Art Director)
 */
export const useGenerateArtDirection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateArtDirection>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateArtDirection>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getGenerateArtDirectionMutationOptions(options));
};

/**
 * @summary Optimize user's prompt (Method A)
 */
export const getOptimizePromptUrl = (id: number) => {
  return `/api/v1/cards/${id}/optimize-prompt`;
};

export const optimizePrompt = async (
  id: number,
  optimizePromptBody: OptimizePromptBody,
  options?: RequestInit,
): Promise<ArtDirectionResult> => {
  return customFetch<ArtDirectionResult>(getOptimizePromptUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(optimizePromptBody),
  });
};

export const getOptimizePromptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof optimizePrompt>>,
    TError,
    { id: number; data: BodyType<OptimizePromptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof optimizePrompt>>,
  TError,
  { id: number; data: BodyType<OptimizePromptBody> },
  TContext
> => {
  const mutationKey = ["optimizePrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof optimizePrompt>>,
    { id: number; data: BodyType<OptimizePromptBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return optimizePrompt(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OptimizePromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof optimizePrompt>>
>;
export type OptimizePromptMutationBody = BodyType<OptimizePromptBody>;
export type OptimizePromptMutationError = ErrorType<unknown>;

/**
 * @summary Optimize user's prompt (Method A)
 */
export const useOptimizePrompt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof optimizePrompt>>,
    TError,
    { id: number; data: BodyType<OptimizePromptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof optimizePrompt>>,
  TError,
  { id: number; data: BodyType<OptimizePromptBody> },
  TContext
> => {
  return useMutation(getOptimizePromptMutationOptions(options));
};

/**
 * @summary Analyze reference image (Method C)
 */
export const getAnalyzeReferenceUrl = (id: number) => {
  return `/api/v1/cards/${id}/analyze-reference`;
};

export const analyzeReference = async (
  id: number,
  analyzeReferenceBody: AnalyzeReferenceBody,
  options?: RequestInit,
): Promise<ArtDirectionResult> => {
  return customFetch<ArtDirectionResult>(getAnalyzeReferenceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(analyzeReferenceBody),
  });
};

export const getAnalyzeReferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeReference>>,
    TError,
    { id: number; data: BodyType<AnalyzeReferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeReference>>,
  TError,
  { id: number; data: BodyType<AnalyzeReferenceBody> },
  TContext
> => {
  const mutationKey = ["analyzeReference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeReference>>,
    { id: number; data: BodyType<AnalyzeReferenceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return analyzeReference(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeReferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeReference>>
>;
export type AnalyzeReferenceMutationBody = BodyType<AnalyzeReferenceBody>;
export type AnalyzeReferenceMutationError = ErrorType<unknown>;

/**
 * @summary Analyze reference image (Method C)
 */
export const useAnalyzeReference = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeReference>>,
    TError,
    { id: number; data: BodyType<AnalyzeReferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeReference>>,
  TError,
  { id: number; data: BodyType<AnalyzeReferenceBody> },
  TContext
> => {
  return useMutation(getAnalyzeReferenceMutationOptions(options));
};

/**
 * @summary Generate a dress-model image using a safe-clothes generated image as the source
 */
export const getDressModelUrl = (id: number) => {
  return `/api/v1/cards/${id}/dress-model`;
};

export const dressModel = async (
  id: number,
  dressModelBody: DressModelBody,
  options?: RequestInit,
): Promise<DressModelResult> => {
  return customFetch<DressModelResult>(getDressModelUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(dressModelBody),
  });
};

export const getDressModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dressModel>>,
    TError,
    { id: number; data: BodyType<DressModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dressModel>>,
  TError,
  { id: number; data: BodyType<DressModelBody> },
  TContext
> => {
  const mutationKey = ["dressModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dressModel>>,
    { id: number; data: BodyType<DressModelBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dressModel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DressModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof dressModel>>
>;
export type DressModelMutationBody = BodyType<DressModelBody>;
export type DressModelMutationError = ErrorType<unknown>;

/**
 * @summary Generate a dress-model image using a safe-clothes generated image as the source
 */
export const useDressModel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dressModel>>,
    TError,
    { id: number; data: BodyType<DressModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dressModel>>,
  TError,
  { id: number; data: BodyType<DressModelBody> },
  TContext
> => {
  return useMutation(getDressModelMutationOptions(options));
};

/**
 * @summary Per-image credit cost preview + max reference image cap for the shot-card Custom Dress flow. The cost reflects the default Dress Model and this card's quality (the exact charge); maxRefImages reflects the admin-configured cap. Returns `configured: false` when no Dress Model is enabled.
 */
export const getShotCardGetCustomDressCostUrl = (id: number) => {
  return `/api/v1/cards/${id}/custom-dress-cost`;
};

export const shotCardGetCustomDressCost = async (
  id: number,
  options?: RequestInit,
): Promise<ShotCardCustomDressCost> => {
  return customFetch<ShotCardCustomDressCost>(
    getShotCardGetCustomDressCostUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getShotCardGetCustomDressCostQueryKey = (id: number) => {
  return [`/api/v1/cards/${id}/custom-dress-cost`] as const;
};

export const getShotCardGetCustomDressCostQueryOptions = <
  TData = Awaited<ReturnType<typeof shotCardGetCustomDressCost>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof shotCardGetCustomDressCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getShotCardGetCustomDressCostQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof shotCardGetCustomDressCost>>
  > = ({ signal }) =>
    shotCardGetCustomDressCost(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof shotCardGetCustomDressCost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ShotCardGetCustomDressCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof shotCardGetCustomDressCost>>
>;
export type ShotCardGetCustomDressCostQueryError = ErrorType<unknown>;

/**
 * @summary Per-image credit cost preview + max reference image cap for the shot-card Custom Dress flow. The cost reflects the default Dress Model and this card's quality (the exact charge); maxRefImages reflects the admin-configured cap. Returns `configured: false` when no Dress Model is enabled.
 */

export function useShotCardGetCustomDressCost<
  TData = Awaited<ReturnType<typeof shotCardGetCustomDressCost>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof shotCardGetCustomDressCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getShotCardGetCustomDressCostQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Re-dress a shot card's generated image using user-supplied reference clothing images (mirrors Influencer Content's Provide Reference Clothes flow). Inserts a new generated_images row on success.
 */
export const getShotCardCustomDressUrl = (id: number) => {
  return `/api/v1/cards/${id}/custom-dress`;
};

export const shotCardCustomDress = async (
  id: number,
  shotCardCustomDressBody: ShotCardCustomDressBody,
  options?: RequestInit,
): Promise<DressModelResult> => {
  return customFetch<DressModelResult>(getShotCardCustomDressUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(shotCardCustomDressBody),
  });
};

export const getShotCardCustomDressMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shotCardCustomDress>>,
    TError,
    { id: number; data: BodyType<ShotCardCustomDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shotCardCustomDress>>,
  TError,
  { id: number; data: BodyType<ShotCardCustomDressBody> },
  TContext
> => {
  const mutationKey = ["shotCardCustomDress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shotCardCustomDress>>,
    { id: number; data: BodyType<ShotCardCustomDressBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return shotCardCustomDress(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShotCardCustomDressMutationResult = NonNullable<
  Awaited<ReturnType<typeof shotCardCustomDress>>
>;
export type ShotCardCustomDressMutationBody = BodyType<ShotCardCustomDressBody>;
export type ShotCardCustomDressMutationError = ErrorType<unknown>;

/**
 * @summary Re-dress a shot card's generated image using user-supplied reference clothing images (mirrors Influencer Content's Provide Reference Clothes flow). Inserts a new generated_images row on success.
 */
export const useShotCardCustomDress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shotCardCustomDress>>,
    TError,
    { id: number; data: BodyType<ShotCardCustomDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof shotCardCustomDress>>,
  TError,
  { id: number; data: BodyType<ShotCardCustomDressBody> },
  TContext
> => {
  return useMutation(getShotCardCustomDressMutationOptions(options));
};

/**
 * @summary Apply an AI Filter to one of a shot card's generated images; inserts a new generated_images row on success.
 */
export const getApplyShotCardAiFilterUrl = (id: number) => {
  return `/api/v1/cards/${id}/apply-ai-filter`;
};

export const applyShotCardAiFilter = async (
  id: number,
  shotCardApplyAiFilterBody: ShotCardApplyAiFilterBody,
  options?: RequestInit,
): Promise<ShotCardApplyAiFilterResponse> => {
  return customFetch<ShotCardApplyAiFilterResponse>(
    getApplyShotCardAiFilterUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(shotCardApplyAiFilterBody),
    },
  );
};

export const getApplyShotCardAiFilterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyShotCardAiFilter>>,
    TError,
    { id: number; data: BodyType<ShotCardApplyAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyShotCardAiFilter>>,
  TError,
  { id: number; data: BodyType<ShotCardApplyAiFilterBody> },
  TContext
> => {
  const mutationKey = ["applyShotCardAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyShotCardAiFilter>>,
    { id: number; data: BodyType<ShotCardApplyAiFilterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return applyShotCardAiFilter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyShotCardAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyShotCardAiFilter>>
>;
export type ApplyShotCardAiFilterMutationBody =
  BodyType<ShotCardApplyAiFilterBody>;
export type ApplyShotCardAiFilterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Apply an AI Filter to one of a shot card's generated images; inserts a new generated_images row on success.
 */
export const useApplyShotCardAiFilter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyShotCardAiFilter>>,
    TError,
    { id: number; data: BodyType<ShotCardApplyAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyShotCardAiFilter>>,
  TError,
  { id: number; data: BodyType<ShotCardApplyAiFilterBody> },
  TContext
> => {
  return useMutation(getApplyShotCardAiFilterMutationOptions(options));
};

/**
 * @summary Poll the status of a send-and-release shot-card AI Filter request, keyed by requestGroupId.
 */
export const getGetShotCardAiFilterStatusUrl = (
  id: number,
  params: GetShotCardAiFilterStatusParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/cards/${id}/ai-filter-status?${stringifiedParams}`
    : `/api/v1/cards/${id}/ai-filter-status`;
};

export const getShotCardAiFilterStatus = async (
  id: number,
  params: GetShotCardAiFilterStatusParams,
  options?: RequestInit,
): Promise<ShotCardAiFilterStatusResponse> => {
  return customFetch<ShotCardAiFilterStatusResponse>(
    getGetShotCardAiFilterStatusUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetShotCardAiFilterStatusQueryKey = (
  id: number,
  params?: GetShotCardAiFilterStatusParams,
) => {
  return [
    `/api/v1/cards/${id}/ai-filter-status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetShotCardAiFilterStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getShotCardAiFilterStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  params: GetShotCardAiFilterStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getShotCardAiFilterStatus>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetShotCardAiFilterStatusQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getShotCardAiFilterStatus>>
  > = ({ signal }) =>
    getShotCardAiFilterStatus(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getShotCardAiFilterStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetShotCardAiFilterStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShotCardAiFilterStatus>>
>;
export type GetShotCardAiFilterStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Poll the status of a send-and-release shot-card AI Filter request, keyed by requestGroupId.
 */

export function useGetShotCardAiFilterStatus<
  TData = Awaited<ReturnType<typeof getShotCardAiFilterStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  params: GetShotCardAiFilterStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getShotCardAiFilterStatus>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetShotCardAiFilterStatusQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate images for a single card
 */
export const getGenerateCardImagesUrl = (id: number) => {
  return `/api/v1/cards/${id}/generate-images`;
};

export const generateCardImages = async (
  id: number,
  options?: RequestInit,
): Promise<GenerateImagesResult> => {
  return customFetch<GenerateImagesResult>(getGenerateCardImagesUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getGenerateCardImagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCardImages>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateCardImages>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["generateCardImages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateCardImages>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return generateCardImages(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateCardImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateCardImages>>
>;

export type GenerateCardImagesMutationError = ErrorType<unknown>;

/**
 * @summary Generate images for a single card
 */
export const useGenerateCardImages = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCardImages>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateCardImages>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getGenerateCardImagesMutationOptions(options));
};

/**
 * @summary Regenerate the most recent batch of images for a card using the exact historical inputs (prompt, references, model, quality, aspect ratio) that produced them.
 */
export const getRegenerateCardBatchUrl = (id: number) => {
  return `/api/v1/cards/${id}/regenerate-batch`;
};

export const regenerateCardBatch = async (
  id: number,
  options?: RequestInit,
): Promise<GenerateImagesResult> => {
  return customFetch<GenerateImagesResult>(getRegenerateCardBatchUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRegenerateCardBatchMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCardBatch>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateCardBatch>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["regenerateCardBatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateCardBatch>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return regenerateCardBatch(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateCardBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateCardBatch>>
>;

export type RegenerateCardBatchMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Regenerate the most recent batch of images for a card using the exact historical inputs (prompt, references, model, quality, aspect ratio) that produced them.
 */
export const useRegenerateCardBatch = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCardBatch>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateCardBatch>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRegenerateCardBatchMutationOptions(options));
};

/**
 * @summary Regenerate a single generated image using the exact historical inputs that produced it (1 new image).
 */
export const getRegenerateCardImageUrl = (cardId: number, imageId: number) => {
  return `/api/v1/cards/${cardId}/images/${imageId}/regenerate`;
};

export const regenerateCardImage = async (
  cardId: number,
  imageId: number,
  options?: RequestInit,
): Promise<GenerateImagesResult> => {
  return customFetch<GenerateImagesResult>(
    getRegenerateCardImageUrl(cardId, imageId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRegenerateCardImageMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCardImage>>,
    TError,
    { cardId: number; imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateCardImage>>,
  TError,
  { cardId: number; imageId: number },
  TContext
> => {
  const mutationKey = ["regenerateCardImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateCardImage>>,
    { cardId: number; imageId: number }
  > = (props) => {
    const { cardId, imageId } = props ?? {};

    return regenerateCardImage(cardId, imageId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateCardImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateCardImage>>
>;

export type RegenerateCardImageMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Regenerate a single generated image using the exact historical inputs that produced it (1 new image).
 */
export const useRegenerateCardImage = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCardImage>>,
    TError,
    { cardId: number; imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateCardImage>>,
  TError,
  { cardId: number; imageId: number },
  TContext
> => {
  return useMutation(getRegenerateCardImageMutationOptions(options));
};

/**
 * @summary Edit, sharpen, humanize, insert, or precise-edit an image (Wan/Seedream/Gemini)
 */
export const getEditImageUrl = () => {
  return `/api/v1/edit-image`;
};

export const editImage = async (
  editImageBody: EditImageBody,
  options?: RequestInit,
): Promise<EditImageResponse> => {
  return customFetch<EditImageResponse>(getEditImageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(editImageBody),
  });
};

export const getEditImageMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editImage>>,
    TError,
    { data: BodyType<EditImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editImage>>,
  TError,
  { data: BodyType<EditImageBody> },
  TContext
> => {
  const mutationKey = ["editImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editImage>>,
    { data: BodyType<EditImageBody> }
  > = (props) => {
    const { data } = props ?? {};

    return editImage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof editImage>>
>;
export type EditImageMutationBody = BodyType<EditImageBody>;
export type EditImageMutationError = ErrorType<void>;

/**
 * @summary Edit, sharpen, humanize, insert, or precise-edit an image (Wan/Seedream/Gemini)
 */
export const useEditImage = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editImage>>,
    TError,
    { data: BodyType<EditImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof editImage>>,
  TError,
  { data: BodyType<EditImageBody> },
  TContext
> => {
  return useMutation(getEditImageMutationOptions(options));
};

/**
 * @summary Update a generated image (star/soft-delete)
 */
export const getUpdateGeneratedImageUrl = (cardId: number, imageId: number) => {
  return `/api/v1/cards/${cardId}/images/${imageId}`;
};

export const updateGeneratedImage = async (
  cardId: number,
  imageId: number,
  updateGeneratedImageBody: UpdateGeneratedImageBody,
  options?: RequestInit,
): Promise<GeneratedImage> => {
  return customFetch<GeneratedImage>(
    getUpdateGeneratedImageUrl(cardId, imageId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateGeneratedImageBody),
    },
  );
};

export const getUpdateGeneratedImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGeneratedImage>>,
    TError,
    {
      cardId: number;
      imageId: number;
      data: BodyType<UpdateGeneratedImageBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGeneratedImage>>,
  TError,
  { cardId: number; imageId: number; data: BodyType<UpdateGeneratedImageBody> },
  TContext
> => {
  const mutationKey = ["updateGeneratedImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGeneratedImage>>,
    {
      cardId: number;
      imageId: number;
      data: BodyType<UpdateGeneratedImageBody>;
    }
  > = (props) => {
    const { cardId, imageId, data } = props ?? {};

    return updateGeneratedImage(cardId, imageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGeneratedImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGeneratedImage>>
>;
export type UpdateGeneratedImageMutationBody =
  BodyType<UpdateGeneratedImageBody>;
export type UpdateGeneratedImageMutationError = ErrorType<unknown>;

/**
 * @summary Update a generated image (star/soft-delete)
 */
export const useUpdateGeneratedImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGeneratedImage>>,
    TError,
    {
      cardId: number;
      imageId: number;
      data: BodyType<UpdateGeneratedImageBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGeneratedImage>>,
  TError,
  { cardId: number; imageId: number; data: BodyType<UpdateGeneratedImageBody> },
  TContext
> => {
  return useMutation(getUpdateGeneratedImageMutationOptions(options));
};

/**
 * @summary Soft delete a generated image
 */
export const getDeleteGeneratedImageUrl = (cardId: number, imageId: number) => {
  return `/api/v1/cards/${cardId}/images/${imageId}`;
};

export const deleteGeneratedImage = async (
  cardId: number,
  imageId: number,
  options?: RequestInit,
): Promise<GeneratedImage> => {
  return customFetch<GeneratedImage>(
    getDeleteGeneratedImageUrl(cardId, imageId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteGeneratedImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGeneratedImage>>,
    TError,
    { cardId: number; imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGeneratedImage>>,
  TError,
  { cardId: number; imageId: number },
  TContext
> => {
  const mutationKey = ["deleteGeneratedImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGeneratedImage>>,
    { cardId: number; imageId: number }
  > = (props) => {
    const { cardId, imageId } = props ?? {};

    return deleteGeneratedImage(cardId, imageId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGeneratedImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGeneratedImage>>
>;

export type DeleteGeneratedImageMutationError = ErrorType<unknown>;

/**
 * @summary Soft delete a generated image
 */
export const useDeleteGeneratedImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGeneratedImage>>,
    TError,
    { cardId: number; imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteGeneratedImage>>,
  TError,
  { cardId: number; imageId: number },
  TContext
> => {
  return useMutation(getDeleteGeneratedImageMutationOptions(options));
};

/**
 * @summary Generate a photoshoot from a single source image
 */
export const getGeneratePhotoshootFromImageUrl = (id: number) => {
  return `/api/v1/cards/${id}/generate-photoshoot-from-image`;
};

export const generatePhotoshootFromImage = async (
  id: number,
  generatePhotoshootFromImageBody: GeneratePhotoshootFromImageBody,
  options?: RequestInit,
): Promise<GeneratePhotoshootFromImageResult> => {
  return customFetch<GeneratePhotoshootFromImageResult>(
    getGeneratePhotoshootFromImageUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generatePhotoshootFromImageBody),
    },
  );
};

export const getGeneratePhotoshootFromImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePhotoshootFromImage>>,
    TError,
    { id: number; data: BodyType<GeneratePhotoshootFromImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generatePhotoshootFromImage>>,
  TError,
  { id: number; data: BodyType<GeneratePhotoshootFromImageBody> },
  TContext
> => {
  const mutationKey = ["generatePhotoshootFromImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generatePhotoshootFromImage>>,
    { id: number; data: BodyType<GeneratePhotoshootFromImageBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generatePhotoshootFromImage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GeneratePhotoshootFromImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generatePhotoshootFromImage>>
>;
export type GeneratePhotoshootFromImageMutationBody =
  BodyType<GeneratePhotoshootFromImageBody>;
export type GeneratePhotoshootFromImageMutationError = ErrorType<unknown>;

/**
 * @summary Generate a photoshoot from a single source image
 */
export const useGeneratePhotoshootFromImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePhotoshootFromImage>>,
    TError,
    { id: number; data: BodyType<GeneratePhotoshootFromImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generatePhotoshootFromImage>>,
  TError,
  { id: number; data: BodyType<GeneratePhotoshootFromImageBody> },
  TContext
> => {
  return useMutation(getGeneratePhotoshootFromImageMutationOptions(options));
};

/**
 * @summary Get the status of a photoshoot-from-image job
 */
export const getGetPhotoshootJobStatusUrl = (id: number, jobId: string) => {
  return `/api/v1/cards/${id}/photoshoot-job/${jobId}`;
};

export const getPhotoshootJobStatus = async (
  id: number,
  jobId: string,
  options?: RequestInit,
): Promise<PhotoshootJobStatus> => {
  return customFetch<PhotoshootJobStatus>(
    getGetPhotoshootJobStatusUrl(id, jobId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPhotoshootJobStatusQueryKey = (
  id: number,
  jobId: string,
) => {
  return [`/api/v1/cards/${id}/photoshoot-job/${jobId}`] as const;
};

export const getGetPhotoshootJobStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhotoshootJobStatus>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getPhotoshootJobStatus>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhotoshootJobStatusQueryKey(id, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhotoshootJobStatus>>
  > = ({ signal }) =>
    getPhotoshootJobStatus(id, jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && jobId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhotoshootJobStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPhotoshootJobStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhotoshootJobStatus>>
>;
export type GetPhotoshootJobStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get the status of a photoshoot-from-image job
 */

export function useGetPhotoshootJobStatus<
  TData = Awaited<ReturnType<typeof getPhotoshootJobStatus>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getPhotoshootJobStatus>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPhotoshootJobStatusQueryOptions(
    id,
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate images for all cards in a photoshoot
 */
export const getGeneratePhotoshootUrl = (id: number) => {
  return `/api/v1/photoshoots/${id}/generate`;
};

export const generatePhotoshoot = async (
  id: number,
  options?: RequestInit,
): Promise<CardGenerationResult[]> => {
  return customFetch<CardGenerationResult[]>(getGeneratePhotoshootUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getGeneratePhotoshootMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePhotoshoot>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generatePhotoshoot>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["generatePhotoshoot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generatePhotoshoot>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return generatePhotoshoot(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GeneratePhotoshootMutationResult = NonNullable<
  Awaited<ReturnType<typeof generatePhotoshoot>>
>;

export type GeneratePhotoshootMutationError = ErrorType<unknown>;

/**
 * @summary Generate images for all cards in a photoshoot
 */
export const useGeneratePhotoshoot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePhotoshoot>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generatePhotoshoot>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getGeneratePhotoshootMutationOptions(options));
};

/**
 * @summary List all model profiles
 */
export const getListModelProfilesUrl = () => {
  return `/api/v1/admin/models`;
};

export const listModelProfiles = async (
  options?: RequestInit,
): Promise<ModelProfileWithImages[]> => {
  return customFetch<ModelProfileWithImages[]>(getListModelProfilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListModelProfilesQueryKey = () => {
  return [`/api/v1/admin/models`] as const;
};

export const getListModelProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listModelProfiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listModelProfiles>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModelProfilesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listModelProfiles>>
  > = ({ signal }) => listModelProfiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModelProfiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListModelProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModelProfiles>>
>;
export type ListModelProfilesQueryError = ErrorType<unknown>;

/**
 * @summary List all model profiles
 */

export function useListModelProfiles<
  TData = Awaited<ReturnType<typeof listModelProfiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listModelProfiles>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListModelProfilesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a model profile
 */
export const getCreateModelProfileUrl = () => {
  return `/api/v1/admin/models`;
};

export const createModelProfile = async (
  createModelProfileBody: CreateModelProfileBody,
  options?: RequestInit,
): Promise<ModelProfileWithImages> => {
  return customFetch<ModelProfileWithImages>(getCreateModelProfileUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createModelProfileBody),
  });
};

export const getCreateModelProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelProfile>>,
    TError,
    { data: BodyType<CreateModelProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModelProfile>>,
  TError,
  { data: BodyType<CreateModelProfileBody> },
  TContext
> => {
  const mutationKey = ["createModelProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModelProfile>>,
    { data: BodyType<CreateModelProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createModelProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModelProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModelProfile>>
>;
export type CreateModelProfileMutationBody = BodyType<CreateModelProfileBody>;
export type CreateModelProfileMutationError = ErrorType<unknown>;

/**
 * @summary Create a model profile
 */
export const useCreateModelProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelProfile>>,
    TError,
    { data: BodyType<CreateModelProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createModelProfile>>,
  TError,
  { data: BodyType<CreateModelProfileBody> },
  TContext
> => {
  return useMutation(getCreateModelProfileMutationOptions(options));
};

/**
 * @summary Update a model profile
 */
export const getUpdateModelProfileUrl = (id: number) => {
  return `/api/v1/admin/models/${id}`;
};

export const updateModelProfile = async (
  id: number,
  updateModelProfileBody: UpdateModelProfileBody,
  options?: RequestInit,
): Promise<ModelProfileWithImages> => {
  return customFetch<ModelProfileWithImages>(getUpdateModelProfileUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateModelProfileBody),
  });
};

export const getUpdateModelProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelProfile>>,
    TError,
    { id: number; data: BodyType<UpdateModelProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModelProfile>>,
  TError,
  { id: number; data: BodyType<UpdateModelProfileBody> },
  TContext
> => {
  const mutationKey = ["updateModelProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModelProfile>>,
    { id: number; data: BodyType<UpdateModelProfileBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateModelProfile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModelProfile>>
>;
export type UpdateModelProfileMutationBody = BodyType<UpdateModelProfileBody>;
export type UpdateModelProfileMutationError = ErrorType<unknown>;

/**
 * @summary Update a model profile
 */
export const useUpdateModelProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelProfile>>,
    TError,
    { id: number; data: BodyType<UpdateModelProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModelProfile>>,
  TError,
  { id: number; data: BodyType<UpdateModelProfileBody> },
  TContext
> => {
  return useMutation(getUpdateModelProfileMutationOptions(options));
};

/**
 * @summary Delete a model profile
 */
export const getDeleteModelProfileUrl = (id: number) => {
  return `/api/v1/admin/models/${id}`;
};

export const deleteModelProfile = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteModelProfileUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteModelProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModelProfile>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteModelProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModelProfile>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteModelProfile(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModelProfile>>
>;

export type DeleteModelProfileMutationError = ErrorType<unknown>;

/**
 * @summary Delete a model profile
 */
export const useDeleteModelProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModelProfile>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteModelProfileMutationOptions(options));
};

/**
 * @summary Add a reference image to a model profile
 */
export const getAddModelReferenceImageUrl = (modelId: number) => {
  return `/api/v1/admin/models/${modelId}/images`;
};

export const addModelReferenceImage = async (
  modelId: number,
  addModelReferenceImageBody: AddModelReferenceImageBody,
  options?: RequestInit,
): Promise<ModelReferenceImage> => {
  return customFetch<ModelReferenceImage>(
    getAddModelReferenceImageUrl(modelId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(addModelReferenceImageBody),
    },
  );
};

export const getAddModelReferenceImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addModelReferenceImage>>,
    TError,
    { modelId: number; data: BodyType<AddModelReferenceImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addModelReferenceImage>>,
  TError,
  { modelId: number; data: BodyType<AddModelReferenceImageBody> },
  TContext
> => {
  const mutationKey = ["addModelReferenceImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addModelReferenceImage>>,
    { modelId: number; data: BodyType<AddModelReferenceImageBody> }
  > = (props) => {
    const { modelId, data } = props ?? {};

    return addModelReferenceImage(modelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddModelReferenceImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof addModelReferenceImage>>
>;
export type AddModelReferenceImageMutationBody =
  BodyType<AddModelReferenceImageBody>;
export type AddModelReferenceImageMutationError = ErrorType<unknown>;

/**
 * @summary Add a reference image to a model profile
 */
export const useAddModelReferenceImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addModelReferenceImage>>,
    TError,
    { modelId: number; data: BodyType<AddModelReferenceImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addModelReferenceImage>>,
  TError,
  { modelId: number; data: BodyType<AddModelReferenceImageBody> },
  TContext
> => {
  return useMutation(getAddModelReferenceImageMutationOptions(options));
};

/**
 * @summary Update a model reference image description
 */
export const getUpdateModelReferenceImageUrl = (
  modelId: number,
  imageId: number,
) => {
  return `/api/v1/admin/models/${modelId}/images/${imageId}`;
};

export const updateModelReferenceImage = async (
  modelId: number,
  imageId: number,
  updateModelReferenceImageBody: UpdateModelReferenceImageBody,
  options?: RequestInit,
): Promise<ModelReferenceImage> => {
  return customFetch<ModelReferenceImage>(
    getUpdateModelReferenceImageUrl(modelId, imageId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateModelReferenceImageBody),
    },
  );
};

export const getUpdateModelReferenceImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelReferenceImage>>,
    TError,
    {
      modelId: number;
      imageId: number;
      data: BodyType<UpdateModelReferenceImageBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModelReferenceImage>>,
  TError,
  {
    modelId: number;
    imageId: number;
    data: BodyType<UpdateModelReferenceImageBody>;
  },
  TContext
> => {
  const mutationKey = ["updateModelReferenceImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModelReferenceImage>>,
    {
      modelId: number;
      imageId: number;
      data: BodyType<UpdateModelReferenceImageBody>;
    }
  > = (props) => {
    const { modelId, imageId, data } = props ?? {};

    return updateModelReferenceImage(modelId, imageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelReferenceImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModelReferenceImage>>
>;
export type UpdateModelReferenceImageMutationBody =
  BodyType<UpdateModelReferenceImageBody>;
export type UpdateModelReferenceImageMutationError = ErrorType<unknown>;

/**
 * @summary Update a model reference image description
 */
export const useUpdateModelReferenceImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelReferenceImage>>,
    TError,
    {
      modelId: number;
      imageId: number;
      data: BodyType<UpdateModelReferenceImageBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModelReferenceImage>>,
  TError,
  {
    modelId: number;
    imageId: number;
    data: BodyType<UpdateModelReferenceImageBody>;
  },
  TContext
> => {
  return useMutation(getUpdateModelReferenceImageMutationOptions(options));
};

/**
 * @summary Delete a model reference image
 */
export const getDeleteModelReferenceImageUrl = (
  modelId: number,
  imageId: number,
) => {
  return `/api/v1/admin/models/${modelId}/images/${imageId}`;
};

export const deleteModelReferenceImage = async (
  modelId: number,
  imageId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteModelReferenceImageUrl(modelId, imageId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteModelReferenceImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelReferenceImage>>,
    TError,
    { modelId: number; imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModelReferenceImage>>,
  TError,
  { modelId: number; imageId: number },
  TContext
> => {
  const mutationKey = ["deleteModelReferenceImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModelReferenceImage>>,
    { modelId: number; imageId: number }
  > = (props) => {
    const { modelId, imageId } = props ?? {};

    return deleteModelReferenceImage(modelId, imageId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelReferenceImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModelReferenceImage>>
>;

export type DeleteModelReferenceImageMutationError = ErrorType<unknown>;

/**
 * @summary Delete a model reference image
 */
export const useDeleteModelReferenceImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelReferenceImage>>,
    TError,
    { modelId: number; imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModelReferenceImage>>,
  TError,
  { modelId: number; imageId: number },
  TContext
> => {
  return useMutation(getDeleteModelReferenceImageMutationOptions(options));
};

/**
 * @summary List users (paginated, optionally filtered by email substring)
 */
export const getListUsersUrl = (params?: ListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/users?${stringifiedParams}`
    : `/api/v1/admin/users`;
};

export const listUsers = async (
  params?: ListUsersParams,
  options?: RequestInit,
): Promise<ListUsers200> => {
  return customFetch<ListUsers200>(getListUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListUsersQueryKey = (params?: ListUsersParams) => {
  return [`/api/v1/admin/users`, ...(params ? [params] : [])] as const;
};

export const getListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listUsers>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({
    signal,
  }) => listUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsers>>
>;
export type ListUsersQueryError = ErrorType<unknown>;

/**
 * @summary List users (paginated, optionally filtered by email substring)
 */

export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listUsers>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Pulls the user's subscription + active subscription_schedules from
Stripe and replays the same handlers the webhook would have run
(subscription.updated + subscription_schedule.upserted). Idempotent
— when our mirror already matches Stripe, the response is
`{ ok: true, changed: false }`. Any repaired mirror drift is
audited to `plan_admin_actions` for the operator.

 * @summary Replay live Stripe state for one user (Task
 */
export const getRefreshUserStripeUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/refresh-stripe`;
};

export const refreshUserStripe = async (
  id: number,
  options?: RequestInit,
): Promise<RefreshUserStripe200> => {
  return customFetch<RefreshUserStripe200>(getRefreshUserStripeUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRefreshUserStripeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshUserStripe>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshUserStripe>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["refreshUserStripe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshUserStripe>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return refreshUserStripe(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshUserStripeMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshUserStripe>>
>;

export type RefreshUserStripeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Replay live Stripe state for one user (Task
 */
export const useRefreshUserStripe = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshUserStripe>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshUserStripe>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRefreshUserStripeMutationOptions(options));
};

/**
 * @summary Update user settings (admin)
 */
export const getUpdateUserUrl = (id: number) => {
  return `/api/v1/admin/users/${id}`;
};

export const updateUser = async (
  id: number,
  updateUserBody: UpdateUserBody,
  options?: RequestInit,
): Promise<UserAdmin> => {
  return customFetch<UserAdmin>(getUpdateUserUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserBody),
  });
};

export const getUpdateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: number; data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: number; data: BodyType<UpdateUserBody> },
  TContext
> => {
  const mutationKey = ["updateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUser>>,
    { id: number; data: BodyType<UpdateUserBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUser>>
>;
export type UpdateUserMutationBody = BodyType<UpdateUserBody>;
export type UpdateUserMutationError = ErrorType<unknown>;

/**
 * @summary Update user settings (admin)
 */
export const useUpdateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: number; data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: number; data: BodyType<UpdateUserBody> },
  TContext
> => {
  return useMutation(getUpdateUserMutationOptions(options));
};

/**
 * @summary Delete a user
 */
export const getDeleteUserUrl = (id: number) => {
  return `/api/v1/admin/users/${id}`;
};

export const deleteUser = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteUserUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteUser(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = ErrorType<unknown>;

/**
 * @summary Delete a user
 */
export const useDeleteUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteUserMutationOptions(options));
};

/**
 * @summary List all admin plans
 */
export const getListPlansUrl = () => {
  return `/api/v1/admin/plans`;
};

export const listPlans = async (
  options?: RequestInit,
): Promise<AdminPlan[]> => {
  return customFetch<AdminPlan[]>(getListPlansUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPlansQueryKey = () => {
  return [`/api/v1/admin/plans`] as const;
};

export const getListPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof listPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPlansQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlans>>> = ({
    signal,
  }) => listPlans({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPlans>>
>;
export type ListPlansQueryError = ErrorType<unknown>;

/**
 * @summary List all admin plans
 */

export function useListPlans<
  TData = Awaited<ReturnType<typeof listPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPlansQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Invite a new user
 */
export const getInviteUserUrl = () => {
  return `/api/v1/admin/users/invite`;
};

export const inviteUser = async (
  inviteUserBody: InviteUserBody,
  options?: RequestInit,
): Promise<InvitationResponse> => {
  return customFetch<InvitationResponse>(getInviteUserUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteUserBody),
  });
};

export const getInviteUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteUser>>,
    TError,
    { data: BodyType<InviteUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  { data: BodyType<InviteUserBody> },
  TContext
> => {
  const mutationKey = ["inviteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteUser>>,
    { data: BodyType<InviteUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return inviteUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteUser>>
>;
export type InviteUserMutationBody = BodyType<InviteUserBody>;
export type InviteUserMutationError = ErrorType<unknown>;

/**
 * @summary Invite a new user
 */
export const useInviteUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteUser>>,
    TError,
    { data: BodyType<InviteUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  { data: BodyType<InviteUserBody> },
  TContext
> => {
  return useMutation(getInviteUserMutationOptions(options));
};

/**
 * @summary Invite a new admin via magic-link email
 */
export const getInviteAdminUrl = () => {
  return `/api/v1/admin/users/invite-admin`;
};

export const inviteAdmin = async (
  inviteAdminBody: InviteAdminBody,
  options?: RequestInit,
): Promise<MagicLinkInvitationResponse> => {
  return customFetch<MagicLinkInvitationResponse>(getInviteAdminUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteAdminBody),
  });
};

export const getInviteAdminMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteAdmin>>,
    TError,
    { data: BodyType<InviteAdminBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteAdmin>>,
  TError,
  { data: BodyType<InviteAdminBody> },
  TContext
> => {
  const mutationKey = ["inviteAdmin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteAdmin>>,
    { data: BodyType<InviteAdminBody> }
  > = (props) => {
    const { data } = props ?? {};

    return inviteAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteAdmin>>
>;
export type InviteAdminMutationBody = BodyType<InviteAdminBody>;
export type InviteAdminMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Invite a new admin via magic-link email
 */
export const useInviteAdmin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteAdmin>>,
    TError,
    { data: BodyType<InviteAdminBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteAdmin>>,
  TError,
  { data: BodyType<InviteAdminBody> },
  TContext
> => {
  return useMutation(getInviteAdminMutationOptions(options));
};

/**
 * @summary Invite a new complimentary user via magic-link email
 */
export const getInviteComplimentaryUrl = () => {
  return `/api/v1/admin/users/invite-complimentary`;
};

export const inviteComplimentary = async (
  inviteComplimentaryBody: InviteComplimentaryBody,
  options?: RequestInit,
): Promise<MagicLinkInvitationResponse> => {
  return customFetch<MagicLinkInvitationResponse>(getInviteComplimentaryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteComplimentaryBody),
  });
};

export const getInviteComplimentaryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteComplimentary>>,
    TError,
    { data: BodyType<InviteComplimentaryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteComplimentary>>,
  TError,
  { data: BodyType<InviteComplimentaryBody> },
  TContext
> => {
  const mutationKey = ["inviteComplimentary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteComplimentary>>,
    { data: BodyType<InviteComplimentaryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return inviteComplimentary(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteComplimentaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteComplimentary>>
>;
export type InviteComplimentaryMutationBody = BodyType<InviteComplimentaryBody>;
export type InviteComplimentaryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Invite a new complimentary user via magic-link email
 */
export const useInviteComplimentary = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteComplimentary>>,
    TError,
    { data: BodyType<InviteComplimentaryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteComplimentary>>,
  TError,
  { data: BodyType<InviteComplimentaryBody> },
  TContext
> => {
  return useMutation(getInviteComplimentaryMutationOptions(options));
};

/**
 * @summary Assign or change a user's plan
 */
export const getAssignPlanUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/plan`;
};

export const assignPlan = async (
  id: number,
  assignPlanBody: AssignPlanBody,
  options?: RequestInit,
): Promise<UserPlan> => {
  return customFetch<UserPlan>(getAssignPlanUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignPlanBody),
  });
};

export const getAssignPlanMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPlan>>,
    TError,
    { id: number; data: BodyType<AssignPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignPlan>>,
  TError,
  { id: number; data: BodyType<AssignPlanBody> },
  TContext
> => {
  const mutationKey = ["assignPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignPlan>>,
    { id: number; data: BodyType<AssignPlanBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignPlan(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignPlan>>
>;
export type AssignPlanMutationBody = BodyType<AssignPlanBody>;
export type AssignPlanMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Assign or change a user's plan
 */
export const useAssignPlan = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPlan>>,
    TError,
    { id: number; data: BodyType<AssignPlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignPlan>>,
  TError,
  { id: number; data: BodyType<AssignPlanBody> },
  TContext
> => {
  return useMutation(getAssignPlanMutationOptions(options));
};

/**
 * @summary List pending invitations
 */
export const getListInvitationsUrl = () => {
  return `/api/v1/admin/invitations`;
};

export const listInvitations = async (
  options?: RequestInit,
): Promise<PendingInvitation[]> => {
  return customFetch<PendingInvitation[]>(getListInvitationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListInvitationsQueryKey = () => {
  return [`/api/v1/admin/invitations`] as const;
};

export const getListInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvitations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listInvitations>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvitationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvitations>>> = ({
    signal,
  }) => listInvitations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvitations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvitationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvitations>>
>;
export type ListInvitationsQueryError = ErrorType<unknown>;

/**
 * @summary List pending invitations
 */

export function useListInvitations<
  TData = Awaited<ReturnType<typeof listInvitations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listInvitations>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvitationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a pending invitation
 */
export const getDeleteInvitationUrl = (id: number) => {
  return `/api/v1/admin/invitations/${id}`;
};

export const deleteInvitation = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInvitationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInvitationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInvitation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInvitation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInvitation>>
>;

export type DeleteInvitationMutationError = ErrorType<unknown>;

/**
 * @summary Delete a pending invitation
 */
export const useDeleteInvitation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInvitationMutationOptions(options));
};

/**
 * @summary Resend a pending invitation with a new token
 */
export const getResendInvitationUrl = (id: number) => {
  return `/api/v1/admin/invitations/${id}/resend`;
};

export const resendInvitation = async (
  id: number,
  options?: RequestInit,
): Promise<InvitationResponse> => {
  return customFetch<InvitationResponse>(getResendInvitationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResendInvitationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["resendInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendInvitation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return resendInvitation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendInvitation>>
>;

export type ResendInvitationMutationError = ErrorType<unknown>;

/**
 * @summary Resend a pending invitation with a new token
 */
export const useResendInvitation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getResendInvitationMutationOptions(options));
};

/**
 * @summary Grant or update complimentary access for a user
 */
export const getGrantComplimentaryUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/complimentary`;
};

export const grantComplimentary = async (
  id: number,
  grantComplimentaryBody: GrantComplimentaryBody,
  options?: RequestInit,
): Promise<GrantComplimentaryResponse> => {
  return customFetch<GrantComplimentaryResponse>(getGrantComplimentaryUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(grantComplimentaryBody),
  });
};

export const getGrantComplimentaryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantComplimentary>>,
    TError,
    { id: number; data: BodyType<GrantComplimentaryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantComplimentary>>,
  TError,
  { id: number; data: BodyType<GrantComplimentaryBody> },
  TContext
> => {
  const mutationKey = ["grantComplimentary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantComplimentary>>,
    { id: number; data: BodyType<GrantComplimentaryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return grantComplimentary(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantComplimentaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantComplimentary>>
>;
export type GrantComplimentaryMutationBody = BodyType<GrantComplimentaryBody>;
export type GrantComplimentaryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Grant or update complimentary access for a user
 */
export const useGrantComplimentary = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantComplimentary>>,
    TError,
    { id: number; data: BodyType<GrantComplimentaryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantComplimentary>>,
  TError,
  { id: number; data: BodyType<GrantComplimentaryBody> },
  TContext
> => {
  return useMutation(getGrantComplimentaryMutationOptions(options));
};

/**
 * @summary Revoke complimentary access for a user
 */
export const getRevokeComplimentaryUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/complimentary`;
};

export const revokeComplimentary = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRevokeComplimentaryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeComplimentaryMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeComplimentary>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeComplimentary>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeComplimentary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeComplimentary>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeComplimentary(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeComplimentaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeComplimentary>>
>;

export type RevokeComplimentaryMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Revoke complimentary access for a user
 */
export const useRevokeComplimentary = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeComplimentary>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeComplimentary>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeComplimentaryMutationOptions(options));
};

/**
 * @summary Promote a user to the admin role
 */
export const getGrantAdminRoleUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/admin-role`;
};

export const grantAdminRole = async (
  id: number,
  grantAdminRoleBody: GrantAdminRoleBody,
  options?: RequestInit,
): Promise<GrantAdminRoleResponse> => {
  return customFetch<GrantAdminRoleResponse>(getGrantAdminRoleUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(grantAdminRoleBody),
  });
};

export const getGrantAdminRoleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAdminRole>>,
    TError,
    { id: number; data: BodyType<GrantAdminRoleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantAdminRole>>,
  TError,
  { id: number; data: BodyType<GrantAdminRoleBody> },
  TContext
> => {
  const mutationKey = ["grantAdminRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantAdminRole>>,
    { id: number; data: BodyType<GrantAdminRoleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return grantAdminRole(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantAdminRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantAdminRole>>
>;
export type GrantAdminRoleMutationBody = BodyType<GrantAdminRoleBody>;
export type GrantAdminRoleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Promote a user to the admin role
 */
export const useGrantAdminRole = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAdminRole>>,
    TError,
    { id: number; data: BodyType<GrantAdminRoleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantAdminRole>>,
  TError,
  { id: number; data: BodyType<GrantAdminRoleBody> },
  TContext
> => {
  return useMutation(getGrantAdminRoleMutationOptions(options));
};

/**
 * @summary Demote a user from the admin role
 */
export const getRevokeAdminRoleUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/admin-role`;
};

export const revokeAdminRole = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRevokeAdminRoleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeAdminRoleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAdminRole>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeAdminRole>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeAdminRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeAdminRole>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeAdminRole(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeAdminRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeAdminRole>>
>;

export type RevokeAdminRoleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Demote a user from the admin role
 */
export const useRevokeAdminRole = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAdminRole>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeAdminRole>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeAdminRoleMutationOptions(options));
};

/**
 * @summary List a user's recorded legal-document consents (admin)
 */
export const getAdminListUserConsentsUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/consents`;
};

export const adminListUserConsents = async (
  id: number,
  options?: RequestInit,
): Promise<UserConsentList> => {
  return customFetch<UserConsentList>(getAdminListUserConsentsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getAdminListUserConsentsQueryKey = (id: number) => {
  return [`/api/v1/admin/users/${id}/consents`] as const;
};

export const getAdminListUserConsentsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUserConsents>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserConsents>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListUserConsentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListUserConsents>>
  > = ({ signal }) => adminListUserConsents(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUserConsents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListUserConsentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListUserConsents>>
>;
export type AdminListUserConsentsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List a user's recorded legal-document consents (admin)
 */

export function useAdminListUserConsents<
  TData = Awaited<ReturnType<typeof adminListUserConsents>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserConsents>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListUserConsentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List a user's recent plan changes (admin, newest first)
 */
export const getAdminListUserPlanChangesUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/plan-changes`;
};

export const adminListUserPlanChanges = async (
  id: number,
  options?: RequestInit,
): Promise<AdminPlanChangeEventList> => {
  return customFetch<AdminPlanChangeEventList>(
    getAdminListUserPlanChangesUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListUserPlanChangesQueryKey = (id: number) => {
  return [`/api/v1/admin/users/${id}/plan-changes`] as const;
};

export const getAdminListUserPlanChangesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUserPlanChanges>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserPlanChanges>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListUserPlanChangesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListUserPlanChanges>>
  > = ({ signal }) =>
    adminListUserPlanChanges(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUserPlanChanges>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListUserPlanChangesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListUserPlanChanges>>
>;
export type AdminListUserPlanChangesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List a user's recent plan changes (admin, newest first)
 */

export function useAdminListUserPlanChanges<
  TData = Awaited<ReturnType<typeof adminListUserPlanChanges>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserPlanChanges>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListUserPlanChangesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all photoshoots for a user (admin view, includes all images with status)
 */
export const getAdminListUserPhotoshootsUrl = (id: number) => {
  return `/api/v1/admin/users/${id}/photoshoots`;
};

export const adminListUserPhotoshoots = async (
  id: number,
  options?: RequestInit,
): Promise<AdminUserPhotoshoot[]> => {
  return customFetch<AdminUserPhotoshoot[]>(
    getAdminListUserPhotoshootsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListUserPhotoshootsQueryKey = (id: number) => {
  return [`/api/v1/admin/users/${id}/photoshoots`] as const;
};

export const getAdminListUserPhotoshootsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUserPhotoshoots>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserPhotoshoots>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListUserPhotoshootsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListUserPhotoshoots>>
  > = ({ signal }) =>
    adminListUserPhotoshoots(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUserPhotoshoots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListUserPhotoshootsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListUserPhotoshoots>>
>;
export type AdminListUserPhotoshootsQueryError = ErrorType<unknown>;

/**
 * @summary List all photoshoots for a user (admin view, includes all images with status)
 */

export function useAdminListUserPhotoshoots<
  TData = Awaited<ReturnType<typeof adminListUserPhotoshoots>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserPhotoshoots>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListUserPhotoshootsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List a user's generated images (paginated, newest first)
 */
export const getAdminListUserGeneratedImagesUrl = (
  id: number,
  params?: AdminListUserGeneratedImagesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/users/${id}/generated-images?${stringifiedParams}`
    : `/api/v1/admin/users/${id}/generated-images`;
};

export const adminListUserGeneratedImages = async (
  id: number,
  params?: AdminListUserGeneratedImagesParams,
  options?: RequestInit,
): Promise<AdminListUserGeneratedImages200> => {
  return customFetch<AdminListUserGeneratedImages200>(
    getAdminListUserGeneratedImagesUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListUserGeneratedImagesQueryKey = (
  id: number,
  params?: AdminListUserGeneratedImagesParams,
) => {
  return [
    `/api/v1/admin/users/${id}/generated-images`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminListUserGeneratedImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUserGeneratedImages>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: AdminListUserGeneratedImagesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserGeneratedImages>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminListUserGeneratedImagesQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListUserGeneratedImages>>
  > = ({ signal }) =>
    adminListUserGeneratedImages(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUserGeneratedImages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListUserGeneratedImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListUserGeneratedImages>>
>;
export type AdminListUserGeneratedImagesQueryError = ErrorType<unknown>;

/**
 * @summary List a user's generated images (paginated, newest first)
 */

export function useAdminListUserGeneratedImages<
  TData = Awaited<ReturnType<typeof adminListUserGeneratedImages>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: AdminListUserGeneratedImagesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListUserGeneratedImages>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListUserGeneratedImagesQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all versions of a legal document type (newest first)
 */
export const getAdminListLegalDocumentVersionsUrl = (type: LegalDocType) => {
  return `/api/v1/admin/legal-documents/${type}`;
};

export const adminListLegalDocumentVersions = async (
  type: LegalDocType,
  options?: RequestInit,
): Promise<LegalDocument[]> => {
  return customFetch<LegalDocument[]>(
    getAdminListLegalDocumentVersionsUrl(type),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListLegalDocumentVersionsQueryKey = (
  type: LegalDocType,
) => {
  return [`/api/v1/admin/legal-documents/${type}`] as const;
};

export const getAdminListLegalDocumentVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListLegalDocumentVersions>>,
  TError = ErrorType<ErrorResponse>,
>(
  type: LegalDocType,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListLegalDocumentVersions>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListLegalDocumentVersionsQueryKey(type);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListLegalDocumentVersions>>
  > = ({ signal }) =>
    adminListLegalDocumentVersions(type, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!type,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListLegalDocumentVersions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListLegalDocumentVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListLegalDocumentVersions>>
>;
export type AdminListLegalDocumentVersionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all versions of a legal document type (newest first)
 */

export function useAdminListLegalDocumentVersions<
  TData = Awaited<ReturnType<typeof adminListLegalDocumentVersions>>,
  TError = ErrorType<ErrorResponse>,
>(
  type: LegalDocType,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminListLegalDocumentVersions>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListLegalDocumentVersionsQueryOptions(
    type,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new (initially inactive) version of a legal document
 */
export const getAdminCreateLegalDocumentVersionUrl = (type: LegalDocType) => {
  return `/api/v1/admin/legal-documents/${type}`;
};

export const adminCreateLegalDocumentVersion = async (
  type: LegalDocType,
  createLegalDocumentBody: CreateLegalDocumentBody,
  options?: RequestInit,
): Promise<LegalDocument> => {
  return customFetch<LegalDocument>(
    getAdminCreateLegalDocumentVersionUrl(type),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createLegalDocumentBody),
    },
  );
};

export const getAdminCreateLegalDocumentVersionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
    TError,
    { type: LegalDocType; data: BodyType<CreateLegalDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
  TError,
  { type: LegalDocType; data: BodyType<CreateLegalDocumentBody> },
  TContext
> => {
  const mutationKey = ["adminCreateLegalDocumentVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
    { type: LegalDocType; data: BodyType<CreateLegalDocumentBody> }
  > = (props) => {
    const { type, data } = props ?? {};

    return adminCreateLegalDocumentVersion(type, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateLegalDocumentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>
>;
export type AdminCreateLegalDocumentVersionMutationBody =
  BodyType<CreateLegalDocumentBody>;
export type AdminCreateLegalDocumentVersionMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Create a new (initially inactive) version of a legal document
 */
export const useAdminCreateLegalDocumentVersion = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
    TError,
    { type: LegalDocType; data: BodyType<CreateLegalDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
  TError,
  { type: LegalDocType; data: BodyType<CreateLegalDocumentBody> },
  TContext
> => {
  return useMutation(
    getAdminCreateLegalDocumentVersionMutationOptions(options),
  );
};

/**
 * @summary Get a single legal document version
 */
export const getAdminGetLegalDocumentVersionUrl = (
  type: LegalDocType,
  id: number,
) => {
  return `/api/v1/admin/legal-documents/${type}/${id}`;
};

export const adminGetLegalDocumentVersion = async (
  type: LegalDocType,
  id: number,
  options?: RequestInit,
): Promise<LegalDocument> => {
  return customFetch<LegalDocument>(
    getAdminGetLegalDocumentVersionUrl(type, id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetLegalDocumentVersionQueryKey = (
  type: LegalDocType,
  id: number,
) => {
  return [`/api/v1/admin/legal-documents/${type}/${id}`] as const;
};

export const getAdminGetLegalDocumentVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
  TError = ErrorType<ErrorResponse>,
>(
  type: LegalDocType,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetLegalDocumentVersionQueryKey(type, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>
  > = ({ signal }) =>
    adminGetLegalDocumentVersion(type, id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(type && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetLegalDocumentVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>
>;
export type AdminGetLegalDocumentVersionQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a single legal document version
 */

export function useAdminGetLegalDocumentVersion<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
  TError = ErrorType<ErrorResponse>,
>(
  type: LegalDocType,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetLegalDocumentVersionQueryOptions(
    type,
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a legal document version as the active (public) one for its type
 */
export const getAdminActivateLegalDocumentVersionUrl = (
  type: LegalDocType,
  id: number,
) => {
  return `/api/v1/admin/legal-documents/${type}/${id}/activate`;
};

export const adminActivateLegalDocumentVersion = async (
  type: LegalDocType,
  id: number,
  options?: RequestInit,
): Promise<LegalDocument> => {
  return customFetch<LegalDocument>(
    getAdminActivateLegalDocumentVersionUrl(type, id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAdminActivateLegalDocumentVersionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
    TError,
    { type: LegalDocType; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
  TError,
  { type: LegalDocType; id: number },
  TContext
> => {
  const mutationKey = ["adminActivateLegalDocumentVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
    { type: LegalDocType; id: number }
  > = (props) => {
    const { type, id } = props ?? {};

    return adminActivateLegalDocumentVersion(type, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminActivateLegalDocumentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>
>;

export type AdminActivateLegalDocumentVersionMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Mark a legal document version as the active (public) one for its type
 */
export const useAdminActivateLegalDocumentVersion = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
    TError,
    { type: LegalDocType; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
  TError,
  { type: LegalDocType; id: number },
  TContext
> => {
  return useMutation(
    getAdminActivateLegalDocumentVersionMutationOptions(options),
  );
};

/**
 * @summary Count of users who have accepted this legal document version
 */
export const getAdminGetLegalDocumentAcceptanceCountUrl = (
  type: LegalDocType,
  id: number,
) => {
  return `/api/v1/admin/legal-documents/${type}/${id}/acceptance`;
};

export const adminGetLegalDocumentAcceptanceCount = async (
  type: LegalDocType,
  id: number,
  options?: RequestInit,
): Promise<LegalDocumentAcceptanceCount> => {
  return customFetch<LegalDocumentAcceptanceCount>(
    getAdminGetLegalDocumentAcceptanceCountUrl(type, id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetLegalDocumentAcceptanceCountQueryKey = (
  type: LegalDocType,
  id: number,
) => {
  return [`/api/v1/admin/legal-documents/${type}/${id}/acceptance`] as const;
};

export const getAdminGetLegalDocumentAcceptanceCountQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentAcceptanceCount>>,
  TError = ErrorType<ErrorResponse>,
>(
  type: LegalDocType,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetLegalDocumentAcceptanceCount>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminGetLegalDocumentAcceptanceCountQueryKey(type, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetLegalDocumentAcceptanceCount>>
  > = ({ signal }) =>
    adminGetLegalDocumentAcceptanceCount(type, id, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(type && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLegalDocumentAcceptanceCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetLegalDocumentAcceptanceCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetLegalDocumentAcceptanceCount>>
>;
export type AdminGetLegalDocumentAcceptanceCountQueryError =
  ErrorType<ErrorResponse>;

/**
 * @summary Count of users who have accepted this legal document version
 */

export function useAdminGetLegalDocumentAcceptanceCount<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentAcceptanceCount>>,
  TError = ErrorType<ErrorResponse>,
>(
  type: LegalDocType,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetLegalDocumentAcceptanceCount>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetLegalDocumentAcceptanceCountQueryOptions(
    type,
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List active legal-document versions the calling user has not yet accepted
 */
export const getGetMyLegalConsentStatusUrl = () => {
  return `/api/v1/me/legal-consent-status`;
};

export const getMyLegalConsentStatus = async (
  options?: RequestInit,
): Promise<LegalConsentStatus> => {
  return customFetch<LegalConsentStatus>(getGetMyLegalConsentStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyLegalConsentStatusQueryKey = () => {
  return [`/api/v1/me/legal-consent-status`] as const;
};

export const getGetMyLegalConsentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyLegalConsentStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getMyLegalConsentStatus>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyLegalConsentStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyLegalConsentStatus>>
  > = ({ signal }) => getMyLegalConsentStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyLegalConsentStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyLegalConsentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyLegalConsentStatus>>
>;
export type GetMyLegalConsentStatusQueryError = ErrorType<unknown>;

/**
 * @summary List active legal-document versions the calling user has not yet accepted
 */

export function useGetMyLegalConsentStatus<
  TData = Awaited<ReturnType<typeof getMyLegalConsentStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getMyLegalConsentStatus>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyLegalConsentStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record consent for one or more outstanding legal-document types
 */
export const getAcceptMyLegalConsentUrl = () => {
  return `/api/v1/me/legal-consent`;
};

export const acceptMyLegalConsent = async (
  acceptLegalConsentBody: AcceptLegalConsentBody,
  options?: RequestInit,
): Promise<AcceptLegalConsentResponse> => {
  return customFetch<AcceptLegalConsentResponse>(getAcceptMyLegalConsentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptLegalConsentBody),
  });
};

export const getAcceptMyLegalConsentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptMyLegalConsent>>,
    TError,
    { data: BodyType<AcceptLegalConsentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptMyLegalConsent>>,
  TError,
  { data: BodyType<AcceptLegalConsentBody> },
  TContext
> => {
  const mutationKey = ["acceptMyLegalConsent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptMyLegalConsent>>,
    { data: BodyType<AcceptLegalConsentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptMyLegalConsent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptMyLegalConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptMyLegalConsent>>
>;
export type AcceptMyLegalConsentMutationBody = BodyType<AcceptLegalConsentBody>;
export type AcceptMyLegalConsentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Record consent for one or more outstanding legal-document types
 */
export const useAcceptMyLegalConsent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptMyLegalConsent>>,
    TError,
    { data: BodyType<AcceptLegalConsentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptMyLegalConsent>>,
  TError,
  { data: BodyType<AcceptLegalConsentBody> },
  TContext
> => {
  return useMutation(getAcceptMyLegalConsentMutationOptions(options));
};

/**
 * @summary Mark the current user as having acknowledged the Responsible Use reminder
 */
export const getAcknowledgeResponsibleUseUrl = () => {
  return `/api/v1/me/responsible-use-acknowledgement`;
};

export const acknowledgeResponsibleUse = async (
  options?: RequestInit,
): Promise<ResponsibleUseAcknowledgementResponse> => {
  return customFetch<ResponsibleUseAcknowledgementResponse>(
    getAcknowledgeResponsibleUseUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAcknowledgeResponsibleUseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeResponsibleUse>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acknowledgeResponsibleUse>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["acknowledgeResponsibleUse"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeResponsibleUse>>,
    void
  > = () => {
    return acknowledgeResponsibleUse(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcknowledgeResponsibleUseMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgeResponsibleUse>>
>;

export type AcknowledgeResponsibleUseMutationError = ErrorType<unknown>;

/**
 * @summary Mark the current user as having acknowledged the Responsible Use reminder
 */
export const useAcknowledgeResponsibleUse = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeResponsibleUse>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acknowledgeResponsibleUse>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getAcknowledgeResponsibleUseMutationOptions(options));
};

/**
 * @summary List all model archetypes (active and soft-deleted)
 */
export const getListArchetypesUrl = () => {
  return `/api/v1/admin/archetypes`;
};

export const listArchetypes = async (
  options?: RequestInit,
): Promise<ModelArchetype[]> => {
  return customFetch<ModelArchetype[]>(getListArchetypesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListArchetypesQueryKey = () => {
  return [`/api/v1/admin/archetypes`] as const;
};

export const getListArchetypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listArchetypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listArchetypes>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListArchetypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listArchetypes>>> = ({
    signal,
  }) => listArchetypes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listArchetypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListArchetypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listArchetypes>>
>;
export type ListArchetypesQueryError = ErrorType<unknown>;

/**
 * @summary List all model archetypes (active and soft-deleted)
 */

export function useListArchetypes<
  TData = Awaited<ReturnType<typeof listArchetypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listArchetypes>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListArchetypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a model archetype
 */
export const getCreateArchetypeUrl = () => {
  return `/api/v1/admin/archetypes`;
};

export const createArchetype = async (
  createArchetypeBody: CreateArchetypeBody,
  options?: RequestInit,
): Promise<ModelArchetype> => {
  return customFetch<ModelArchetype>(getCreateArchetypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createArchetypeBody),
  });
};

export const getCreateArchetypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createArchetype>>,
    TError,
    { data: BodyType<CreateArchetypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createArchetype>>,
  TError,
  { data: BodyType<CreateArchetypeBody> },
  TContext
> => {
  const mutationKey = ["createArchetype"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createArchetype>>,
    { data: BodyType<CreateArchetypeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createArchetype(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateArchetypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createArchetype>>
>;
export type CreateArchetypeMutationBody = BodyType<CreateArchetypeBody>;
export type CreateArchetypeMutationError = ErrorType<unknown>;

/**
 * @summary Create a model archetype
 */
export const useCreateArchetype = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createArchetype>>,
    TError,
    { data: BodyType<CreateArchetypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createArchetype>>,
  TError,
  { data: BodyType<CreateArchetypeBody> },
  TContext
> => {
  return useMutation(getCreateArchetypeMutationOptions(options));
};

/**
 * @summary Update a model archetype
 */
export const getUpdateArchetypeUrl = (id: number) => {
  return `/api/v1/admin/archetypes/${id}`;
};

export const updateArchetype = async (
  id: number,
  updateArchetypeBody: UpdateArchetypeBody,
  options?: RequestInit,
): Promise<ModelArchetype> => {
  return customFetch<ModelArchetype>(getUpdateArchetypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateArchetypeBody),
  });
};

export const getUpdateArchetypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArchetype>>,
    TError,
    { id: number; data: BodyType<UpdateArchetypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateArchetype>>,
  TError,
  { id: number; data: BodyType<UpdateArchetypeBody> },
  TContext
> => {
  const mutationKey = ["updateArchetype"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateArchetype>>,
    { id: number; data: BodyType<UpdateArchetypeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateArchetype(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateArchetypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateArchetype>>
>;
export type UpdateArchetypeMutationBody = BodyType<UpdateArchetypeBody>;
export type UpdateArchetypeMutationError = ErrorType<unknown>;

/**
 * @summary Update a model archetype
 */
export const useUpdateArchetype = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArchetype>>,
    TError,
    { id: number; data: BodyType<UpdateArchetypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateArchetype>>,
  TError,
  { id: number; data: BodyType<UpdateArchetypeBody> },
  TContext
> => {
  return useMutation(getUpdateArchetypeMutationOptions(options));
};

/**
 * @summary Soft-delete a model archetype
 */
export const getDeleteArchetypeUrl = (id: number) => {
  return `/api/v1/admin/archetypes/${id}`;
};

export const deleteArchetype = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteArchetype200> => {
  return customFetch<DeleteArchetype200>(getDeleteArchetypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteArchetypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteArchetype>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteArchetype>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteArchetype"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteArchetype>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteArchetype(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteArchetypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteArchetype>>
>;

export type DeleteArchetypeMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete a model archetype
 */
export const useDeleteArchetype = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteArchetype>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteArchetype>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteArchetypeMutationOptions(options));
};

/**
 * @summary Restore a soft-deleted model archetype
 */
export const getRestoreArchetypeUrl = (id: number) => {
  return `/api/v1/admin/archetypes/${id}/restore`;
};

export const restoreArchetype = async (
  id: number,
  options?: RequestInit,
): Promise<ModelArchetype> => {
  return customFetch<ModelArchetype>(getRestoreArchetypeUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreArchetypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreArchetype>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreArchetype>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["restoreArchetype"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreArchetype>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return restoreArchetype(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreArchetypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreArchetype>>
>;

export type RestoreArchetypeMutationError = ErrorType<unknown>;

/**
 * @summary Restore a soft-deleted model archetype
 */
export const useRestoreArchetype = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreArchetype>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreArchetype>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRestoreArchetypeMutationOptions(options));
};

/**
 * @summary List active archetypes available to users (with public descriptions)
 */
export const getListActiveArchetypesUrl = () => {
  return `/api/v1/user/archetypes`;
};

export const listActiveArchetypes = async (
  options?: RequestInit,
): Promise<ListActiveArchetypes200Item[]> => {
  return customFetch<ListActiveArchetypes200Item[]>(
    getListActiveArchetypesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListActiveArchetypesQueryKey = () => {
  return [`/api/v1/user/archetypes`] as const;
};

export const getListActiveArchetypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveArchetypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveArchetypes>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveArchetypesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveArchetypes>>
  > = ({ signal }) => listActiveArchetypes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveArchetypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveArchetypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveArchetypes>>
>;
export type ListActiveArchetypesQueryError = ErrorType<unknown>;

/**
 * @summary List active archetypes available to users (with public descriptions)
 */

export function useListActiveArchetypes<
  TData = Awaited<ReturnType<typeof listActiveArchetypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveArchetypes>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveArchetypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all model ethnicities (active and soft-deleted)
 */
export const getListEthnicitiesUrl = () => {
  return `/api/v1/admin/ethnicities`;
};

export const listEthnicities = async (
  options?: RequestInit,
): Promise<ModelEthnicity[]> => {
  return customFetch<ModelEthnicity[]>(getListEthnicitiesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListEthnicitiesQueryKey = () => {
  return [`/api/v1/admin/ethnicities`] as const;
};

export const getListEthnicitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEthnicities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listEthnicities>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEthnicitiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEthnicities>>> = ({
    signal,
  }) => listEthnicities({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEthnicities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEthnicitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEthnicities>>
>;
export type ListEthnicitiesQueryError = ErrorType<unknown>;

/**
 * @summary List all model ethnicities (active and soft-deleted)
 */

export function useListEthnicities<
  TData = Awaited<ReturnType<typeof listEthnicities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listEthnicities>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEthnicitiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a model ethnicity
 */
export const getCreateEthnicityUrl = () => {
  return `/api/v1/admin/ethnicities`;
};

export const createEthnicity = async (
  createEthnicityBody: CreateEthnicityBody,
  options?: RequestInit,
): Promise<ModelEthnicity> => {
  return customFetch<ModelEthnicity>(getCreateEthnicityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createEthnicityBody),
  });
};

export const getCreateEthnicityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEthnicity>>,
    TError,
    { data: BodyType<CreateEthnicityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEthnicity>>,
  TError,
  { data: BodyType<CreateEthnicityBody> },
  TContext
> => {
  const mutationKey = ["createEthnicity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEthnicity>>,
    { data: BodyType<CreateEthnicityBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createEthnicity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEthnicityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEthnicity>>
>;
export type CreateEthnicityMutationBody = BodyType<CreateEthnicityBody>;
export type CreateEthnicityMutationError = ErrorType<unknown>;

/**
 * @summary Create a model ethnicity
 */
export const useCreateEthnicity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEthnicity>>,
    TError,
    { data: BodyType<CreateEthnicityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEthnicity>>,
  TError,
  { data: BodyType<CreateEthnicityBody> },
  TContext
> => {
  return useMutation(getCreateEthnicityMutationOptions(options));
};

/**
 * @summary Update a model ethnicity
 */
export const getUpdateEthnicityUrl = (id: number) => {
  return `/api/v1/admin/ethnicities/${id}`;
};

export const updateEthnicity = async (
  id: number,
  updateEthnicityBody: UpdateEthnicityBody,
  options?: RequestInit,
): Promise<ModelEthnicity> => {
  return customFetch<ModelEthnicity>(getUpdateEthnicityUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEthnicityBody),
  });
};

export const getUpdateEthnicityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEthnicity>>,
    TError,
    { id: number; data: BodyType<UpdateEthnicityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEthnicity>>,
  TError,
  { id: number; data: BodyType<UpdateEthnicityBody> },
  TContext
> => {
  const mutationKey = ["updateEthnicity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEthnicity>>,
    { id: number; data: BodyType<UpdateEthnicityBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEthnicity(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEthnicityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEthnicity>>
>;
export type UpdateEthnicityMutationBody = BodyType<UpdateEthnicityBody>;
export type UpdateEthnicityMutationError = ErrorType<unknown>;

/**
 * @summary Update a model ethnicity
 */
export const useUpdateEthnicity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEthnicity>>,
    TError,
    { id: number; data: BodyType<UpdateEthnicityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEthnicity>>,
  TError,
  { id: number; data: BodyType<UpdateEthnicityBody> },
  TContext
> => {
  return useMutation(getUpdateEthnicityMutationOptions(options));
};

/**
 * @summary Soft-delete a model ethnicity
 */
export const getDeleteEthnicityUrl = (id: number) => {
  return `/api/v1/admin/ethnicities/${id}`;
};

export const deleteEthnicity = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteEthnicity200> => {
  return customFetch<DeleteEthnicity200>(getDeleteEthnicityUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteEthnicityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEthnicity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEthnicity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteEthnicity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEthnicity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEthnicity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEthnicityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEthnicity>>
>;

export type DeleteEthnicityMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete a model ethnicity
 */
export const useDeleteEthnicity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEthnicity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEthnicity>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteEthnicityMutationOptions(options));
};

/**
 * @summary Restore a soft-deleted model ethnicity
 */
export const getRestoreEthnicityUrl = (id: number) => {
  return `/api/v1/admin/ethnicities/${id}/restore`;
};

export const restoreEthnicity = async (
  id: number,
  options?: RequestInit,
): Promise<ModelEthnicity> => {
  return customFetch<ModelEthnicity>(getRestoreEthnicityUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreEthnicityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEthnicity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreEthnicity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["restoreEthnicity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreEthnicity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return restoreEthnicity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreEthnicityMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreEthnicity>>
>;

export type RestoreEthnicityMutationError = ErrorType<unknown>;

/**
 * @summary Restore a soft-deleted model ethnicity
 */
export const useRestoreEthnicity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEthnicity>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreEthnicity>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRestoreEthnicityMutationOptions(options));
};

/**
 * @summary List active ethnicities available to users for the model creation dialog
 */
export const getListActiveEthnicitiesUrl = () => {
  return `/api/v1/user/ethnicities`;
};

export const listActiveEthnicities = async (
  options?: RequestInit,
): Promise<ListActiveEthnicities200Item[]> => {
  return customFetch<ListActiveEthnicities200Item[]>(
    getListActiveEthnicitiesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListActiveEthnicitiesQueryKey = () => {
  return [`/api/v1/user/ethnicities`] as const;
};

export const getListActiveEthnicitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveEthnicities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveEthnicities>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveEthnicitiesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveEthnicities>>
  > = ({ signal }) => listActiveEthnicities({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveEthnicities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveEthnicitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveEthnicities>>
>;
export type ListActiveEthnicitiesQueryError = ErrorType<unknown>;

/**
 * @summary List active ethnicities available to users for the model creation dialog
 */

export function useListActiveEthnicities<
  TData = Awaited<ReturnType<typeof listActiveEthnicities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveEthnicities>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveEthnicitiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all model genders (active and soft-deleted)
 */
export const getListGendersUrl = () => {
  return `/api/v1/admin/genders`;
};

export const listGenders = async (
  options?: RequestInit,
): Promise<ModelGender[]> => {
  return customFetch<ModelGender[]>(getListGendersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListGendersQueryKey = () => {
  return [`/api/v1/admin/genders`] as const;
};

export const getListGendersQueryOptions = <
  TData = Awaited<ReturnType<typeof listGenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listGenders>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGendersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGenders>>> = ({
    signal,
  }) => listGenders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGenders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGendersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGenders>>
>;
export type ListGendersQueryError = ErrorType<unknown>;

/**
 * @summary List all model genders (active and soft-deleted)
 */

export function useListGenders<
  TData = Awaited<ReturnType<typeof listGenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listGenders>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGendersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a model gender
 */
export const getCreateGenderUrl = () => {
  return `/api/v1/admin/genders`;
};

export const createGender = async (
  createGenderBody: CreateGenderBody,
  options?: RequestInit,
): Promise<ModelGender> => {
  return customFetch<ModelGender>(getCreateGenderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createGenderBody),
  });
};

export const getCreateGenderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGender>>,
    TError,
    { data: BodyType<CreateGenderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGender>>,
  TError,
  { data: BodyType<CreateGenderBody> },
  TContext
> => {
  const mutationKey = ["createGender"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGender>>,
    { data: BodyType<CreateGenderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createGender(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGender>>
>;
export type CreateGenderMutationBody = BodyType<CreateGenderBody>;
export type CreateGenderMutationError = ErrorType<unknown>;

/**
 * @summary Create a model gender
 */
export const useCreateGender = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGender>>,
    TError,
    { data: BodyType<CreateGenderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGender>>,
  TError,
  { data: BodyType<CreateGenderBody> },
  TContext
> => {
  return useMutation(getCreateGenderMutationOptions(options));
};

/**
 * @summary Update a model gender
 */
export const getUpdateGenderUrl = (id: number) => {
  return `/api/v1/admin/genders/${id}`;
};

export const updateGender = async (
  id: number,
  updateGenderBody: UpdateGenderBody,
  options?: RequestInit,
): Promise<ModelGender> => {
  return customFetch<ModelGender>(getUpdateGenderUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateGenderBody),
  });
};

export const getUpdateGenderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGender>>,
    TError,
    { id: number; data: BodyType<UpdateGenderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGender>>,
  TError,
  { id: number; data: BodyType<UpdateGenderBody> },
  TContext
> => {
  const mutationKey = ["updateGender"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGender>>,
    { id: number; data: BodyType<UpdateGenderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGender(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGender>>
>;
export type UpdateGenderMutationBody = BodyType<UpdateGenderBody>;
export type UpdateGenderMutationError = ErrorType<unknown>;

/**
 * @summary Update a model gender
 */
export const useUpdateGender = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGender>>,
    TError,
    { id: number; data: BodyType<UpdateGenderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGender>>,
  TError,
  { id: number; data: BodyType<UpdateGenderBody> },
  TContext
> => {
  return useMutation(getUpdateGenderMutationOptions(options));
};

/**
 * @summary Soft-delete a model gender
 */
export const getDeleteGenderUrl = (id: number) => {
  return `/api/v1/admin/genders/${id}`;
};

export const deleteGender = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteGender200> => {
  return customFetch<DeleteGender200>(getDeleteGenderUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteGenderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGender>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGender>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteGender"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGender>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteGender(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGender>>
>;

export type DeleteGenderMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete a model gender
 */
export const useDeleteGender = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGender>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteGender>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteGenderMutationOptions(options));
};

/**
 * @summary Restore a soft-deleted model gender
 */
export const getRestoreGenderUrl = (id: number) => {
  return `/api/v1/admin/genders/${id}/restore`;
};

export const restoreGender = async (
  id: number,
  options?: RequestInit,
): Promise<ModelGender> => {
  return customFetch<ModelGender>(getRestoreGenderUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreGenderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreGender>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreGender>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["restoreGender"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreGender>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return restoreGender(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreGenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreGender>>
>;

export type RestoreGenderMutationError = ErrorType<unknown>;

/**
 * @summary Restore a soft-deleted model gender
 */
export const useRestoreGender = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreGender>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreGender>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRestoreGenderMutationOptions(options));
};

/**
 * @summary List active genders available to users for the model creation dialog
 */
export const getListActiveGendersUrl = () => {
  return `/api/v1/user/genders`;
};

export const listActiveGenders = async (
  options?: RequestInit,
): Promise<ListActiveGenders200Item[]> => {
  return customFetch<ListActiveGenders200Item[]>(getListActiveGendersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListActiveGendersQueryKey = () => {
  return [`/api/v1/user/genders`] as const;
};

export const getListActiveGendersQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveGenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveGenders>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveGendersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveGenders>>
  > = ({ signal }) => listActiveGenders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveGenders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveGendersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveGenders>>
>;
export type ListActiveGendersQueryError = ErrorType<unknown>;

/**
 * @summary List active genders available to users for the model creation dialog
 */

export function useListActiveGenders<
  TData = Awaited<ReturnType<typeof listActiveGenders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveGenders>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveGendersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all model age ranges (active and soft-deleted)
 */
export const getListAgeRangesUrl = () => {
  return `/api/v1/admin/age-ranges`;
};

export const listAgeRanges = async (
  options?: RequestInit,
): Promise<ModelAgeRange[]> => {
  return customFetch<ModelAgeRange[]>(getListAgeRangesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAgeRangesQueryKey = () => {
  return [`/api/v1/admin/age-ranges`] as const;
};

export const getListAgeRangesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAgeRanges>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listAgeRanges>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgeRangesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgeRanges>>> = ({
    signal,
  }) => listAgeRanges({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgeRanges>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAgeRangesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAgeRanges>>
>;
export type ListAgeRangesQueryError = ErrorType<unknown>;

/**
 * @summary List all model age ranges (active and soft-deleted)
 */

export function useListAgeRanges<
  TData = Awaited<ReturnType<typeof listAgeRanges>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listAgeRanges>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAgeRangesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a model age range
 */
export const getCreateAgeRangeUrl = () => {
  return `/api/v1/admin/age-ranges`;
};

export const createAgeRange = async (
  createAgeRangeBody: CreateAgeRangeBody,
  options?: RequestInit,
): Promise<ModelAgeRange> => {
  return customFetch<ModelAgeRange>(getCreateAgeRangeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAgeRangeBody),
  });
};

export const getCreateAgeRangeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgeRange>>,
    TError,
    { data: BodyType<CreateAgeRangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAgeRange>>,
  TError,
  { data: BodyType<CreateAgeRangeBody> },
  TContext
> => {
  const mutationKey = ["createAgeRange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAgeRange>>,
    { data: BodyType<CreateAgeRangeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAgeRange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAgeRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAgeRange>>
>;
export type CreateAgeRangeMutationBody = BodyType<CreateAgeRangeBody>;
export type CreateAgeRangeMutationError = ErrorType<unknown>;

/**
 * @summary Create a model age range
 */
export const useCreateAgeRange = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgeRange>>,
    TError,
    { data: BodyType<CreateAgeRangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAgeRange>>,
  TError,
  { data: BodyType<CreateAgeRangeBody> },
  TContext
> => {
  return useMutation(getCreateAgeRangeMutationOptions(options));
};

/**
 * @summary Update a model age range
 */
export const getUpdateAgeRangeUrl = (id: number) => {
  return `/api/v1/admin/age-ranges/${id}`;
};

export const updateAgeRange = async (
  id: number,
  updateAgeRangeBody: UpdateAgeRangeBody,
  options?: RequestInit,
): Promise<ModelAgeRange> => {
  return customFetch<ModelAgeRange>(getUpdateAgeRangeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAgeRangeBody),
  });
};

export const getUpdateAgeRangeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAgeRange>>,
    TError,
    { id: number; data: BodyType<UpdateAgeRangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAgeRange>>,
  TError,
  { id: number; data: BodyType<UpdateAgeRangeBody> },
  TContext
> => {
  const mutationKey = ["updateAgeRange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAgeRange>>,
    { id: number; data: BodyType<UpdateAgeRangeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAgeRange(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAgeRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAgeRange>>
>;
export type UpdateAgeRangeMutationBody = BodyType<UpdateAgeRangeBody>;
export type UpdateAgeRangeMutationError = ErrorType<unknown>;

/**
 * @summary Update a model age range
 */
export const useUpdateAgeRange = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAgeRange>>,
    TError,
    { id: number; data: BodyType<UpdateAgeRangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAgeRange>>,
  TError,
  { id: number; data: BodyType<UpdateAgeRangeBody> },
  TContext
> => {
  return useMutation(getUpdateAgeRangeMutationOptions(options));
};

/**
 * @summary Soft-delete a model age range
 */
export const getDeleteAgeRangeUrl = (id: number) => {
  return `/api/v1/admin/age-ranges/${id}`;
};

export const deleteAgeRange = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteAgeRange200> => {
  return customFetch<DeleteAgeRange200>(getDeleteAgeRangeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAgeRangeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgeRange>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgeRange>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAgeRange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgeRange>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAgeRange(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgeRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAgeRange>>
>;

export type DeleteAgeRangeMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete a model age range
 */
export const useDeleteAgeRange = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgeRange>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAgeRange>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAgeRangeMutationOptions(options));
};

/**
 * @summary Restore a soft-deleted model age range
 */
export const getRestoreAgeRangeUrl = (id: number) => {
  return `/api/v1/admin/age-ranges/${id}/restore`;
};

export const restoreAgeRange = async (
  id: number,
  options?: RequestInit,
): Promise<ModelAgeRange> => {
  return customFetch<ModelAgeRange>(getRestoreAgeRangeUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreAgeRangeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAgeRange>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAgeRange>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["restoreAgeRange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAgeRange>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return restoreAgeRange(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreAgeRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAgeRange>>
>;

export type RestoreAgeRangeMutationError = ErrorType<unknown>;

/**
 * @summary Restore a soft-deleted model age range
 */
export const useRestoreAgeRange = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAgeRange>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreAgeRange>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRestoreAgeRangeMutationOptions(options));
};

/**
 * @summary List active age ranges available to users for the model creation dialog
 */
export const getListActiveAgeRangesUrl = () => {
  return `/api/v1/user/age-ranges`;
};

export const listActiveAgeRanges = async (
  options?: RequestInit,
): Promise<ListActiveAgeRanges200Item[]> => {
  return customFetch<ListActiveAgeRanges200Item[]>(
    getListActiveAgeRangesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListActiveAgeRangesQueryKey = () => {
  return [`/api/v1/user/age-ranges`] as const;
};

export const getListActiveAgeRangesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveAgeRanges>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveAgeRanges>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveAgeRangesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveAgeRanges>>
  > = ({ signal }) => listActiveAgeRanges({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveAgeRanges>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveAgeRangesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveAgeRanges>>
>;
export type ListActiveAgeRangesQueryError = ErrorType<unknown>;

/**
 * @summary List active age ranges available to users for the model creation dialog
 */

export function useListActiveAgeRanges<
  TData = Awaited<ReturnType<typeof listActiveAgeRanges>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveAgeRanges>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveAgeRangesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all model body types (active and soft-deleted)
 */
export const getListBodyTypesUrl = () => {
  return `/api/v1/admin/body-types`;
};

export const listBodyTypes = async (
  options?: RequestInit,
): Promise<ModelBodyType[]> => {
  return customFetch<ModelBodyType[]>(getListBodyTypesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListBodyTypesQueryKey = () => {
  return [`/api/v1/admin/body-types`] as const;
};

export const getListBodyTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBodyTypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listBodyTypes>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBodyTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBodyTypes>>> = ({
    signal,
  }) => listBodyTypes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBodyTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBodyTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBodyTypes>>
>;
export type ListBodyTypesQueryError = ErrorType<unknown>;

/**
 * @summary List all model body types (active and soft-deleted)
 */

export function useListBodyTypes<
  TData = Awaited<ReturnType<typeof listBodyTypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listBodyTypes>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBodyTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a model body type
 */
export const getCreateBodyTypeUrl = () => {
  return `/api/v1/admin/body-types`;
};

export const createBodyType = async (
  createBodyTypeBody: CreateBodyTypeBody,
  options?: RequestInit,
): Promise<ModelBodyType> => {
  return customFetch<ModelBodyType>(getCreateBodyTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBodyTypeBody),
  });
};

export const getCreateBodyTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBodyType>>,
    TError,
    { data: BodyType<CreateBodyTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBodyType>>,
  TError,
  { data: BodyType<CreateBodyTypeBody> },
  TContext
> => {
  const mutationKey = ["createBodyType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBodyType>>,
    { data: BodyType<CreateBodyTypeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBodyType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBodyTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBodyType>>
>;
export type CreateBodyTypeMutationBody = BodyType<CreateBodyTypeBody>;
export type CreateBodyTypeMutationError = ErrorType<unknown>;

/**
 * @summary Create a model body type
 */
export const useCreateBodyType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBodyType>>,
    TError,
    { data: BodyType<CreateBodyTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBodyType>>,
  TError,
  { data: BodyType<CreateBodyTypeBody> },
  TContext
> => {
  return useMutation(getCreateBodyTypeMutationOptions(options));
};

/**
 * @summary Update a model body type
 */
export const getUpdateBodyTypeUrl = (id: number) => {
  return `/api/v1/admin/body-types/${id}`;
};

export const updateBodyType = async (
  id: number,
  updateBodyTypeBody: UpdateBodyTypeBody,
  options?: RequestInit,
): Promise<ModelBodyType> => {
  return customFetch<ModelBodyType>(getUpdateBodyTypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBodyTypeBody),
  });
};

export const getUpdateBodyTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBodyType>>,
    TError,
    { id: number; data: BodyType<UpdateBodyTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBodyType>>,
  TError,
  { id: number; data: BodyType<UpdateBodyTypeBody> },
  TContext
> => {
  const mutationKey = ["updateBodyType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBodyType>>,
    { id: number; data: BodyType<UpdateBodyTypeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBodyType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBodyTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBodyType>>
>;
export type UpdateBodyTypeMutationBody = BodyType<UpdateBodyTypeBody>;
export type UpdateBodyTypeMutationError = ErrorType<unknown>;

/**
 * @summary Update a model body type
 */
export const useUpdateBodyType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBodyType>>,
    TError,
    { id: number; data: BodyType<UpdateBodyTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBodyType>>,
  TError,
  { id: number; data: BodyType<UpdateBodyTypeBody> },
  TContext
> => {
  return useMutation(getUpdateBodyTypeMutationOptions(options));
};

/**
 * @summary Soft-delete a model body type
 */
export const getDeleteBodyTypeUrl = (id: number) => {
  return `/api/v1/admin/body-types/${id}`;
};

export const deleteBodyType = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteBodyType200> => {
  return customFetch<DeleteBodyType200>(getDeleteBodyTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBodyTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBodyType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBodyType>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteBodyType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBodyType>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBodyType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBodyTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBodyType>>
>;

export type DeleteBodyTypeMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete a model body type
 */
export const useDeleteBodyType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBodyType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBodyType>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteBodyTypeMutationOptions(options));
};

/**
 * @summary Restore a soft-deleted model body type
 */
export const getRestoreBodyTypeUrl = (id: number) => {
  return `/api/v1/admin/body-types/${id}/restore`;
};

export const restoreBodyType = async (
  id: number,
  options?: RequestInit,
): Promise<ModelBodyType> => {
  return customFetch<ModelBodyType>(getRestoreBodyTypeUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreBodyTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreBodyType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreBodyType>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["restoreBodyType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreBodyType>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return restoreBodyType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreBodyTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreBodyType>>
>;

export type RestoreBodyTypeMutationError = ErrorType<unknown>;

/**
 * @summary Restore a soft-deleted model body type
 */
export const useRestoreBodyType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreBodyType>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreBodyType>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRestoreBodyTypeMutationOptions(options));
};

/**
 * @summary List active body types available to users, filtered by the gender they have selected
 */
export const getListActiveBodyTypesUrl = (
  params?: ListActiveBodyTypesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/user/body-types?${stringifiedParams}`
    : `/api/v1/user/body-types`;
};

export const listActiveBodyTypes = async (
  params?: ListActiveBodyTypesParams,
  options?: RequestInit,
): Promise<ListActiveBodyTypes200Item[]> => {
  return customFetch<ListActiveBodyTypes200Item[]>(
    getListActiveBodyTypesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListActiveBodyTypesQueryKey = (
  params?: ListActiveBodyTypesParams,
) => {
  return [`/api/v1/user/body-types`, ...(params ? [params] : [])] as const;
};

export const getListActiveBodyTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveBodyTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListActiveBodyTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listActiveBodyTypes>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListActiveBodyTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveBodyTypes>>
  > = ({ signal }) =>
    listActiveBodyTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveBodyTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveBodyTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveBodyTypes>>
>;
export type ListActiveBodyTypesQueryError = ErrorType<unknown>;

/**
 * @summary List active body types available to users, filtered by the gender they have selected
 */

export function useListActiveBodyTypes<
  TData = Awaited<ReturnType<typeof listActiveBodyTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListActiveBodyTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listActiveBodyTypes>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveBodyTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all admin prompts
 */
export const getListPromptsUrl = () => {
  return `/api/v1/admin/prompts`;
};

export const listPrompts = async (
  options?: RequestInit,
): Promise<AdminPrompt[]> => {
  return customFetch<AdminPrompt[]>(getListPromptsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPromptsQueryKey = () => {
  return [`/api/v1/admin/prompts`] as const;
};

export const getListPromptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPrompts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listPrompts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPromptsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrompts>>> = ({
    signal,
  }) => listPrompts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPrompts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPromptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPrompts>>
>;
export type ListPromptsQueryError = ErrorType<unknown>;

/**
 * @summary List all admin prompts
 */

export function useListPrompts<
  TData = Awaited<ReturnType<typeof listPrompts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listPrompts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPromptsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an admin prompt
 */
export const getUpdatePromptUrl = (promptId: string) => {
  return `/api/v1/admin/prompts/${promptId}`;
};

export const updatePrompt = async (
  promptId: string,
  updatePromptBody: UpdatePromptBody,
  options?: RequestInit,
): Promise<AdminPrompt> => {
  return customFetch<AdminPrompt>(getUpdatePromptUrl(promptId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePromptBody),
  });
};

export const getUpdatePromptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePrompt>>,
    TError,
    { promptId: string; data: BodyType<UpdatePromptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePrompt>>,
  TError,
  { promptId: string; data: BodyType<UpdatePromptBody> },
  TContext
> => {
  const mutationKey = ["updatePrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePrompt>>,
    { promptId: string; data: BodyType<UpdatePromptBody> }
  > = (props) => {
    const { promptId, data } = props ?? {};

    return updatePrompt(promptId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePrompt>>
>;
export type UpdatePromptMutationBody = BodyType<UpdatePromptBody>;
export type UpdatePromptMutationError = ErrorType<unknown>;

/**
 * @summary Update an admin prompt
 */
export const useUpdatePrompt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePrompt>>,
    TError,
    { promptId: string; data: BodyType<UpdatePromptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePrompt>>,
  TError,
  { promptId: string; data: BodyType<UpdatePromptBody> },
  TContext
> => {
  return useMutation(getUpdatePromptMutationOptions(options));
};

/**
 * @summary Get all platform settings
 */
export const getGetSettingsUrl = () => {
  return `/api/v1/admin/settings`;
};

export const getSettings = async (
  options?: RequestInit,
): Promise<PlatformSettings> => {
  return customFetch<PlatformSettings>(getGetSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSettingsQueryKey = () => {
  return [`/api/v1/admin/settings`] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({
    signal,
  }) => getSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettings>>
>;
export type GetSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get all platform settings
 */

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update platform settings
 */
export const getUpdateSettingsUrl = () => {
  return `/api/v1/admin/settings`;
};

export const updateSettings = async (
  updateSettingsBody: UpdateSettingsBody,
  options?: RequestInit,
): Promise<PlatformSettings> => {
  return customFetch<PlatformSettings>(getUpdateSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSettingsBody),
  });
};

export const getUpdateSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: BodyType<UpdateSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: BodyType<UpdateSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSettings>>,
    { data: BodyType<UpdateSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSettings>>
>;
export type UpdateSettingsMutationBody = BodyType<UpdateSettingsBody>;
export type UpdateSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update platform settings
 */
export const useUpdateSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: BodyType<UpdateSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: BodyType<UpdateSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateSettingsMutationOptions(options));
};

/**
 * @summary Get available image generation models with visible names
 */
export const getGetImageModelsUrl = () => {
  return `/api/v1/settings/image-models`;
};

export const getImageModels = async (
  options?: RequestInit,
): Promise<ImageModelsResponse> => {
  return customFetch<ImageModelsResponse>(getGetImageModelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetImageModelsQueryKey = () => {
  return [`/api/v1/settings/image-models`] as const;
};

export const getGetImageModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getImageModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getImageModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImageModelsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImageModels>>> = ({
    signal,
  }) => getImageModels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getImageModels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImageModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImageModels>>
>;
export type GetImageModelsQueryError = ErrorType<unknown>;

/**
 * @summary Get available image generation models with visible names
 */

export function useGetImageModels<
  TData = Awaited<ReturnType<typeof getImageModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getImageModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetImageModelsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get enabled aspect ratios for photoshoots
 */
export const getGetEnabledAspectRatiosUrl = () => {
  return `/api/v1/settings/aspect-ratios`;
};

export const getEnabledAspectRatios = async (
  options?: RequestInit,
): Promise<GetEnabledAspectRatios200> => {
  return customFetch<GetEnabledAspectRatios200>(
    getGetEnabledAspectRatiosUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetEnabledAspectRatiosQueryKey = () => {
  return [`/api/v1/settings/aspect-ratios`] as const;
};

export const getGetEnabledAspectRatiosQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnabledAspectRatios>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getEnabledAspectRatios>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEnabledAspectRatiosQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEnabledAspectRatios>>
  > = ({ signal }) => getEnabledAspectRatios({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnabledAspectRatios>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnabledAspectRatiosQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnabledAspectRatios>>
>;
export type GetEnabledAspectRatiosQueryError = ErrorType<unknown>;

/**
 * @summary Get enabled aspect ratios for photoshoots
 */

export function useGetEnabledAspectRatios<
  TData = Awaited<ReturnType<typeof getEnabledAspectRatios>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getEnabledAspectRatios>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnabledAspectRatiosQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List audit logs with filters
 */
export const getListAuditLogsUrl = (params?: ListAuditLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/audit-logs?${stringifiedParams}`
    : `/api/v1/admin/audit-logs`;
};

export const listAuditLogs = async (
  params?: ListAuditLogsParams,
  options?: RequestInit,
): Promise<AuditLogListResponse> => {
  return customFetch<AuditLogListResponse>(getListAuditLogsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAuditLogsQueryKey = (params?: ListAuditLogsParams) => {
  return [`/api/v1/admin/audit-logs`, ...(params ? [params] : [])] as const;
};

export const getListAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLogs>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({
    signal,
  }) => listAuditLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuditLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuditLogs>>
>;
export type ListAuditLogsQueryError = ErrorType<unknown>;

/**
 * @summary List audit logs with filters
 */

export function useListAuditLogs<
  TData = Awaited<ReturnType<typeof listAuditLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLogs>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAuditLogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get audit-log retention settings (singleton)
 */
export const getGetAuditLogSettingsUrl = () => {
  return `/api/v1/admin/audit-log-settings`;
};

export const getAuditLogSettings = async (
  options?: RequestInit,
): Promise<AuditLogSettings> => {
  return customFetch<AuditLogSettings>(getGetAuditLogSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAuditLogSettingsQueryKey = () => {
  return [`/api/v1/admin/audit-log-settings`] as const;
};

export const getGetAuditLogSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuditLogSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAuditLogSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuditLogSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAuditLogSettings>>
  > = ({ signal }) => getAuditLogSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuditLogSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuditLogSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuditLogSettings>>
>;
export type GetAuditLogSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get audit-log retention settings (singleton)
 */

export function useGetAuditLogSettings<
  TData = Awaited<ReturnType<typeof getAuditLogSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAuditLogSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAuditLogSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update audit-log retention days (admin only)
 */
export const getUpdateAuditLogSettingsUrl = () => {
  return `/api/v1/admin/audit-log-settings`;
};

export const updateAuditLogSettings = async (
  updateAuditLogSettingsBody: UpdateAuditLogSettingsBody,
  options?: RequestInit,
): Promise<AuditLogSettings> => {
  return customFetch<AuditLogSettings>(getUpdateAuditLogSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAuditLogSettingsBody),
  });
};

export const getUpdateAuditLogSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAuditLogSettings>>,
    TError,
    { data: BodyType<UpdateAuditLogSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAuditLogSettings>>,
  TError,
  { data: BodyType<UpdateAuditLogSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateAuditLogSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAuditLogSettings>>,
    { data: BodyType<UpdateAuditLogSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateAuditLogSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAuditLogSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAuditLogSettings>>
>;
export type UpdateAuditLogSettingsMutationBody =
  BodyType<UpdateAuditLogSettingsBody>;
export type UpdateAuditLogSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update audit-log retention days (admin only)
 */
export const useUpdateAuditLogSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAuditLogSettings>>,
    TError,
    { data: BodyType<UpdateAuditLogSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAuditLogSettings>>,
  TError,
  { data: BodyType<UpdateAuditLogSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateAuditLogSettingsMutationOptions(options));
};

/**
 * @summary Restore an image previously sent to retention queue
 */
export const getRestoreAuditLogImageUrl = (logId: number) => {
  return `/api/v1/admin/audit-logs/${logId}/image/restore`;
};

export const restoreAuditLogImage = async (
  logId: number,
  auditLogImageActionBody: AuditLogImageActionBody,
  options?: RequestInit,
): Promise<RestoreAuditLogImageResponse> => {
  return customFetch<RestoreAuditLogImageResponse>(
    getRestoreAuditLogImageUrl(logId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(auditLogImageActionBody),
    },
  );
};

export const getRestoreAuditLogImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAuditLogImage>>,
    TError,
    { logId: number; data: BodyType<AuditLogImageActionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAuditLogImage>>,
  TError,
  { logId: number; data: BodyType<AuditLogImageActionBody> },
  TContext
> => {
  const mutationKey = ["restoreAuditLogImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAuditLogImage>>,
    { logId: number; data: BodyType<AuditLogImageActionBody> }
  > = (props) => {
    const { logId, data } = props ?? {};

    return restoreAuditLogImage(logId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreAuditLogImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAuditLogImage>>
>;
export type RestoreAuditLogImageMutationBody =
  BodyType<AuditLogImageActionBody>;
export type RestoreAuditLogImageMutationError = ErrorType<unknown>;

/**
 * @summary Restore an image previously sent to retention queue
 */
export const useRestoreAuditLogImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAuditLogImage>>,
    TError,
    { logId: number; data: BodyType<AuditLogImageActionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreAuditLogImage>>,
  TError,
  { logId: number; data: BodyType<AuditLogImageActionBody> },
  TContext
> => {
  return useMutation(getRestoreAuditLogImageMutationOptions(options));
};

/**
 * @summary Immediately purge an image from storage (bypass retention)
 */
export const getPermanentDeleteAuditLogImageUrl = (logId: number) => {
  return `/api/v1/admin/audit-logs/${logId}/image/permanent-delete`;
};

export const permanentDeleteAuditLogImage = async (
  logId: number,
  auditLogImageActionBody: AuditLogImageActionBody,
  options?: RequestInit,
): Promise<PermanentDeleteAuditLogImage200> => {
  return customFetch<PermanentDeleteAuditLogImage200>(
    getPermanentDeleteAuditLogImageUrl(logId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(auditLogImageActionBody),
    },
  );
};

export const getPermanentDeleteAuditLogImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof permanentDeleteAuditLogImage>>,
    TError,
    { logId: number; data: BodyType<AuditLogImageActionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof permanentDeleteAuditLogImage>>,
  TError,
  { logId: number; data: BodyType<AuditLogImageActionBody> },
  TContext
> => {
  const mutationKey = ["permanentDeleteAuditLogImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof permanentDeleteAuditLogImage>>,
    { logId: number; data: BodyType<AuditLogImageActionBody> }
  > = (props) => {
    const { logId, data } = props ?? {};

    return permanentDeleteAuditLogImage(logId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PermanentDeleteAuditLogImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof permanentDeleteAuditLogImage>>
>;
export type PermanentDeleteAuditLogImageMutationBody =
  BodyType<AuditLogImageActionBody>;
export type PermanentDeleteAuditLogImageMutationError = ErrorType<unknown>;

/**
 * @summary Immediately purge an image from storage (bypass retention)
 */
export const usePermanentDeleteAuditLogImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof permanentDeleteAuditLogImage>>,
    TError,
    { logId: number; data: BodyType<AuditLogImageActionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof permanentDeleteAuditLogImage>>,
  TError,
  { logId: number; data: BodyType<AuditLogImageActionBody> },
  TContext
> => {
  return useMutation(getPermanentDeleteAuditLogImageMutationOptions(options));
};

/**
 * @summary Request a presigned upload URL
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/v1/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  requestUploadUrlBody: RequestUploadUrlBody,
  options?: RequestInit,
): Promise<RequestUploadUrlResponse> => {
  return customFetch<RequestUploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestUploadUrlBody),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<RequestUploadUrlBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<RequestUploadUrlBody>;
export type RequestUploadUrlMutationError = ErrorType<unknown>;

/**
 * @summary Request a presigned upload URL
 */
export const useRequestUploadUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Finalize an uploaded object and set ACL
 */
export const getFinalizeUploadUrl = () => {
  return `/api/v1/storage/uploads/finalize`;
};

export const finalizeUpload = async (
  finalizeUploadBody: FinalizeUploadBody,
  options?: RequestInit,
): Promise<FinalizeUploadResponse> => {
  return customFetch<FinalizeUploadResponse>(getFinalizeUploadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(finalizeUploadBody),
  });
};

export const getFinalizeUploadMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeUpload>>,
    TError,
    { data: BodyType<FinalizeUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeUpload>>,
  TError,
  { data: BodyType<FinalizeUploadBody> },
  TContext
> => {
  const mutationKey = ["finalizeUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeUpload>>,
    { data: BodyType<FinalizeUploadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return finalizeUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeUpload>>
>;
export type FinalizeUploadMutationBody = BodyType<FinalizeUploadBody>;
export type FinalizeUploadMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Finalize an uploaded object and set ACL
 */
export const useFinalizeUpload = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeUpload>>,
    TError,
    { data: BodyType<FinalizeUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof finalizeUpload>>,
  TError,
  { data: BodyType<FinalizeUploadBody> },
  TContext
> => {
  return useMutation(getFinalizeUploadMutationOptions(options));
};

/**
 * @summary Get an authenticated object by path
 */
export const getGetObjectUrl = (path: string) => {
  return `/api/v1/storage/objects/${path}`;
};

export const getObject = async (
  path: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGetObjectUrl(path), {
    ...options,
    method: "GET",
  });
};

export const getGetObjectQueryKey = (path: string) => {
  return [`/api/v1/storage/objects/${path}`] as const;
};

export const getGetObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  path: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getObject>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetObjectQueryKey(path);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getObject>>> = ({
    signal,
  }) => getObject(path, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!path,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getObject>>
>;
export type GetObjectQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get an authenticated object by path
 */

export function useGetObject<
  TData = Awaited<ReturnType<typeof getObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  path: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getObject>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetObjectQueryOptions(path, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a public object by path
 */
export const getGetPublicObjectUrl = (filePath: string) => {
  return `/api/v1/storage/public-objects/${filePath}`;
};

export const getPublicObject = async (
  filePath: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGetPublicObjectUrl(filePath), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicObjectQueryKey = (filePath: string) => {
  return [`/api/v1/storage/public-objects/${filePath}`] as const;
};

export const getGetPublicObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  filePath: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({
    signal,
  }) => getPublicObject(filePath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!filePath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicObject>>
>;
export type GetPublicObjectQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a public object by path
 */

export function useGetPublicObject<
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  filePath: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicObjectQueryOptions(filePath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List active model profiles (for user selection)
 */
export const getListActiveModelsUrl = () => {
  return `/api/v1/models/active`;
};

export const listActiveModels = async (
  options?: RequestInit,
): Promise<ModelProfileWithImages[]> => {
  return customFetch<ModelProfileWithImages[]>(getListActiveModelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListActiveModelsQueryKey = () => {
  return [`/api/v1/models/active`] as const;
};

export const getListActiveModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveModelsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveModels>>
  > = ({ signal }) => listActiveModels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveModels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveModels>>
>;
export type ListActiveModelsQueryError = ErrorType<unknown>;

/**
 * @summary List active model profiles (for user selection)
 */

export function useListActiveModels<
  TData = Awaited<ReturnType<typeof listActiveModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listActiveModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveModelsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List ALL reference images (active AND inactive) for a model the caller owns. Used by the per-shot-card model reference selector so users can toggle any of their own model's shots on/off for a single photoshoot. Returns 403 for platform/system models or models owned by another user.
 */
export const getListModelAllReferenceImagesUrl = (id: number) => {
  return `/api/v1/models/${id}/all-reference-images`;
};

export const listModelAllReferenceImages = async (
  id: number,
  options?: RequestInit,
): Promise<ModelReferenceImage[]> => {
  return customFetch<ModelReferenceImage[]>(
    getListModelAllReferenceImagesUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListModelAllReferenceImagesQueryKey = (id: number) => {
  return [`/api/v1/models/${id}/all-reference-images`] as const;
};

export const getListModelAllReferenceImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listModelAllReferenceImages>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listModelAllReferenceImages>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListModelAllReferenceImagesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listModelAllReferenceImages>>
  > = ({ signal }) =>
    listModelAllReferenceImages(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listModelAllReferenceImages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListModelAllReferenceImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModelAllReferenceImages>>
>;
export type ListModelAllReferenceImagesQueryError = ErrorType<void>;

/**
 * @summary List ALL reference images (active AND inactive) for a model the caller owns. Used by the per-shot-card model reference selector so users can toggle any of their own model's shots on/off for a single photoshoot. Returns 403 for platform/system models or models owned by another user.
 */

export function useListModelAllReferenceImages<
  TData = Awaited<ReturnType<typeof listModelAllReferenceImages>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listModelAllReferenceImages>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListModelAllReferenceImagesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetUserModelCreditRateUrl = () => {
  return `/api/v1/user/models/credit-rate`;
};

export const getUserModelCreditRate = async (
  options?: RequestInit,
): Promise<GetUserModelCreditRate200> => {
  return customFetch<GetUserModelCreditRate200>(
    getGetUserModelCreditRateUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetUserModelCreditRateQueryKey = () => {
  return [`/api/v1/user/models/credit-rate`] as const;
};

export const getGetUserModelCreditRateQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserModelCreditRate>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getUserModelCreditRate>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserModelCreditRateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserModelCreditRate>>
  > = ({ signal }) => getUserModelCreditRate({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserModelCreditRate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserModelCreditRateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserModelCreditRate>>
>;
export type GetUserModelCreditRateQueryError = ErrorType<unknown>;

export function useGetUserModelCreditRate<
  TData = Awaited<ReturnType<typeof getUserModelCreditRate>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getUserModelCreditRate>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserModelCreditRateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListUserModelsUrl = () => {
  return `/api/v1/user/models`;
};

export const listUserModels = async (
  options?: RequestInit,
): Promise<ModelProfileWithImages[]> => {
  return customFetch<ModelProfileWithImages[]>(getListUserModelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListUserModelsQueryKey = () => {
  return [`/api/v1/user/models`] as const;
};

export const getListUserModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUserModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listUserModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUserModelsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserModels>>> = ({
    signal,
  }) => listUserModels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUserModels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUserModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUserModels>>
>;
export type ListUserModelsQueryError = ErrorType<unknown>;

export function useListUserModels<
  TData = Awaited<ReturnType<typeof listUserModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listUserModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUserModelsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateUserModelUrl = () => {
  return `/api/v1/user/models`;
};

export const createUserModel = async (
  createUserModelBody: CreateUserModelBody,
  options?: RequestInit,
): Promise<ModelProfileWithImages> => {
  return customFetch<ModelProfileWithImages>(getCreateUserModelUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createUserModelBody),
  });
};

export const getCreateUserModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserModel>>,
    TError,
    { data: BodyType<CreateUserModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUserModel>>,
  TError,
  { data: BodyType<CreateUserModelBody> },
  TContext
> => {
  const mutationKey = ["createUserModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUserModel>>,
    { data: BodyType<CreateUserModelBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createUserModel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUserModel>>
>;
export type CreateUserModelMutationBody = BodyType<CreateUserModelBody>;
export type CreateUserModelMutationError = ErrorType<unknown>;

export const useCreateUserModel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserModel>>,
    TError,
    { data: BodyType<CreateUserModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUserModel>>,
  TError,
  { data: BodyType<CreateUserModelBody> },
  TContext
> => {
  return useMutation(getCreateUserModelMutationOptions(options));
};

export const getGetUserModelUrl = (id: number) => {
  return `/api/v1/user/models/${id}`;
};

export const getUserModel = async (
  id: number,
  options?: RequestInit,
): Promise<ModelProfileWithImages> => {
  return customFetch<ModelProfileWithImages>(getGetUserModelUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetUserModelQueryKey = (id: number) => {
  return [`/api/v1/user/models/${id}`] as const;
};

export const getGetUserModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserModel>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getUserModel>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserModelQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserModel>>> = ({
    signal,
  }) => getUserModel(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserModelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserModel>>
>;
export type GetUserModelQueryError = ErrorType<unknown>;

export function useGetUserModel<
  TData = Awaited<ReturnType<typeof getUserModel>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getUserModel>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserModelQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateUserModelUrl = (id: number) => {
  return `/api/v1/user/models/${id}`;
};

export const updateUserModel = async (
  id: number,
  updateUserModelBody: UpdateUserModelBody,
  options?: RequestInit,
): Promise<ModelProfileWithImages> => {
  return customFetch<ModelProfileWithImages>(getUpdateUserModelUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserModelBody),
  });
};

export const getUpdateUserModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserModel>>,
    TError,
    { id: number; data: BodyType<UpdateUserModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserModel>>,
  TError,
  { id: number; data: BodyType<UpdateUserModelBody> },
  TContext
> => {
  const mutationKey = ["updateUserModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserModel>>,
    { id: number; data: BodyType<UpdateUserModelBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUserModel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserModel>>
>;
export type UpdateUserModelMutationBody = BodyType<UpdateUserModelBody>;
export type UpdateUserModelMutationError = ErrorType<unknown>;

export const useUpdateUserModel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserModel>>,
    TError,
    { id: number; data: BodyType<UpdateUserModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserModel>>,
  TError,
  { id: number; data: BodyType<UpdateUserModelBody> },
  TContext
> => {
  return useMutation(getUpdateUserModelMutationOptions(options));
};

export const getDeleteUserModelUrl = (id: number) => {
  return `/api/v1/user/models/${id}`;
};

export const deleteUserModel = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteUserModel200> => {
  return customFetch<DeleteUserModel200>(getDeleteUserModelUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteUserModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserModel>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserModel>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteUserModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserModel>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteUserModel(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserModel>>
>;

export type DeleteUserModelMutationError = ErrorType<unknown>;

export const useDeleteUserModel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserModel>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserModel>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteUserModelMutationOptions(options));
};

/**
 * @summary Create one or two pet models that share a single uploaded image.
 */
export const getCreateUserPetModelsUrl = () => {
  return `/api/v1/user/models/pets`;
};

export const createUserPetModels = async (
  createPetModelBody: CreatePetModelBody,
  options?: RequestInit,
): Promise<CreateUserPetModels201> => {
  return customFetch<CreateUserPetModels201>(getCreateUserPetModelsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPetModelBody),
  });
};

export const getCreateUserPetModelsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserPetModels>>,
    TError,
    { data: BodyType<CreatePetModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUserPetModels>>,
  TError,
  { data: BodyType<CreatePetModelBody> },
  TContext
> => {
  const mutationKey = ["createUserPetModels"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUserPetModels>>,
    { data: BodyType<CreatePetModelBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createUserPetModels(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserPetModelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUserPetModels>>
>;
export type CreateUserPetModelsMutationBody = BodyType<CreatePetModelBody>;
export type CreateUserPetModelsMutationError = ErrorType<unknown>;

/**
 * @summary Create one or two pet models that share a single uploaded image.
 */
export const useCreateUserPetModels = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserPetModels>>,
    TError,
    { data: BodyType<CreatePetModelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUserPetModels>>,
  TError,
  { data: BodyType<CreatePetModelBody> },
  TContext
> => {
  return useMutation(getCreateUserPetModelsMutationOptions(options));
};

export const getDuplicateUserModelUrl = (id: number) => {
  return `/api/v1/user/models/${id}/duplicate`;
};

export const duplicateUserModel = async (
  id: number,
  options?: RequestInit,
): Promise<ModelProfileWithImages> => {
  return customFetch<ModelProfileWithImages>(getDuplicateUserModelUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDuplicateUserModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateUserModel>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateUserModel>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["duplicateUserModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateUserModel>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return duplicateUserModel(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateUserModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateUserModel>>
>;

export type DuplicateUserModelMutationError = ErrorType<unknown>;

export const useDuplicateUserModel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateUserModel>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof duplicateUserModel>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDuplicateUserModelMutationOptions(options));
};

export const getAddUserModelImageUrl = (id: number) => {
  return `/api/v1/user/models/${id}/images`;
};

export const addUserModelImage = async (
  id: number,
  addModelReferenceImageBody: AddModelReferenceImageBody,
  options?: RequestInit,
): Promise<ModelReferenceImage> => {
  return customFetch<ModelReferenceImage>(getAddUserModelImageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addModelReferenceImageBody),
  });
};

export const getAddUserModelImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addUserModelImage>>,
    TError,
    { id: number; data: BodyType<AddModelReferenceImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addUserModelImage>>,
  TError,
  { id: number; data: BodyType<AddModelReferenceImageBody> },
  TContext
> => {
  const mutationKey = ["addUserModelImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addUserModelImage>>,
    { id: number; data: BodyType<AddModelReferenceImageBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addUserModelImage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddUserModelImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof addUserModelImage>>
>;
export type AddUserModelImageMutationBody =
  BodyType<AddModelReferenceImageBody>;
export type AddUserModelImageMutationError = ErrorType<unknown>;

export const useAddUserModelImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addUserModelImage>>,
    TError,
    { id: number; data: BodyType<AddModelReferenceImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addUserModelImage>>,
  TError,
  { id: number; data: BodyType<AddModelReferenceImageBody> },
  TContext
> => {
  return useMutation(getAddUserModelImageMutationOptions(options));
};

export const getReorderUserModelImagesUrl = (id: number) => {
  return `/api/v1/user/models/${id}/images/reorder`;
};

export const reorderUserModelImages = async (
  id: number,
  reorderUserModelImagesBody: ReorderUserModelImagesBody,
  options?: RequestInit,
): Promise<ModelReferenceImage[]> => {
  return customFetch<ModelReferenceImage[]>(getReorderUserModelImagesUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderUserModelImagesBody),
  });
};

export const getReorderUserModelImagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderUserModelImages>>,
    TError,
    { id: number; data: BodyType<ReorderUserModelImagesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderUserModelImages>>,
  TError,
  { id: number; data: BodyType<ReorderUserModelImagesBody> },
  TContext
> => {
  const mutationKey = ["reorderUserModelImages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderUserModelImages>>,
    { id: number; data: BodyType<ReorderUserModelImagesBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reorderUserModelImages(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderUserModelImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderUserModelImages>>
>;
export type ReorderUserModelImagesMutationBody =
  BodyType<ReorderUserModelImagesBody>;
export type ReorderUserModelImagesMutationError = ErrorType<unknown>;

export const useReorderUserModelImages = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderUserModelImages>>,
    TError,
    { id: number; data: BodyType<ReorderUserModelImagesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderUserModelImages>>,
  TError,
  { id: number; data: BodyType<ReorderUserModelImagesBody> },
  TContext
> => {
  return useMutation(getReorderUserModelImagesMutationOptions(options));
};

export const getRetryUserModelProfileAnalysisUrl = (id: number) => {
  return `/api/v1/user/models/${id}/retry-profile-analysis`;
};

export const retryUserModelProfileAnalysis = async (
  id: number,
  options?: RequestInit,
): Promise<RetryUserModelProfileAnalysis200> => {
  return customFetch<RetryUserModelProfileAnalysis200>(
    getRetryUserModelProfileAnalysisUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetryUserModelProfileAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryUserModelProfileAnalysis>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryUserModelProfileAnalysis>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["retryUserModelProfileAnalysis"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryUserModelProfileAnalysis>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return retryUserModelProfileAnalysis(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryUserModelProfileAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryUserModelProfileAnalysis>>
>;

export type RetryUserModelProfileAnalysisMutationError = ErrorType<unknown>;

export const useRetryUserModelProfileAnalysis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryUserModelProfileAnalysis>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryUserModelProfileAnalysis>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRetryUserModelProfileAnalysisMutationOptions(options));
};

export const getRetryUserModelSideHeadshotUrl = (id: number) => {
  return `/api/v1/user/models/${id}/retry-side-headshot`;
};

export const retryUserModelSideHeadshot = async (
  id: number,
  options?: RequestInit,
): Promise<RetryUserModelSideHeadshot200> => {
  return customFetch<RetryUserModelSideHeadshot200>(
    getRetryUserModelSideHeadshotUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetryUserModelSideHeadshotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryUserModelSideHeadshot>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryUserModelSideHeadshot>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["retryUserModelSideHeadshot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryUserModelSideHeadshot>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return retryUserModelSideHeadshot(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryUserModelSideHeadshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryUserModelSideHeadshot>>
>;

export type RetryUserModelSideHeadshotMutationError = ErrorType<unknown>;

export const useRetryUserModelSideHeadshot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryUserModelSideHeadshot>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryUserModelSideHeadshot>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRetryUserModelSideHeadshotMutationOptions(options));
};

export const getFaceSmashUserModelImagesUrl = (id: number) => {
  return `/api/v1/user/models/${id}/face-smash`;
};

export const faceSmashUserModelImages = async (
  id: number,
  faceSmashUserModelImagesBody: FaceSmashUserModelImagesBody,
  options?: RequestInit,
): Promise<ModelReferenceImage> => {
  return customFetch<ModelReferenceImage>(getFaceSmashUserModelImagesUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(faceSmashUserModelImagesBody),
  });
};

export const getFaceSmashUserModelImagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof faceSmashUserModelImages>>,
    TError,
    { id: number; data: BodyType<FaceSmashUserModelImagesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof faceSmashUserModelImages>>,
  TError,
  { id: number; data: BodyType<FaceSmashUserModelImagesBody> },
  TContext
> => {
  const mutationKey = ["faceSmashUserModelImages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof faceSmashUserModelImages>>,
    { id: number; data: BodyType<FaceSmashUserModelImagesBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return faceSmashUserModelImages(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FaceSmashUserModelImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof faceSmashUserModelImages>>
>;
export type FaceSmashUserModelImagesMutationBody =
  BodyType<FaceSmashUserModelImagesBody>;
export type FaceSmashUserModelImagesMutationError = ErrorType<unknown>;

export const useFaceSmashUserModelImages = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof faceSmashUserModelImages>>,
    TError,
    { id: number; data: BodyType<FaceSmashUserModelImagesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof faceSmashUserModelImages>>,
  TError,
  { id: number; data: BodyType<FaceSmashUserModelImagesBody> },
  TContext
> => {
  return useMutation(getFaceSmashUserModelImagesMutationOptions(options));
};

export const getRetryUserModelFaceSmashUrl = (id: number, imgId: number) => {
  return `/api/v1/user/models/${id}/images/${imgId}/retry-face-smash`;
};

export const retryUserModelFaceSmash = async (
  id: number,
  imgId: number,
  options?: RequestInit,
): Promise<RetryUserModelFaceSmash200> => {
  return customFetch<RetryUserModelFaceSmash200>(
    getRetryUserModelFaceSmashUrl(id, imgId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetryUserModelFaceSmashMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryUserModelFaceSmash>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryUserModelFaceSmash>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  const mutationKey = ["retryUserModelFaceSmash"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryUserModelFaceSmash>>,
    { id: number; imgId: number }
  > = (props) => {
    const { id, imgId } = props ?? {};

    return retryUserModelFaceSmash(id, imgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryUserModelFaceSmashMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryUserModelFaceSmash>>
>;

export type RetryUserModelFaceSmashMutationError = ErrorType<unknown>;

export const useRetryUserModelFaceSmash = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryUserModelFaceSmash>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryUserModelFaceSmash>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  return useMutation(getRetryUserModelFaceSmashMutationOptions(options));
};

export const getRegenerateUserModelImageUrl = (id: number, imgId: number) => {
  return `/api/v1/user/models/${id}/images/${imgId}/regenerate`;
};

export const regenerateUserModelImage = async (
  id: number,
  imgId: number,
  options?: RequestInit,
): Promise<RegenerateUserModelImage200> => {
  return customFetch<RegenerateUserModelImage200>(
    getRegenerateUserModelImageUrl(id, imgId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRegenerateUserModelImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateUserModelImage>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateUserModelImage>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  const mutationKey = ["regenerateUserModelImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateUserModelImage>>,
    { id: number; imgId: number }
  > = (props) => {
    const { id, imgId } = props ?? {};

    return regenerateUserModelImage(id, imgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateUserModelImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateUserModelImage>>
>;

export type RegenerateUserModelImageMutationError = ErrorType<unknown>;

export const useRegenerateUserModelImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateUserModelImage>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateUserModelImage>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  return useMutation(getRegenerateUserModelImageMutationOptions(options));
};

/**
 * Idempotent. Flips an in-flight `generating` reference image to
`cancelled`. No-op success for any other status (already complete,
already cancelled, deleted, errored). Does NOT refund credits — if the
upstream image provider has already finished, the credit was committed
and the result is silently discarded on arrival.

 * @summary Cancel a single in-flight headshot generation
 */
export const getCancelUserModelHeadshotUrl = (id: number, imgId: number) => {
  return `/api/v1/user/models/${id}/headshots/${imgId}/cancel`;
};

export const cancelUserModelHeadshot = async (
  id: number,
  imgId: number,
  options?: RequestInit,
): Promise<CancelUserModelHeadshot200> => {
  return customFetch<CancelUserModelHeadshot200>(
    getCancelUserModelHeadshotUrl(id, imgId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelUserModelHeadshotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelUserModelHeadshot>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelUserModelHeadshot>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  const mutationKey = ["cancelUserModelHeadshot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelUserModelHeadshot>>,
    { id: number; imgId: number }
  > = (props) => {
    const { id, imgId } = props ?? {};

    return cancelUserModelHeadshot(id, imgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelUserModelHeadshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelUserModelHeadshot>>
>;

export type CancelUserModelHeadshotMutationError = ErrorType<unknown>;

/**
 * @summary Cancel a single in-flight headshot generation
 */
export const useCancelUserModelHeadshot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelUserModelHeadshot>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelUserModelHeadshot>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  return useMutation(getCancelUserModelHeadshotMutationOptions(options));
};

/**
 * Idempotent. Flips every reference image whose status is currently
`generating` to `cancelled`. Same billing caveat as the single-image
cancel: credits are not refunded.

 * @summary Cancel every still-generating headshot for this model
 */
export const getCancelAllUserModelHeadshotsUrl = (id: number) => {
  return `/api/v1/user/models/${id}/headshots/cancel-all`;
};

export const cancelAllUserModelHeadshots = async (
  id: number,
  options?: RequestInit,
): Promise<CancelAllUserModelHeadshots200> => {
  return customFetch<CancelAllUserModelHeadshots200>(
    getCancelAllUserModelHeadshotsUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelAllUserModelHeadshotsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelAllUserModelHeadshots>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelAllUserModelHeadshots>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["cancelAllUserModelHeadshots"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelAllUserModelHeadshots>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return cancelAllUserModelHeadshots(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelAllUserModelHeadshotsMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelAllUserModelHeadshots>>
>;

export type CancelAllUserModelHeadshotsMutationError = ErrorType<unknown>;

/**
 * @summary Cancel every still-generating headshot for this model
 */
export const useCancelAllUserModelHeadshots = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelAllUserModelHeadshots>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelAllUserModelHeadshots>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getCancelAllUserModelHeadshotsMutationOptions(options));
};

export const getKeepUserModelImageUrl = (id: number, imgId: number) => {
  return `/api/v1/user/models/${id}/images/${imgId}/keep`;
};

export const keepUserModelImage = async (
  id: number,
  imgId: number,
  options?: RequestInit,
): Promise<KeepUserModelImage200> => {
  return customFetch<KeepUserModelImage200>(
    getKeepUserModelImageUrl(id, imgId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getKeepUserModelImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof keepUserModelImage>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof keepUserModelImage>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  const mutationKey = ["keepUserModelImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof keepUserModelImage>>,
    { id: number; imgId: number }
  > = (props) => {
    const { id, imgId } = props ?? {};

    return keepUserModelImage(id, imgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KeepUserModelImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof keepUserModelImage>>
>;

export type KeepUserModelImageMutationError = ErrorType<unknown>;

export const useKeepUserModelImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof keepUserModelImage>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof keepUserModelImage>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  return useMutation(getKeepUserModelImageMutationOptions(options));
};

export const getUpdateUserModelImageUrl = (id: number, imgId: number) => {
  return `/api/v1/user/models/${id}/images/${imgId}`;
};

export const updateUserModelImage = async (
  id: number,
  imgId: number,
  updateModelReferenceImageBody: UpdateModelReferenceImageBody,
  options?: RequestInit,
): Promise<ModelReferenceImage> => {
  return customFetch<ModelReferenceImage>(
    getUpdateUserModelImageUrl(id, imgId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateModelReferenceImageBody),
    },
  );
};

export const getUpdateUserModelImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserModelImage>>,
    TError,
    {
      id: number;
      imgId: number;
      data: BodyType<UpdateModelReferenceImageBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserModelImage>>,
  TError,
  { id: number; imgId: number; data: BodyType<UpdateModelReferenceImageBody> },
  TContext
> => {
  const mutationKey = ["updateUserModelImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserModelImage>>,
    { id: number; imgId: number; data: BodyType<UpdateModelReferenceImageBody> }
  > = (props) => {
    const { id, imgId, data } = props ?? {};

    return updateUserModelImage(id, imgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserModelImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserModelImage>>
>;
export type UpdateUserModelImageMutationBody =
  BodyType<UpdateModelReferenceImageBody>;
export type UpdateUserModelImageMutationError = ErrorType<unknown>;

export const useUpdateUserModelImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserModelImage>>,
    TError,
    {
      id: number;
      imgId: number;
      data: BodyType<UpdateModelReferenceImageBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserModelImage>>,
  TError,
  { id: number; imgId: number; data: BodyType<UpdateModelReferenceImageBody> },
  TContext
> => {
  return useMutation(getUpdateUserModelImageMutationOptions(options));
};

export const getDeleteUserModelImageUrl = (id: number, imgId: number) => {
  return `/api/v1/user/models/${id}/images/${imgId}`;
};

export const deleteUserModelImage = async (
  id: number,
  imgId: number,
  options?: RequestInit,
): Promise<DeleteUserModelImage200> => {
  return customFetch<DeleteUserModelImage200>(
    getDeleteUserModelImageUrl(id, imgId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteUserModelImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserModelImage>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserModelImage>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  const mutationKey = ["deleteUserModelImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserModelImage>>,
    { id: number; imgId: number }
  > = (props) => {
    const { id, imgId } = props ?? {};

    return deleteUserModelImage(id, imgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserModelImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserModelImage>>
>;

export type DeleteUserModelImageMutationError = ErrorType<unknown>;

export const useDeleteUserModelImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserModelImage>>,
    TError,
    { id: number; imgId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserModelImage>>,
  TError,
  { id: number; imgId: number },
  TContext
> => {
  return useMutation(getDeleteUserModelImageMutationOptions(options));
};

export const getGenerateMoreUserModelHeadshotsUrl = (id: number) => {
  return `/api/v1/user/models/${id}/generate-more`;
};

export const generateMoreUserModelHeadshots = async (
  id: number,
  generateMoreUserModelHeadshotsBody: GenerateMoreUserModelHeadshotsBody,
  options?: RequestInit,
): Promise<ModelReferenceImage[]> => {
  return customFetch<ModelReferenceImage[]>(
    getGenerateMoreUserModelHeadshotsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generateMoreUserModelHeadshotsBody),
    },
  );
};

export const getGenerateMoreUserModelHeadshotsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMoreUserModelHeadshots>>,
    TError,
    { id: number; data: BodyType<GenerateMoreUserModelHeadshotsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateMoreUserModelHeadshots>>,
  TError,
  { id: number; data: BodyType<GenerateMoreUserModelHeadshotsBody> },
  TContext
> => {
  const mutationKey = ["generateMoreUserModelHeadshots"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateMoreUserModelHeadshots>>,
    { id: number; data: BodyType<GenerateMoreUserModelHeadshotsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateMoreUserModelHeadshots(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateMoreUserModelHeadshotsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateMoreUserModelHeadshots>>
>;
export type GenerateMoreUserModelHeadshotsMutationBody =
  BodyType<GenerateMoreUserModelHeadshotsBody>;
export type GenerateMoreUserModelHeadshotsMutationError = ErrorType<unknown>;

export const useGenerateMoreUserModelHeadshots = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMoreUserModelHeadshots>>,
    TError,
    { id: number; data: BodyType<GenerateMoreUserModelHeadshotsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateMoreUserModelHeadshots>>,
  TError,
  { id: number; data: BodyType<GenerateMoreUserModelHeadshotsBody> },
  TContext
> => {
  return useMutation(getGenerateMoreUserModelHeadshotsMutationOptions(options));
};

export const getFinalizeUserModelUrl = (id: number) => {
  return `/api/v1/user/models/${id}/finalize`;
};

export const finalizeUserModel = async (
  id: number,
  options?: RequestInit,
): Promise<FinalizeUserModel200> => {
  return customFetch<FinalizeUserModel200>(getFinalizeUserModelUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getFinalizeUserModelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeUserModel>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeUserModel>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["finalizeUserModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeUserModel>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return finalizeUserModel(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeUserModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeUserModel>>
>;

export type FinalizeUserModelMutationError = ErrorType<unknown>;

export const useFinalizeUserModel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeUserModel>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof finalizeUserModel>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getFinalizeUserModelMutationOptions(options));
};

export const getListUserNotificationsUrl = () => {
  return `/api/v1/user/notifications`;
};

export const listUserNotifications = async (
  options?: RequestInit,
): Promise<UserNotification[]> => {
  return customFetch<UserNotification[]>(getListUserNotificationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListUserNotificationsQueryKey = () => {
  return [`/api/v1/user/notifications`] as const;
};

export const getListUserNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUserNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listUserNotifications>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUserNotificationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUserNotifications>>
  > = ({ signal }) => listUserNotifications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUserNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUserNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUserNotifications>>
>;
export type ListUserNotificationsQueryError = ErrorType<unknown>;

export function useListUserNotifications<
  TData = Awaited<ReturnType<typeof listUserNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listUserNotifications>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUserNotificationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMarkUserNotificationReadUrl = (id: number) => {
  return `/api/v1/user/notifications/${id}/read`;
};

export const markUserNotificationRead = async (
  id: number,
  options?: RequestInit,
): Promise<MarkUserNotificationRead200> => {
  return customFetch<MarkUserNotificationRead200>(
    getMarkUserNotificationReadUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMarkUserNotificationReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markUserNotificationRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markUserNotificationRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["markUserNotificationRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markUserNotificationRead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return markUserNotificationRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkUserNotificationReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markUserNotificationRead>>
>;

export type MarkUserNotificationReadMutationError = ErrorType<unknown>;

export const useMarkUserNotificationRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markUserNotificationRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markUserNotificationRead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getMarkUserNotificationReadMutationOptions(options));
};

export const getMarkAllUserNotificationsReadUrl = () => {
  return `/api/v1/user/notifications/read-all`;
};

export const markAllUserNotificationsRead = async (
  options?: RequestInit,
): Promise<MarkAllUserNotificationsRead200> => {
  return customFetch<MarkAllUserNotificationsRead200>(
    getMarkAllUserNotificationsReadUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMarkAllUserNotificationsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllUserNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllUserNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markAllUserNotificationsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllUserNotificationsRead>>,
    void
  > = () => {
    return markAllUserNotificationsRead(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllUserNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllUserNotificationsRead>>
>;

export type MarkAllUserNotificationsReadMutationError = ErrorType<unknown>;

export const useMarkAllUserNotificationsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllUserNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAllUserNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getMarkAllUserNotificationsReadMutationOptions(options));
};

/**
 * @summary List active mannequins (user-facing) with star state
 */
export const getListMannequinsUrl = () => {
  return `/api/v1/mannequins`;
};

export const listMannequins = async (
  options?: RequestInit,
): Promise<MannequinWithStar[]> => {
  return customFetch<MannequinWithStar[]>(getListMannequinsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMannequinsQueryKey = () => {
  return [`/api/v1/mannequins`] as const;
};

export const getListMannequinsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMannequins>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listMannequins>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMannequinsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMannequins>>> = ({
    signal,
  }) => listMannequins({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMannequins>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMannequinsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMannequins>>
>;
export type ListMannequinsQueryError = ErrorType<unknown>;

/**
 * @summary List active mannequins (user-facing) with star state
 */

export function useListMannequins<
  TData = Awaited<ReturnType<typeof listMannequins>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listMannequins>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMannequinsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Star a mannequin for the current user
 */
export const getStarMannequinUrl = (id: number) => {
  return `/api/v1/mannequins/${id}/star`;
};

export const starMannequin = async (
  id: number,
  options?: RequestInit,
): Promise<StarMannequin200> => {
  return customFetch<StarMannequin200>(getStarMannequinUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getStarMannequinMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof starMannequin>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof starMannequin>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["starMannequin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof starMannequin>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return starMannequin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StarMannequinMutationResult = NonNullable<
  Awaited<ReturnType<typeof starMannequin>>
>;

export type StarMannequinMutationError = ErrorType<unknown>;

/**
 * @summary Star a mannequin for the current user
 */
export const useStarMannequin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof starMannequin>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof starMannequin>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getStarMannequinMutationOptions(options));
};

/**
 * @summary Remove a star from a mannequin
 */
export const getUnstarMannequinUrl = (id: number) => {
  return `/api/v1/mannequins/${id}/star`;
};

export const unstarMannequin = async (
  id: number,
  options?: RequestInit,
): Promise<UnstarMannequin200> => {
  return customFetch<UnstarMannequin200>(getUnstarMannequinUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getUnstarMannequinMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unstarMannequin>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unstarMannequin>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["unstarMannequin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unstarMannequin>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unstarMannequin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnstarMannequinMutationResult = NonNullable<
  Awaited<ReturnType<typeof unstarMannequin>>
>;

export type UnstarMannequinMutationError = ErrorType<unknown>;

/**
 * @summary Remove a star from a mannequin
 */
export const useUnstarMannequin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unstarMannequin>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unstarMannequin>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getUnstarMannequinMutationOptions(options));
};

/**
 * @summary List all mannequins (admin)
 */
export const getListAdminMannequinsUrl = () => {
  return `/api/v1/admin/mannequins`;
};

export const listAdminMannequins = async (
  options?: RequestInit,
): Promise<Mannequin[]> => {
  return customFetch<Mannequin[]>(getListAdminMannequinsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminMannequinsQueryKey = () => {
  return [`/api/v1/admin/mannequins`] as const;
};

export const getListAdminMannequinsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminMannequins>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listAdminMannequins>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminMannequinsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminMannequins>>
  > = ({ signal }) => listAdminMannequins({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminMannequins>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminMannequinsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminMannequins>>
>;
export type ListAdminMannequinsQueryError = ErrorType<unknown>;

/**
 * @summary List all mannequins (admin)
 */

export function useListAdminMannequins<
  TData = Awaited<ReturnType<typeof listAdminMannequins>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listAdminMannequins>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminMannequinsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a mannequin (admin)
 */
export const getCreateAdminMannequinUrl = () => {
  return `/api/v1/admin/mannequins`;
};

export const createAdminMannequin = async (
  createMannequinBody: CreateMannequinBody,
  options?: RequestInit,
): Promise<Mannequin> => {
  return customFetch<Mannequin>(getCreateAdminMannequinUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMannequinBody),
  });
};

export const getCreateAdminMannequinMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminMannequin>>,
    TError,
    { data: BodyType<CreateMannequinBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminMannequin>>,
  TError,
  { data: BodyType<CreateMannequinBody> },
  TContext
> => {
  const mutationKey = ["createAdminMannequin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminMannequin>>,
    { data: BodyType<CreateMannequinBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAdminMannequin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminMannequinMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminMannequin>>
>;
export type CreateAdminMannequinMutationBody = BodyType<CreateMannequinBody>;
export type CreateAdminMannequinMutationError = ErrorType<unknown>;

/**
 * @summary Create a mannequin (admin)
 */
export const useCreateAdminMannequin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminMannequin>>,
    TError,
    { data: BodyType<CreateMannequinBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAdminMannequin>>,
  TError,
  { data: BodyType<CreateMannequinBody> },
  TContext
> => {
  return useMutation(getCreateAdminMannequinMutationOptions(options));
};

/**
 * @summary Update a mannequin (admin)
 */
export const getUpdateAdminMannequinUrl = (id: number) => {
  return `/api/v1/admin/mannequins/${id}`;
};

export const updateAdminMannequin = async (
  id: number,
  updateMannequinBody: UpdateMannequinBody,
  options?: RequestInit,
): Promise<Mannequin> => {
  return customFetch<Mannequin>(getUpdateAdminMannequinUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMannequinBody),
  });
};

export const getUpdateAdminMannequinMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminMannequin>>,
    TError,
    { id: number; data: BodyType<UpdateMannequinBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminMannequin>>,
  TError,
  { id: number; data: BodyType<UpdateMannequinBody> },
  TContext
> => {
  const mutationKey = ["updateAdminMannequin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminMannequin>>,
    { id: number; data: BodyType<UpdateMannequinBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAdminMannequin(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminMannequinMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminMannequin>>
>;
export type UpdateAdminMannequinMutationBody = BodyType<UpdateMannequinBody>;
export type UpdateAdminMannequinMutationError = ErrorType<unknown>;

/**
 * @summary Update a mannequin (admin)
 */
export const useUpdateAdminMannequin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminMannequin>>,
    TError,
    { id: number; data: BodyType<UpdateMannequinBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminMannequin>>,
  TError,
  { id: number; data: BodyType<UpdateMannequinBody> },
  TContext
> => {
  return useMutation(getUpdateAdminMannequinMutationOptions(options));
};

/**
 * @summary Delete a mannequin (admin)
 */
export const getDeleteAdminMannequinUrl = (id: number) => {
  return `/api/v1/admin/mannequins/${id}`;
};

export const deleteAdminMannequin = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteAdminMannequin200> => {
  return customFetch<DeleteAdminMannequin200>(getDeleteAdminMannequinUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminMannequinMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminMannequin>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminMannequin>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminMannequin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminMannequin>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminMannequin(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminMannequinMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminMannequin>>
>;

export type DeleteAdminMannequinMutationError = ErrorType<unknown>;

/**
 * @summary Delete a mannequin (admin)
 */
export const useDeleteAdminMannequin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminMannequin>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminMannequin>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAdminMannequinMutationOptions(options));
};

/**
 * @summary Reorder mannequins (admin)
 */
export const getReorderAdminMannequinsUrl = () => {
  return `/api/v1/admin/mannequins/reorder`;
};

export const reorderAdminMannequins = async (
  reorderMannequinsBody: ReorderMannequinsBody,
  options?: RequestInit,
): Promise<ReorderAdminMannequins200> => {
  return customFetch<ReorderAdminMannequins200>(
    getReorderAdminMannequinsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reorderMannequinsBody),
    },
  );
};

export const getReorderAdminMannequinsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderAdminMannequins>>,
    TError,
    { data: BodyType<ReorderMannequinsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderAdminMannequins>>,
  TError,
  { data: BodyType<ReorderMannequinsBody> },
  TContext
> => {
  const mutationKey = ["reorderAdminMannequins"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderAdminMannequins>>,
    { data: BodyType<ReorderMannequinsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return reorderAdminMannequins(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderAdminMannequinsMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderAdminMannequins>>
>;
export type ReorderAdminMannequinsMutationBody =
  BodyType<ReorderMannequinsBody>;
export type ReorderAdminMannequinsMutationError = ErrorType<unknown>;

/**
 * @summary Reorder mannequins (admin)
 */
export const useReorderAdminMannequins = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderAdminMannequins>>,
    TError,
    { data: BodyType<ReorderMannequinsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderAdminMannequins>>,
  TError,
  { data: BodyType<ReorderMannequinsBody> },
  TContext
> => {
  return useMutation(getReorderAdminMannequinsMutationOptions(options));
};

/**
 * @summary Place the photoshoot product onto a selected mannequin
 */
export const getDressMannequinUrl = (id: number) => {
  return `/api/v1/photoshoots/${id}/dress-mannequin`;
};

export const dressMannequin = async (
  id: number,
  dressMannequinBody: DressMannequinBody,
  options?: RequestInit,
): Promise<DressMannequinResult> => {
  return customFetch<DressMannequinResult>(getDressMannequinUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(dressMannequinBody),
  });
};

export const getDressMannequinMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dressMannequin>>,
    TError,
    { id: number; data: BodyType<DressMannequinBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dressMannequin>>,
  TError,
  { id: number; data: BodyType<DressMannequinBody> },
  TContext
> => {
  const mutationKey = ["dressMannequin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dressMannequin>>,
    { id: number; data: BodyType<DressMannequinBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dressMannequin(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DressMannequinMutationResult = NonNullable<
  Awaited<ReturnType<typeof dressMannequin>>
>;
export type DressMannequinMutationBody = BodyType<DressMannequinBody>;
export type DressMannequinMutationError = ErrorType<unknown>;

/**
 * @summary Place the photoshoot product onto a selected mannequin
 */
export const useDressMannequin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dressMannequin>>,
    TError,
    { id: number; data: BodyType<DressMannequinBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dressMannequin>>,
  TError,
  { id: number; data: BodyType<DressMannequinBody> },
  TContext
> => {
  return useMutation(getDressMannequinMutationOptions(options));
};

/**
 * @summary List my organisations
 */
export const getListOrganisationsUrl = () => {
  return `/api/v1/user/organisations`;
};

export const listOrganisations = async (
  options?: RequestInit,
): Promise<Organisation[]> => {
  return customFetch<Organisation[]>(getListOrganisationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListOrganisationsQueryKey = () => {
  return [`/api/v1/user/organisations`] as const;
};

export const getListOrganisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganisations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listOrganisations>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOrganisationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganisations>>
  > = ({ signal }) => listOrganisations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganisations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOrganisationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganisations>>
>;
export type ListOrganisationsQueryError = ErrorType<unknown>;

/**
 * @summary List my organisations
 */

export function useListOrganisations<
  TData = Awaited<ReturnType<typeof listOrganisations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listOrganisations>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOrganisationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an organisation
 */
export const getCreateOrganisationUrl = () => {
  return `/api/v1/user/organisations`;
};

export const createOrganisation = async (
  organisationInput: OrganisationInput,
  options?: RequestInit,
): Promise<Organisation> => {
  return customFetch<Organisation>(getCreateOrganisationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(organisationInput),
  });
};

export const getCreateOrganisationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisation>>,
    TError,
    { data: BodyType<OrganisationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganisation>>,
  TError,
  { data: BodyType<OrganisationInput> },
  TContext
> => {
  const mutationKey = ["createOrganisation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganisation>>,
    { data: BodyType<OrganisationInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createOrganisation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganisationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganisation>>
>;
export type CreateOrganisationMutationBody = BodyType<OrganisationInput>;
export type CreateOrganisationMutationError = ErrorType<unknown>;

/**
 * @summary Create an organisation
 */
export const useCreateOrganisation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisation>>,
    TError,
    { data: BodyType<OrganisationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrganisation>>,
  TError,
  { data: BodyType<OrganisationInput> },
  TContext
> => {
  return useMutation(getCreateOrganisationMutationOptions(options));
};

export const getGetOrganisationUrl = (id: number) => {
  return `/api/v1/user/organisations/${id}`;
};

export const getOrganisation = async (
  id: number,
  options?: RequestInit,
): Promise<Organisation> => {
  return customFetch<Organisation>(getGetOrganisationUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetOrganisationQueryKey = (id: number) => {
  return [`/api/v1/user/organisations/${id}`] as const;
};

export const getGetOrganisationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganisation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getOrganisation>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganisationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisation>>> = ({
    signal,
  }) => getOrganisation(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganisationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganisation>>
>;
export type GetOrganisationQueryError = ErrorType<unknown>;

export function useGetOrganisation<
  TData = Awaited<ReturnType<typeof getOrganisation>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getOrganisation>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganisationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateOrganisationUrl = (id: number) => {
  return `/api/v1/user/organisations/${id}`;
};

export const updateOrganisation = async (
  id: number,
  organisationInput: OrganisationInput,
  options?: RequestInit,
): Promise<Organisation> => {
  return customFetch<Organisation>(getUpdateOrganisationUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(organisationInput),
  });
};

export const getUpdateOrganisationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisation>>,
    TError,
    { id: number; data: BodyType<OrganisationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganisation>>,
  TError,
  { id: number; data: BodyType<OrganisationInput> },
  TContext
> => {
  const mutationKey = ["updateOrganisation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganisation>>,
    { id: number; data: BodyType<OrganisationInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOrganisation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganisationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganisation>>
>;
export type UpdateOrganisationMutationBody = BodyType<OrganisationInput>;
export type UpdateOrganisationMutationError = ErrorType<unknown>;

export const useUpdateOrganisation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisation>>,
    TError,
    { id: number; data: BodyType<OrganisationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganisation>>,
  TError,
  { id: number; data: BodyType<OrganisationInput> },
  TContext
> => {
  return useMutation(getUpdateOrganisationMutationOptions(options));
};

export const getDeleteOrganisationUrl = (id: number) => {
  return `/api/v1/user/organisations/${id}`;
};

export const deleteOrganisation = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteOrganisationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteOrganisationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganisation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganisation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteOrganisation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganisation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOrganisation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganisationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganisation>>
>;

export type DeleteOrganisationMutationError = ErrorType<unknown>;

export const useDeleteOrganisation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganisation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganisation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteOrganisationMutationOptions(options));
};

export const getListInfluencersUrl = (id: number) => {
  return `/api/v1/user/organisations/${id}/influencers`;
};

export const listInfluencers = async (
  id: number,
  options?: RequestInit,
): Promise<Influencer[]> => {
  return customFetch<Influencer[]>(getListInfluencersUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListInfluencersQueryKey = (id: number) => {
  return [`/api/v1/user/organisations/${id}/influencers`] as const;
};

export const getListInfluencersQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfluencers>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listInfluencers>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInfluencersQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInfluencers>>> = ({
    signal,
  }) => listInfluencers(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfluencers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfluencersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfluencers>>
>;
export type ListInfluencersQueryError = ErrorType<unknown>;

export function useListInfluencers<
  TData = Awaited<ReturnType<typeof listInfluencers>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listInfluencers>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfluencersQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateInfluencerUrl = (id: number) => {
  return `/api/v1/user/organisations/${id}/influencers`;
};

export const createInfluencer = async (
  id: number,
  createInfluencerBody: CreateInfluencerBody,
  options?: RequestInit,
): Promise<Influencer> => {
  return customFetch<Influencer>(getCreateInfluencerUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfluencerBody),
  });
};

export const getCreateInfluencerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfluencer>>,
    TError,
    { id: number; data: BodyType<CreateInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfluencer>>,
  TError,
  { id: number; data: BodyType<CreateInfluencerBody> },
  TContext
> => {
  const mutationKey = ["createInfluencer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfluencer>>,
    { id: number; data: BodyType<CreateInfluencerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createInfluencer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfluencerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfluencer>>
>;
export type CreateInfluencerMutationBody = BodyType<CreateInfluencerBody>;
export type CreateInfluencerMutationError = ErrorType<unknown>;

export const useCreateInfluencer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfluencer>>,
    TError,
    { id: number; data: BodyType<CreateInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfluencer>>,
  TError,
  { id: number; data: BodyType<CreateInfluencerBody> },
  TContext
> => {
  return useMutation(getCreateInfluencerMutationOptions(options));
};

export const getGetInfluencerUrl = (id: number) => {
  return `/api/v1/user/influencers/${id}`;
};

export const getInfluencer = async (
  id: number,
  options?: RequestInit,
): Promise<Influencer> => {
  return customFetch<Influencer>(getGetInfluencerUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInfluencerQueryKey = (id: number) => {
  return [`/api/v1/user/influencers/${id}`] as const;
};

export const getGetInfluencerQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfluencer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencer>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInfluencerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInfluencer>>> = ({
    signal,
  }) => getInfluencer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfluencer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInfluencerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInfluencer>>
>;
export type GetInfluencerQueryError = ErrorType<unknown>;

export function useGetInfluencer<
  TData = Awaited<ReturnType<typeof getInfluencer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencer>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInfluencerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update influencer fields (Content Direction inputs etc.)
 */
export const getUpdateInfluencerUrl = (id: number) => {
  return `/api/v1/user/influencers/${id}`;
};

export const updateInfluencer = async (
  id: number,
  updateInfluencerBody: UpdateInfluencerBody,
  options?: RequestInit,
): Promise<Influencer> => {
  return customFetch<Influencer>(getUpdateInfluencerUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInfluencerBody),
  });
};

export const getUpdateInfluencerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencer>>,
    TError,
    { id: number; data: BodyType<UpdateInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfluencer>>,
  TError,
  { id: number; data: BodyType<UpdateInfluencerBody> },
  TContext
> => {
  const mutationKey = ["updateInfluencer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfluencer>>,
    { id: number; data: BodyType<UpdateInfluencerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInfluencer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfluencerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfluencer>>
>;
export type UpdateInfluencerMutationBody = BodyType<UpdateInfluencerBody>;
export type UpdateInfluencerMutationError = ErrorType<unknown>;

/**
 * @summary Update influencer fields (Content Direction inputs etc.)
 */
export const useUpdateInfluencer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencer>>,
    TError,
    { id: number; data: BodyType<UpdateInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfluencer>>,
  TError,
  { id: number; data: BodyType<UpdateInfluencerBody> },
  TContext
> => {
  return useMutation(getUpdateInfluencerMutationOptions(options));
};

export const getDeleteInfluencerUrl = (id: number) => {
  return `/api/v1/user/influencers/${id}`;
};

export const deleteInfluencer = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInfluencerUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfluencerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfluencer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfluencer>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInfluencer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfluencer>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInfluencer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfluencerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfluencer>>
>;

export type DeleteInfluencerMutationError = ErrorType<unknown>;

export const useDeleteInfluencer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfluencer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfluencer>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInfluencerMutationOptions(options));
};

export const getReassignInfluencerUrl = (id: number) => {
  return `/api/v1/user/influencers/${id}/reassign`;
};

export const reassignInfluencer = async (
  id: number,
  reassignInfluencerBody: ReassignInfluencerBody,
  options?: RequestInit,
): Promise<Influencer> => {
  return customFetch<Influencer>(getReassignInfluencerUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reassignInfluencerBody),
  });
};

export const getReassignInfluencerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reassignInfluencer>>,
    TError,
    { id: number; data: BodyType<ReassignInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reassignInfluencer>>,
  TError,
  { id: number; data: BodyType<ReassignInfluencerBody> },
  TContext
> => {
  const mutationKey = ["reassignInfluencer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reassignInfluencer>>,
    { id: number; data: BodyType<ReassignInfluencerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reassignInfluencer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReassignInfluencerMutationResult = NonNullable<
  Awaited<ReturnType<typeof reassignInfluencer>>
>;
export type ReassignInfluencerMutationBody = BodyType<ReassignInfluencerBody>;
export type ReassignInfluencerMutationError = ErrorType<unknown>;

export const useReassignInfluencer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reassignInfluencer>>,
    TError,
    { id: number; data: BodyType<ReassignInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reassignInfluencer>>,
  TError,
  { id: number; data: BodyType<ReassignInfluencerBody> },
  TContext
> => {
  return useMutation(getReassignInfluencerMutationOptions(options));
};

/**
 * @summary Atomically promote a non-pet, unlinked model into a new Influencer (optionally creating its Organisation in the same transaction).
 */
export const getPromoteModelToInfluencerUrl = (id: number) => {
  return `/api/v1/user/models/${id}/promote-to-influencer`;
};

export const promoteModelToInfluencer = async (
  id: number,
  promoteModelToInfluencerBody: PromoteModelToInfluencerBody,
  options?: RequestInit,
): Promise<Influencer> => {
  return customFetch<Influencer>(getPromoteModelToInfluencerUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(promoteModelToInfluencerBody),
  });
};

export const getPromoteModelToInfluencerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteModelToInfluencer>>,
    TError,
    { id: number; data: BodyType<PromoteModelToInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteModelToInfluencer>>,
  TError,
  { id: number; data: BodyType<PromoteModelToInfluencerBody> },
  TContext
> => {
  const mutationKey = ["promoteModelToInfluencer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteModelToInfluencer>>,
    { id: number; data: BodyType<PromoteModelToInfluencerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return promoteModelToInfluencer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteModelToInfluencerMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoteModelToInfluencer>>
>;
export type PromoteModelToInfluencerMutationBody =
  BodyType<PromoteModelToInfluencerBody>;
export type PromoteModelToInfluencerMutationError = ErrorType<unknown>;

/**
 * @summary Atomically promote a non-pet, unlinked model into a new Influencer (optionally creating its Organisation in the same transaction).
 */
export const usePromoteModelToInfluencer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteModelToInfluencer>>,
    TError,
    { id: number; data: BodyType<PromoteModelToInfluencerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoteModelToInfluencer>>,
  TError,
  { id: number; data: BodyType<PromoteModelToInfluencerBody> },
  TContext
> => {
  return useMutation(getPromoteModelToInfluencerMutationOptions(options));
};

/**
 * @summary List organisations a model is wrapped by as influencer
 */
export const getListModelOrganisationAssignmentsUrl = (id: number) => {
  return `/api/v1/user/models/${id}/organisation-assignments`;
};

export const listModelOrganisationAssignments = async (
  id: number,
  options?: RequestInit,
): Promise<ModelOrganisationAssignment[]> => {
  return customFetch<ModelOrganisationAssignment[]>(
    getListModelOrganisationAssignmentsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListModelOrganisationAssignmentsQueryKey = (id: number) => {
  return [`/api/v1/user/models/${id}/organisation-assignments`] as const;
};

export const getListModelOrganisationAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listModelOrganisationAssignments>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listModelOrganisationAssignments>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListModelOrganisationAssignmentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listModelOrganisationAssignments>>
  > = ({ signal }) =>
    listModelOrganisationAssignments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listModelOrganisationAssignments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListModelOrganisationAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModelOrganisationAssignments>>
>;
export type ListModelOrganisationAssignmentsQueryError = ErrorType<unknown>;

/**
 * @summary List organisations a model is wrapped by as influencer
 */

export function useListModelOrganisationAssignments<
  TData = Awaited<ReturnType<typeof listModelOrganisationAssignments>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listModelOrganisationAssignments>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListModelOrganisationAssignmentsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListInfluencerLocationsUrl = (id: number) => {
  return `/api/v1/user/influencers/${id}/locations`;
};

export const listInfluencerLocations = async (
  id: number,
  options?: RequestInit,
): Promise<InfluencerLocation[]> => {
  return customFetch<InfluencerLocation[]>(getListInfluencerLocationsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListInfluencerLocationsQueryKey = (id: number) => {
  return [`/api/v1/user/influencers/${id}/locations`] as const;
};

export const getListInfluencerLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfluencerLocations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listInfluencerLocations>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInfluencerLocationsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfluencerLocations>>
  > = ({ signal }) =>
    listInfluencerLocations(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfluencerLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfluencerLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfluencerLocations>>
>;
export type ListInfluencerLocationsQueryError = ErrorType<unknown>;

export function useListInfluencerLocations<
  TData = Awaited<ReturnType<typeof listInfluencerLocations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listInfluencerLocations>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfluencerLocationsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateInfluencerLocationUrl = (id: number) => {
  return `/api/v1/user/influencers/${id}/locations`;
};

export const createInfluencerLocation = async (
  id: number,
  createInfluencerLocationBody: CreateInfluencerLocationBody,
  options?: RequestInit,
): Promise<InfluencerLocation> => {
  return customFetch<InfluencerLocation>(getCreateInfluencerLocationUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInfluencerLocationBody),
  });
};

export const getCreateInfluencerLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfluencerLocation>>,
    TError,
    { id: number; data: BodyType<CreateInfluencerLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfluencerLocation>>,
  TError,
  { id: number; data: BodyType<CreateInfluencerLocationBody> },
  TContext
> => {
  const mutationKey = ["createInfluencerLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfluencerLocation>>,
    { id: number; data: BodyType<CreateInfluencerLocationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createInfluencerLocation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfluencerLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfluencerLocation>>
>;
export type CreateInfluencerLocationMutationBody =
  BodyType<CreateInfluencerLocationBody>;
export type CreateInfluencerLocationMutationError = ErrorType<unknown>;

export const useCreateInfluencerLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfluencerLocation>>,
    TError,
    { id: number; data: BodyType<CreateInfluencerLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfluencerLocation>>,
  TError,
  { id: number; data: BodyType<CreateInfluencerLocationBody> },
  TContext
> => {
  return useMutation(getCreateInfluencerLocationMutationOptions(options));
};

export const getReorderInfluencerLocationsUrl = (id: number) => {
  return `/api/v1/user/influencers/${id}/locations/reorder`;
};

export const reorderInfluencerLocations = async (
  id: number,
  reorderInfluencerLocationsBody: ReorderInfluencerLocationsBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getReorderInfluencerLocationsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderInfluencerLocationsBody),
  });
};

export const getReorderInfluencerLocationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderInfluencerLocations>>,
    TError,
    { id: number; data: BodyType<ReorderInfluencerLocationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderInfluencerLocations>>,
  TError,
  { id: number; data: BodyType<ReorderInfluencerLocationsBody> },
  TContext
> => {
  const mutationKey = ["reorderInfluencerLocations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderInfluencerLocations>>,
    { id: number; data: BodyType<ReorderInfluencerLocationsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reorderInfluencerLocations(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderInfluencerLocationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderInfluencerLocations>>
>;
export type ReorderInfluencerLocationsMutationBody =
  BodyType<ReorderInfluencerLocationsBody>;
export type ReorderInfluencerLocationsMutationError = ErrorType<unknown>;

export const useReorderInfluencerLocations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderInfluencerLocations>>,
    TError,
    { id: number; data: BodyType<ReorderInfluencerLocationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderInfluencerLocations>>,
  TError,
  { id: number; data: BodyType<ReorderInfluencerLocationsBody> },
  TContext
> => {
  return useMutation(getReorderInfluencerLocationsMutationOptions(options));
};

export const getUpdateInfluencerLocationUrl = (locationId: number) => {
  return `/api/v1/user/influencer-locations/${locationId}`;
};

export const updateInfluencerLocation = async (
  locationId: number,
  updateInfluencerLocationBody: UpdateInfluencerLocationBody,
  options?: RequestInit,
): Promise<InfluencerLocation> => {
  return customFetch<InfluencerLocation>(
    getUpdateInfluencerLocationUrl(locationId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateInfluencerLocationBody),
    },
  );
};

export const getUpdateInfluencerLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencerLocation>>,
    TError,
    { locationId: number; data: BodyType<UpdateInfluencerLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfluencerLocation>>,
  TError,
  { locationId: number; data: BodyType<UpdateInfluencerLocationBody> },
  TContext
> => {
  const mutationKey = ["updateInfluencerLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfluencerLocation>>,
    { locationId: number; data: BodyType<UpdateInfluencerLocationBody> }
  > = (props) => {
    const { locationId, data } = props ?? {};

    return updateInfluencerLocation(locationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfluencerLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfluencerLocation>>
>;
export type UpdateInfluencerLocationMutationBody =
  BodyType<UpdateInfluencerLocationBody>;
export type UpdateInfluencerLocationMutationError = ErrorType<unknown>;

export const useUpdateInfluencerLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencerLocation>>,
    TError,
    { locationId: number; data: BodyType<UpdateInfluencerLocationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfluencerLocation>>,
  TError,
  { locationId: number; data: BodyType<UpdateInfluencerLocationBody> },
  TContext
> => {
  return useMutation(getUpdateInfluencerLocationMutationOptions(options));
};

export const getDeleteInfluencerLocationUrl = (locationId: number) => {
  return `/api/v1/user/influencer-locations/${locationId}`;
};

export const deleteInfluencerLocation = async (
  locationId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInfluencerLocationUrl(locationId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfluencerLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfluencerLocation>>,
    TError,
    { locationId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfluencerLocation>>,
  TError,
  { locationId: number },
  TContext
> => {
  const mutationKey = ["deleteInfluencerLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfluencerLocation>>,
    { locationId: number }
  > = (props) => {
    const { locationId } = props ?? {};

    return deleteInfluencerLocation(locationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfluencerLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfluencerLocation>>
>;

export type DeleteInfluencerLocationMutationError = ErrorType<unknown>;

export const useDeleteInfluencerLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfluencerLocation>>,
    TError,
    { locationId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfluencerLocation>>,
  TError,
  { locationId: number },
  TContext
> => {
  return useMutation(getDeleteInfluencerLocationMutationOptions(options));
};

export const getListInfluencerLocationImagesUrl = (locationId: number) => {
  return `/api/v1/user/influencer-locations/${locationId}/images`;
};

export const listInfluencerLocationImages = async (
  locationId: number,
  options?: RequestInit,
): Promise<InfluencerLocationImage[]> => {
  return customFetch<InfluencerLocationImage[]>(
    getListInfluencerLocationImagesUrl(locationId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInfluencerLocationImagesQueryKey = (locationId: number) => {
  return [`/api/v1/user/influencer-locations/${locationId}/images`] as const;
};

export const getListInfluencerLocationImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInfluencerLocationImages>>,
  TError = ErrorType<unknown>,
>(
  locationId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listInfluencerLocationImages>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListInfluencerLocationImagesQueryKey(locationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInfluencerLocationImages>>
  > = ({ signal }) =>
    listInfluencerLocationImages(locationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!locationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInfluencerLocationImages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInfluencerLocationImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInfluencerLocationImages>>
>;
export type ListInfluencerLocationImagesQueryError = ErrorType<unknown>;

export function useListInfluencerLocationImages<
  TData = Awaited<ReturnType<typeof listInfluencerLocationImages>>,
  TError = ErrorType<unknown>,
>(
  locationId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listInfluencerLocationImages>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInfluencerLocationImagesQueryOptions(
    locationId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateInfluencerLocationImageUrl = (locationId: number) => {
  return `/api/v1/user/influencer-locations/${locationId}/images`;
};

export const createInfluencerLocationImage = async (
  locationId: number,
  createInfluencerLocationImageBody: CreateInfluencerLocationImageBody,
  options?: RequestInit,
): Promise<InfluencerLocationImage> => {
  return customFetch<InfluencerLocationImage>(
    getCreateInfluencerLocationImageUrl(locationId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createInfluencerLocationImageBody),
    },
  );
};

export const getCreateInfluencerLocationImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfluencerLocationImage>>,
    TError,
    { locationId: number; data: BodyType<CreateInfluencerLocationImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInfluencerLocationImage>>,
  TError,
  { locationId: number; data: BodyType<CreateInfluencerLocationImageBody> },
  TContext
> => {
  const mutationKey = ["createInfluencerLocationImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInfluencerLocationImage>>,
    { locationId: number; data: BodyType<CreateInfluencerLocationImageBody> }
  > = (props) => {
    const { locationId, data } = props ?? {};

    return createInfluencerLocationImage(locationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInfluencerLocationImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInfluencerLocationImage>>
>;
export type CreateInfluencerLocationImageMutationBody =
  BodyType<CreateInfluencerLocationImageBody>;
export type CreateInfluencerLocationImageMutationError = ErrorType<unknown>;

export const useCreateInfluencerLocationImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInfluencerLocationImage>>,
    TError,
    { locationId: number; data: BodyType<CreateInfluencerLocationImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInfluencerLocationImage>>,
  TError,
  { locationId: number; data: BodyType<CreateInfluencerLocationImageBody> },
  TContext
> => {
  return useMutation(getCreateInfluencerLocationImageMutationOptions(options));
};

export const getReorderInfluencerLocationImagesUrl = (locationId: number) => {
  return `/api/v1/user/influencer-locations/${locationId}/images/reorder`;
};

export const reorderInfluencerLocationImages = async (
  locationId: number,
  reorderInfluencerLocationImagesBody: ReorderInfluencerLocationImagesBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getReorderInfluencerLocationImagesUrl(locationId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderInfluencerLocationImagesBody),
  });
};

export const getReorderInfluencerLocationImagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderInfluencerLocationImages>>,
    TError,
    { locationId: number; data: BodyType<ReorderInfluencerLocationImagesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderInfluencerLocationImages>>,
  TError,
  { locationId: number; data: BodyType<ReorderInfluencerLocationImagesBody> },
  TContext
> => {
  const mutationKey = ["reorderInfluencerLocationImages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderInfluencerLocationImages>>,
    { locationId: number; data: BodyType<ReorderInfluencerLocationImagesBody> }
  > = (props) => {
    const { locationId, data } = props ?? {};

    return reorderInfluencerLocationImages(locationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderInfluencerLocationImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderInfluencerLocationImages>>
>;
export type ReorderInfluencerLocationImagesMutationBody =
  BodyType<ReorderInfluencerLocationImagesBody>;
export type ReorderInfluencerLocationImagesMutationError = ErrorType<unknown>;

export const useReorderInfluencerLocationImages = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderInfluencerLocationImages>>,
    TError,
    { locationId: number; data: BodyType<ReorderInfluencerLocationImagesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderInfluencerLocationImages>>,
  TError,
  { locationId: number; data: BodyType<ReorderInfluencerLocationImagesBody> },
  TContext
> => {
  return useMutation(
    getReorderInfluencerLocationImagesMutationOptions(options),
  );
};

export const getUpdateInfluencerLocationImageUrl = (imageId: number) => {
  return `/api/v1/user/influencer-location-images/${imageId}`;
};

export const updateInfluencerLocationImage = async (
  imageId: number,
  updateInfluencerLocationImageBody: UpdateInfluencerLocationImageBody,
  options?: RequestInit,
): Promise<InfluencerLocationImage> => {
  return customFetch<InfluencerLocationImage>(
    getUpdateInfluencerLocationImageUrl(imageId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateInfluencerLocationImageBody),
    },
  );
};

export const getUpdateInfluencerLocationImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencerLocationImage>>,
    TError,
    { imageId: number; data: BodyType<UpdateInfluencerLocationImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfluencerLocationImage>>,
  TError,
  { imageId: number; data: BodyType<UpdateInfluencerLocationImageBody> },
  TContext
> => {
  const mutationKey = ["updateInfluencerLocationImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfluencerLocationImage>>,
    { imageId: number; data: BodyType<UpdateInfluencerLocationImageBody> }
  > = (props) => {
    const { imageId, data } = props ?? {};

    return updateInfluencerLocationImage(imageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfluencerLocationImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfluencerLocationImage>>
>;
export type UpdateInfluencerLocationImageMutationBody =
  BodyType<UpdateInfluencerLocationImageBody>;
export type UpdateInfluencerLocationImageMutationError = ErrorType<unknown>;

export const useUpdateInfluencerLocationImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencerLocationImage>>,
    TError,
    { imageId: number; data: BodyType<UpdateInfluencerLocationImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfluencerLocationImage>>,
  TError,
  { imageId: number; data: BodyType<UpdateInfluencerLocationImageBody> },
  TContext
> => {
  return useMutation(getUpdateInfluencerLocationImageMutationOptions(options));
};

export const getDeleteInfluencerLocationImageUrl = (imageId: number) => {
  return `/api/v1/user/influencer-location-images/${imageId}`;
};

export const deleteInfluencerLocationImage = async (
  imageId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInfluencerLocationImageUrl(imageId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInfluencerLocationImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfluencerLocationImage>>,
    TError,
    { imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInfluencerLocationImage>>,
  TError,
  { imageId: number },
  TContext
> => {
  const mutationKey = ["deleteInfluencerLocationImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInfluencerLocationImage>>,
    { imageId: number }
  > = (props) => {
    const { imageId } = props ?? {};

    return deleteInfluencerLocationImage(imageId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInfluencerLocationImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInfluencerLocationImage>>
>;

export type DeleteInfluencerLocationImageMutationError = ErrorType<unknown>;

export const useDeleteInfluencerLocationImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInfluencerLocationImage>>,
    TError,
    { imageId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInfluencerLocationImage>>,
  TError,
  { imageId: number },
  TContext
> => {
  return useMutation(getDeleteInfluencerLocationImageMutationOptions(options));
};

/**
 * @summary List all 5 risk levels (level ASC)
 */
export const getAdminListRiskLevelsUrl = () => {
  return `/api/v1/admin/risk-levels`;
};

export const adminListRiskLevels = async (
  options?: RequestInit,
): Promise<PlanContentRiskLevel[]> => {
  return customFetch<PlanContentRiskLevel[]>(getAdminListRiskLevelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListRiskLevelsQueryKey = () => {
  return [`/api/v1/admin/risk-levels`] as const;
};

export const getAdminListRiskLevelsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListRiskLevels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListRiskLevels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListRiskLevelsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListRiskLevels>>
  > = ({ signal }) => adminListRiskLevels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListRiskLevels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListRiskLevelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListRiskLevels>>
>;
export type AdminListRiskLevelsQueryError = ErrorType<unknown>;

/**
 * @summary List all 5 risk levels (level ASC)
 */

export function useAdminListRiskLevels<
  TData = Awaited<ReturnType<typeof adminListRiskLevels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListRiskLevels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListRiskLevelsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminGetRiskLevelUrl = (level: number) => {
  return `/api/v1/admin/risk-levels/${level}`;
};

export const adminGetRiskLevel = async (
  level: number,
  options?: RequestInit,
): Promise<PlanContentRiskLevel> => {
  return customFetch<PlanContentRiskLevel>(getAdminGetRiskLevelUrl(level), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetRiskLevelQueryKey = (level: number) => {
  return [`/api/v1/admin/risk-levels/${level}`] as const;
};

export const getAdminGetRiskLevelQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetRiskLevel>>,
  TError = ErrorType<unknown>,
>(
  level: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetRiskLevel>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetRiskLevelQueryKey(level);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetRiskLevel>>
  > = ({ signal }) => adminGetRiskLevel(level, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!level,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetRiskLevel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetRiskLevelQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetRiskLevel>>
>;
export type AdminGetRiskLevelQueryError = ErrorType<unknown>;

export function useAdminGetRiskLevel<
  TData = Awaited<ReturnType<typeof adminGetRiskLevel>>,
  TError = ErrorType<unknown>,
>(
  level: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetRiskLevel>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetRiskLevelQueryOptions(level, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminUpdateRiskLevelUrl = (level: number) => {
  return `/api/v1/admin/risk-levels/${level}`;
};

export const adminUpdateRiskLevel = async (
  level: number,
  adminUpdateRiskLevelBody: AdminUpdateRiskLevelBody,
  options?: RequestInit,
): Promise<PlanContentRiskLevel> => {
  return customFetch<PlanContentRiskLevel>(getAdminUpdateRiskLevelUrl(level), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminUpdateRiskLevelBody),
  });
};

export const getAdminUpdateRiskLevelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateRiskLevel>>,
    TError,
    { level: number; data: BodyType<AdminUpdateRiskLevelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateRiskLevel>>,
  TError,
  { level: number; data: BodyType<AdminUpdateRiskLevelBody> },
  TContext
> => {
  const mutationKey = ["adminUpdateRiskLevel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateRiskLevel>>,
    { level: number; data: BodyType<AdminUpdateRiskLevelBody> }
  > = (props) => {
    const { level, data } = props ?? {};

    return adminUpdateRiskLevel(level, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateRiskLevelMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateRiskLevel>>
>;
export type AdminUpdateRiskLevelMutationBody =
  BodyType<AdminUpdateRiskLevelBody>;
export type AdminUpdateRiskLevelMutationError = ErrorType<unknown>;

export const useAdminUpdateRiskLevel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateRiskLevel>>,
    TError,
    { level: number; data: BodyType<AdminUpdateRiskLevelBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateRiskLevel>>,
  TError,
  { level: number; data: BodyType<AdminUpdateRiskLevelBody> },
  TContext
> => {
  return useMutation(getAdminUpdateRiskLevelMutationOptions(options));
};

/**
 * @summary List AI Filter library entries (sortOrder ASC)
 */
export const getAdminListAiFiltersUrl = () => {
  return `/api/v1/admin/ai-filters`;
};

export const adminListAiFilters = async (
  options?: RequestInit,
): Promise<AiFilterAdmin[]> => {
  return customFetch<AiFilterAdmin[]>(getAdminListAiFiltersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListAiFiltersQueryKey = () => {
  return [`/api/v1/admin/ai-filters`] as const;
};

export const getAdminListAiFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListAiFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListAiFilters>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListAiFiltersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListAiFilters>>
  > = ({ signal }) => adminListAiFilters({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListAiFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListAiFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListAiFilters>>
>;
export type AdminListAiFiltersQueryError = ErrorType<unknown>;

/**
 * @summary List AI Filter library entries (sortOrder ASC)
 */

export function useAdminListAiFilters<
  TData = Awaited<ReturnType<typeof adminListAiFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListAiFilters>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListAiFiltersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an AI Filter library entry
 */
export const getAdminCreateAiFilterUrl = () => {
  return `/api/v1/admin/ai-filters`;
};

export const adminCreateAiFilter = async (
  createAiFilterBody: CreateAiFilterBody,
  options?: RequestInit,
): Promise<AiFilterAdmin> => {
  return customFetch<AiFilterAdmin>(getAdminCreateAiFilterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAiFilterBody),
  });
};

export const getAdminCreateAiFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateAiFilter>>,
    TError,
    { data: BodyType<CreateAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateAiFilter>>,
  TError,
  { data: BodyType<CreateAiFilterBody> },
  TContext
> => {
  const mutationKey = ["adminCreateAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateAiFilter>>,
    { data: BodyType<CreateAiFilterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateAiFilter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateAiFilter>>
>;
export type AdminCreateAiFilterMutationBody = BodyType<CreateAiFilterBody>;
export type AdminCreateAiFilterMutationError = ErrorType<unknown>;

/**
 * @summary Create an AI Filter library entry
 */
export const useAdminCreateAiFilter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateAiFilter>>,
    TError,
    { data: BodyType<CreateAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateAiFilter>>,
  TError,
  { data: BodyType<CreateAiFilterBody> },
  TContext
> => {
  return useMutation(getAdminCreateAiFilterMutationOptions(options));
};

/**
 * @summary Update an AI Filter library entry
 */
export const getAdminUpdateAiFilterUrl = (id: number) => {
  return `/api/v1/admin/ai-filters/${id}`;
};

export const adminUpdateAiFilter = async (
  id: number,
  updateAiFilterBody: UpdateAiFilterBody,
  options?: RequestInit,
): Promise<AiFilterAdmin> => {
  return customFetch<AiFilterAdmin>(getAdminUpdateAiFilterUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAiFilterBody),
  });
};

export const getAdminUpdateAiFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateAiFilter>>,
    TError,
    { id: number; data: BodyType<UpdateAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateAiFilter>>,
  TError,
  { id: number; data: BodyType<UpdateAiFilterBody> },
  TContext
> => {
  const mutationKey = ["adminUpdateAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateAiFilter>>,
    { id: number; data: BodyType<UpdateAiFilterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminUpdateAiFilter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateAiFilter>>
>;
export type AdminUpdateAiFilterMutationBody = BodyType<UpdateAiFilterBody>;
export type AdminUpdateAiFilterMutationError = ErrorType<unknown>;

/**
 * @summary Update an AI Filter library entry
 */
export const useAdminUpdateAiFilter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateAiFilter>>,
    TError,
    { id: number; data: BodyType<UpdateAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateAiFilter>>,
  TError,
  { id: number; data: BodyType<UpdateAiFilterBody> },
  TContext
> => {
  return useMutation(getAdminUpdateAiFilterMutationOptions(options));
};

/**
 * @summary Delete an AI Filter library entry
 */
export const getAdminDeleteAiFilterUrl = (id: number) => {
  return `/api/v1/admin/ai-filters/${id}`;
};

export const adminDeleteAiFilter = async (
  id: number,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getAdminDeleteAiFilterUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminDeleteAiFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteAiFilter>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteAiFilter>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminDeleteAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteAiFilter>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminDeleteAiFilter(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteAiFilter>>
>;

export type AdminDeleteAiFilterMutationError = ErrorType<unknown>;

/**
 * @summary Delete an AI Filter library entry
 */
export const useAdminDeleteAiFilter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteAiFilter>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteAiFilter>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminDeleteAiFilterMutationOptions(options));
};

/**
 * @summary Persist a new sort order for the AI Filter library
 */
export const getAdminReorderAiFiltersUrl = () => {
  return `/api/v1/admin/ai-filters/reorder`;
};

export const adminReorderAiFilters = async (
  reorderAiFiltersBody: ReorderAiFiltersBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getAdminReorderAiFiltersUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderAiFiltersBody),
  });
};

export const getAdminReorderAiFiltersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReorderAiFilters>>,
    TError,
    { data: BodyType<ReorderAiFiltersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminReorderAiFilters>>,
  TError,
  { data: BodyType<ReorderAiFiltersBody> },
  TContext
> => {
  const mutationKey = ["adminReorderAiFilters"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminReorderAiFilters>>,
    { data: BodyType<ReorderAiFiltersBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminReorderAiFilters(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminReorderAiFiltersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminReorderAiFilters>>
>;
export type AdminReorderAiFiltersMutationBody = BodyType<ReorderAiFiltersBody>;
export type AdminReorderAiFiltersMutationError = ErrorType<unknown>;

/**
 * @summary Persist a new sort order for the AI Filter library
 */
export const useAdminReorderAiFilters = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReorderAiFilters>>,
    TError,
    { data: BodyType<ReorderAiFiltersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminReorderAiFilters>>,
  TError,
  { data: BodyType<ReorderAiFiltersBody> },
  TContext
> => {
  return useMutation(getAdminReorderAiFiltersMutationOptions(options));
};

/**
 * @summary Get the global AI Filters Primary/Secondary model + resolution settings
 */
export const getAdminGetAiFilterSettingsUrl = () => {
  return `/api/v1/admin/ai-filters/settings`;
};

export const adminGetAiFilterSettings = async (
  options?: RequestInit,
): Promise<AiFilterSettingsAdmin> => {
  return customFetch<AiFilterSettingsAdmin>(getAdminGetAiFilterSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetAiFilterSettingsQueryKey = () => {
  return [`/api/v1/admin/ai-filters/settings`] as const;
};

export const getAdminGetAiFilterSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetAiFilterSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetAiFilterSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetAiFilterSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetAiFilterSettings>>
  > = ({ signal }) => adminGetAiFilterSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetAiFilterSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetAiFilterSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetAiFilterSettings>>
>;
export type AdminGetAiFilterSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get the global AI Filters Primary/Secondary model + resolution settings
 */

export function useAdminGetAiFilterSettings<
  TData = Awaited<ReturnType<typeof adminGetAiFilterSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetAiFilterSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetAiFilterSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the global AI Filters Primary/Secondary model + resolution settings
 */
export const getAdminUpdateAiFilterSettingsUrl = () => {
  return `/api/v1/admin/ai-filters/settings`;
};

export const adminUpdateAiFilterSettings = async (
  updateAiFilterSettingsBody: UpdateAiFilterSettingsBody,
  options?: RequestInit,
): Promise<AiFilterSettingsAdmin> => {
  return customFetch<AiFilterSettingsAdmin>(
    getAdminUpdateAiFilterSettingsUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateAiFilterSettingsBody),
    },
  );
};

export const getAdminUpdateAiFilterSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateAiFilterSettings>>,
    TError,
    { data: BodyType<UpdateAiFilterSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateAiFilterSettings>>,
  TError,
  { data: BodyType<UpdateAiFilterSettingsBody> },
  TContext
> => {
  const mutationKey = ["adminUpdateAiFilterSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateAiFilterSettings>>,
    { data: BodyType<UpdateAiFilterSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUpdateAiFilterSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateAiFilterSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateAiFilterSettings>>
>;
export type AdminUpdateAiFilterSettingsMutationBody =
  BodyType<UpdateAiFilterSettingsBody>;
export type AdminUpdateAiFilterSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update the global AI Filters Primary/Secondary model + resolution settings
 */
export const useAdminUpdateAiFilterSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateAiFilterSettings>>,
    TError,
    { data: BodyType<UpdateAiFilterSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateAiFilterSettings>>,
  TError,
  { data: BodyType<UpdateAiFilterSettingsBody> },
  TContext
> => {
  return useMutation(getAdminUpdateAiFilterSettingsMutationOptions(options));
};

/**
 * @summary List AI Filter library entries available to the end user (prompt omitted)
 */
export const getListAiFiltersUrl = () => {
  return `/api/v1/ai-filters`;
};

export const listAiFilters = async (
  options?: RequestInit,
): Promise<AiFilterPublic[]> => {
  return customFetch<AiFilterPublic[]>(getListAiFiltersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAiFiltersQueryKey = () => {
  return [`/api/v1/ai-filters`] as const;
};

export const getListAiFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAiFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listAiFilters>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAiFiltersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiFilters>>> = ({
    signal,
  }) => listAiFilters({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAiFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAiFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAiFilters>>
>;
export type ListAiFiltersQueryError = ErrorType<unknown>;

/**
 * @summary List AI Filter library entries available to the end user (prompt omitted)
 */

export function useListAiFilters<
  TData = Awaited<ReturnType<typeof listAiFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listAiFilters>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAiFiltersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get end-user-visible AI Filter primary model/resolution (drives credit cost preview)
 */
export const getGetAiFilterSettingsUrl = () => {
  return `/api/v1/ai-filters/settings`;
};

export const getAiFilterSettings = async (
  options?: RequestInit,
): Promise<AiFilterSettingsPublic> => {
  return customFetch<AiFilterSettingsPublic>(getGetAiFilterSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAiFilterSettingsQueryKey = () => {
  return [`/api/v1/ai-filters/settings`] as const;
};

export const getGetAiFilterSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiFilterSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAiFilterSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiFilterSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiFilterSettings>>
  > = ({ signal }) => getAiFilterSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiFilterSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAiFilterSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiFilterSettings>>
>;
export type GetAiFilterSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get end-user-visible AI Filter primary model/resolution (drives credit cost preview)
 */

export function useGetAiFilterSettings<
  TData = Awaited<ReturnType<typeof getAiFilterSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAiFilterSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAiFilterSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the calling user's own private AI Filters (with prompt).
 */
export const getListMyAiFiltersUrl = () => {
  return `/api/v1/ai-filters/mine`;
};

export const listMyAiFilters = async (
  options?: RequestInit,
): Promise<AiFilterPublic[]> => {
  return customFetch<AiFilterPublic[]>(getListMyAiFiltersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMyAiFiltersQueryKey = () => {
  return [`/api/v1/ai-filters/mine`] as const;
};

export const getListMyAiFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyAiFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listMyAiFilters>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyAiFiltersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAiFilters>>> = ({
    signal,
  }) => listMyAiFilters({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyAiFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyAiFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyAiFilters>>
>;
export type ListMyAiFiltersQueryError = ErrorType<unknown>;

/**
 * @summary List the calling user's own private AI Filters (with prompt).
 */

export function useListMyAiFilters<
  TData = Awaited<ReturnType<typeof listMyAiFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listMyAiFilters>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyAiFiltersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a private AI Filter owned by the calling user. Enforces the per-user cap.
 */
export const getCreateMyAiFilterUrl = () => {
  return `/api/v1/ai-filters/mine`;
};

export const createMyAiFilter = async (
  createUserAiFilterBody: CreateUserAiFilterBody,
  options?: RequestInit,
): Promise<AiFilterPublic> => {
  return customFetch<AiFilterPublic>(getCreateMyAiFilterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createUserAiFilterBody),
  });
};

export const getCreateMyAiFilterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMyAiFilter>>,
    TError,
    { data: BodyType<CreateUserAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMyAiFilter>>,
  TError,
  { data: BodyType<CreateUserAiFilterBody> },
  TContext
> => {
  const mutationKey = ["createMyAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMyAiFilter>>,
    { data: BodyType<CreateUserAiFilterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMyAiFilter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMyAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMyAiFilter>>
>;
export type CreateMyAiFilterMutationBody = BodyType<CreateUserAiFilterBody>;
export type CreateMyAiFilterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a private AI Filter owned by the calling user. Enforces the per-user cap.
 */
export const useCreateMyAiFilter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMyAiFilter>>,
    TError,
    { data: BodyType<CreateUserAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMyAiFilter>>,
  TError,
  { data: BodyType<CreateUserAiFilterBody> },
  TContext
> => {
  return useMutation(getCreateMyAiFilterMutationOptions(options));
};

/**
 * @summary Update one of the calling user's private AI Filters.
 */
export const getUpdateMyAiFilterUrl = (id: number) => {
  return `/api/v1/ai-filters/mine/${id}`;
};

export const updateMyAiFilter = async (
  id: number,
  updateUserAiFilterBody: UpdateUserAiFilterBody,
  options?: RequestInit,
): Promise<AiFilterPublic> => {
  return customFetch<AiFilterPublic>(getUpdateMyAiFilterUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserAiFilterBody),
  });
};

export const getUpdateMyAiFilterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyAiFilter>>,
    TError,
    { id: number; data: BodyType<UpdateUserAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyAiFilter>>,
  TError,
  { id: number; data: BodyType<UpdateUserAiFilterBody> },
  TContext
> => {
  const mutationKey = ["updateMyAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyAiFilter>>,
    { id: number; data: BodyType<UpdateUserAiFilterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMyAiFilter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyAiFilter>>
>;
export type UpdateMyAiFilterMutationBody = BodyType<UpdateUserAiFilterBody>;
export type UpdateMyAiFilterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update one of the calling user's private AI Filters.
 */
export const useUpdateMyAiFilter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyAiFilter>>,
    TError,
    { id: number; data: BodyType<UpdateUserAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyAiFilter>>,
  TError,
  { id: number; data: BodyType<UpdateUserAiFilterBody> },
  TContext
> => {
  return useMutation(getUpdateMyAiFilterMutationOptions(options));
};

/**
 * @summary Delete one of the calling user's private AI Filters.
 */
export const getDeleteMyAiFilterUrl = (id: number) => {
  return `/api/v1/ai-filters/mine/${id}`;
};

export const deleteMyAiFilter = async (
  id: number,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getDeleteMyAiFilterUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMyAiFilterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyAiFilter>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyAiFilter>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMyAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyAiFilter>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMyAiFilter(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyAiFilter>>
>;

export type DeleteMyAiFilterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete one of the calling user's private AI Filters.
 */
export const useDeleteMyAiFilter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyAiFilter>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMyAiFilter>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMyAiFilterMutationOptions(options));
};

/**
 * @summary Per-user AI Filter quotas (private-filter cap + per-day analyze cap).
 */
export const getGetAiFilterUserLimitsUrl = () => {
  return `/api/v1/ai-filters/limits`;
};

export const getAiFilterUserLimits = async (
  options?: RequestInit,
): Promise<AiFilterUserLimits> => {
  return customFetch<AiFilterUserLimits>(getGetAiFilterUserLimitsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAiFilterUserLimitsQueryKey = () => {
  return [`/api/v1/ai-filters/limits`] as const;
};

export const getGetAiFilterUserLimitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiFilterUserLimits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAiFilterUserLimits>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiFilterUserLimitsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiFilterUserLimits>>
  > = ({ signal }) => getAiFilterUserLimits({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiFilterUserLimits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAiFilterUserLimitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiFilterUserLimits>>
>;
export type GetAiFilterUserLimitsQueryError = ErrorType<unknown>;

/**
 * @summary Per-user AI Filter quotas (private-filter cap + per-day analyze cap).
 */

export function useGetAiFilterUserLimits<
  TData = Awaited<ReturnType<typeof getAiFilterUserLimits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAiFilterUserLimits>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAiFilterUserLimitsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Run the configured vision-LLM against a single image and return a one-paragraph restyle prompt the user can paste into the AI Filter prompt field. Free for the user; audited at the live AI cost rate. Rate-limited per user per day.
 */
export const getAnalyzeAiFilterImageUrl = () => {
  return `/api/v1/ai-filters/analyze`;
};

export const analyzeAiFilterImage = async (
  analyzeAiFilterImageBody: AnalyzeAiFilterImageBody,
  options?: RequestInit,
): Promise<AnalyzeAiFilterImageResponse> => {
  return customFetch<AnalyzeAiFilterImageResponse>(
    getAnalyzeAiFilterImageUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(analyzeAiFilterImageBody),
    },
  );
};

export const getAnalyzeAiFilterImageMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeAiFilterImage>>,
    TError,
    { data: BodyType<AnalyzeAiFilterImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeAiFilterImage>>,
  TError,
  { data: BodyType<AnalyzeAiFilterImageBody> },
  TContext
> => {
  const mutationKey = ["analyzeAiFilterImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeAiFilterImage>>,
    { data: BodyType<AnalyzeAiFilterImageBody> }
  > = (props) => {
    const { data } = props ?? {};

    return analyzeAiFilterImage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeAiFilterImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeAiFilterImage>>
>;
export type AnalyzeAiFilterImageMutationBody =
  BodyType<AnalyzeAiFilterImageBody>;
export type AnalyzeAiFilterImageMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Run the configured vision-LLM against a single image and return a one-paragraph restyle prompt the user can paste into the AI Filter prompt field. Free for the user; audited at the live AI cost rate. Rate-limited per user per day.
 */
export const useAnalyzeAiFilterImage = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeAiFilterImage>>,
    TError,
    { data: BodyType<AnalyzeAiFilterImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeAiFilterImage>>,
  TError,
  { data: BodyType<AnalyzeAiFilterImageBody> },
  TContext
> => {
  return useMutation(getAnalyzeAiFilterImageMutationOptions(options));
};

/**
 * @summary Per-image credit cost preview for the AI Filter flow. When `postId` is supplied, the cost is computed against the source-image-specific effective resolution + closest-supported aspect ratio. When `imageModel` / `aspectRatio` / `imageResolution` are supplied (user-selected in the Apply dialog), they override the admin defaults so the credit cost label tracks the user's selection live. Returns `configured: false` when an admin has not finished setup.
 */
export const getGetAiFilterCostUrl = (params?: GetAiFilterCostParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/ai-filters/cost?${stringifiedParams}`
    : `/api/v1/ai-filters/cost`;
};

export const getAiFilterCost = async (
  params?: GetAiFilterCostParams,
  options?: RequestInit,
): Promise<AiFilterCost> => {
  return customFetch<AiFilterCost>(getGetAiFilterCostUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAiFilterCostQueryKey = (params?: GetAiFilterCostParams) => {
  return [`/api/v1/ai-filters/cost`, ...(params ? [params] : [])] as const;
};

export const getGetAiFilterCostQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiFilterCost>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAiFilterCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getAiFilterCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiFilterCostQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiFilterCost>>> = ({
    signal,
  }) => getAiFilterCost(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiFilterCost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAiFilterCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiFilterCost>>
>;
export type GetAiFilterCostQueryError = ErrorType<unknown>;

/**
 * @summary Per-image credit cost preview for the AI Filter flow. When `postId` is supplied, the cost is computed against the source-image-specific effective resolution + closest-supported aspect ratio. When `imageModel` / `aspectRatio` / `imageResolution` are supplied (user-selected in the Apply dialog), they override the admin defaults so the credit cost label tracks the user's selection live. Returns `configured: false` when an admin has not finished setup.
 */

export function useGetAiFilterCost<
  TData = Awaited<ReturnType<typeof getAiFilterCost>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAiFilterCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getAiFilterCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAiFilterCostQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Apply an AI Filter to a Plan Content post's image. Creates a new generating Draft Post derived from the source.
 */
export const getApplyAiFilterUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/apply-ai-filter`;
};

export const applyAiFilter = async (
  id: number,
  applyAiFilterBody: ApplyAiFilterBody,
  options?: RequestInit,
): Promise<ApplyAiFilterResponse> => {
  return customFetch<ApplyAiFilterResponse>(getApplyAiFilterUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(applyAiFilterBody),
  });
};

export const getApplyAiFilterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyAiFilter>>,
    TError,
    { id: number; data: BodyType<ApplyAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyAiFilter>>,
  TError,
  { id: number; data: BodyType<ApplyAiFilterBody> },
  TContext
> => {
  const mutationKey = ["applyAiFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyAiFilter>>,
    { id: number; data: BodyType<ApplyAiFilterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return applyAiFilter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyAiFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyAiFilter>>
>;
export type ApplyAiFilterMutationBody = BodyType<ApplyAiFilterBody>;
export type ApplyAiFilterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Apply an AI Filter to a Plan Content post's image. Creates a new generating Draft Post derived from the source.
 */
export const useApplyAiFilter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyAiFilter>>,
    TError,
    { id: number; data: BodyType<ApplyAiFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyAiFilter>>,
  TError,
  { id: number; data: BodyType<ApplyAiFilterBody> },
  TContext
> => {
  return useMutation(getApplyAiFilterMutationOptions(options));
};

export const getAdminGetPlanContentSettingsUrl = () => {
  return `/api/v1/admin/plan-content-settings`;
};

export const adminGetPlanContentSettings = async (
  options?: RequestInit,
): Promise<PlanContentSettings> => {
  return customFetch<PlanContentSettings>(getAdminGetPlanContentSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetPlanContentSettingsQueryKey = () => {
  return [`/api/v1/admin/plan-content-settings`] as const;
};

export const getAdminGetPlanContentSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetPlanContentSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPlanContentSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetPlanContentSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetPlanContentSettings>>
  > = ({ signal }) =>
    adminGetPlanContentSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPlanContentSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetPlanContentSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetPlanContentSettings>>
>;
export type AdminGetPlanContentSettingsQueryError = ErrorType<unknown>;

export function useAdminGetPlanContentSettings<
  TData = Awaited<ReturnType<typeof adminGetPlanContentSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPlanContentSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetPlanContentSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminUpdatePlanContentSettingsUrl = () => {
  return `/api/v1/admin/plan-content-settings`;
};

export const adminUpdatePlanContentSettings = async (
  planContentSettingsUpdateBody: PlanContentSettingsUpdateBody,
  options?: RequestInit,
): Promise<PlanContentSettings> => {
  return customFetch<PlanContentSettings>(
    getAdminUpdatePlanContentSettingsUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentSettingsUpdateBody),
    },
  );
};

export const getAdminUpdatePlanContentSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdatePlanContentSettings>>,
    TError,
    { data: BodyType<PlanContentSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdatePlanContentSettings>>,
  TError,
  { data: BodyType<PlanContentSettingsUpdateBody> },
  TContext
> => {
  const mutationKey = ["adminUpdatePlanContentSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdatePlanContentSettings>>,
    { data: BodyType<PlanContentSettingsUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUpdatePlanContentSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdatePlanContentSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdatePlanContentSettings>>
>;
export type AdminUpdatePlanContentSettingsMutationBody =
  BodyType<PlanContentSettingsUpdateBody>;
export type AdminUpdatePlanContentSettingsMutationError = ErrorType<unknown>;

export const useAdminUpdatePlanContentSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdatePlanContentSettings>>,
    TError,
    { data: BodyType<PlanContentSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdatePlanContentSettings>>,
  TError,
  { data: BodyType<PlanContentSettingsUpdateBody> },
  TContext
> => {
  return useMutation(getAdminUpdatePlanContentSettingsMutationOptions(options));
};

/**
 * @summary Preview the resolved resolution + aspect ratio + per-image cost for a given image model
 */
export const getAdminGetPlanContentModelDefaultsUrl = (
  params: AdminGetPlanContentModelDefaultsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/plan-content-settings/model-defaults?${stringifiedParams}`
    : `/api/v1/admin/plan-content-settings/model-defaults`;
};

export const adminGetPlanContentModelDefaults = async (
  params: AdminGetPlanContentModelDefaultsParams,
  options?: RequestInit,
): Promise<PlanContentModelDefaults> => {
  return customFetch<PlanContentModelDefaults>(
    getAdminGetPlanContentModelDefaultsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetPlanContentModelDefaultsQueryKey = (
  params?: AdminGetPlanContentModelDefaultsParams,
) => {
  return [
    `/api/v1/admin/plan-content-settings/model-defaults`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetPlanContentModelDefaultsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetPlanContentModelDefaults>>,
  TError = ErrorType<unknown>,
>(
  params: AdminGetPlanContentModelDefaultsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetPlanContentModelDefaults>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminGetPlanContentModelDefaultsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetPlanContentModelDefaults>>
  > = ({ signal }) =>
    adminGetPlanContentModelDefaults(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPlanContentModelDefaults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetPlanContentModelDefaultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetPlanContentModelDefaults>>
>;
export type AdminGetPlanContentModelDefaultsQueryError = ErrorType<unknown>;

/**
 * @summary Preview the resolved resolution + aspect ratio + per-image cost for a given image model
 */

export function useAdminGetPlanContentModelDefaults<
  TData = Awaited<ReturnType<typeof adminGetPlanContentModelDefaults>>,
  TError = ErrorType<unknown>,
>(
  params: AdminGetPlanContentModelDefaultsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetPlanContentModelDefaults>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetPlanContentModelDefaultsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminGetInfluencerPhotoshootSettingsUrl = () => {
  return `/api/v1/admin/influencer-photoshoot-settings`;
};

export const adminGetInfluencerPhotoshootSettings = async (
  options?: RequestInit,
): Promise<InfluencerPhotoshootSettings> => {
  return customFetch<InfluencerPhotoshootSettings>(
    getAdminGetInfluencerPhotoshootSettingsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetInfluencerPhotoshootSettingsQueryKey = () => {
  return [`/api/v1/admin/influencer-photoshoot-settings`] as const;
};

export const getAdminGetInfluencerPhotoshootSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInfluencerPhotoshootSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInfluencerPhotoshootSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetInfluencerPhotoshootSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetInfluencerPhotoshootSettings>>
  > = ({ signal }) =>
    adminGetInfluencerPhotoshootSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInfluencerPhotoshootSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetInfluencerPhotoshootSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInfluencerPhotoshootSettings>>
>;
export type AdminGetInfluencerPhotoshootSettingsQueryError = ErrorType<unknown>;

export function useAdminGetInfluencerPhotoshootSettings<
  TData = Awaited<ReturnType<typeof adminGetInfluencerPhotoshootSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInfluencerPhotoshootSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getAdminGetInfluencerPhotoshootSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminUpdateInfluencerPhotoshootSettingsUrl = () => {
  return `/api/v1/admin/influencer-photoshoot-settings`;
};

export const adminUpdateInfluencerPhotoshootSettings = async (
  influencerPhotoshootSettingsUpdateBody: InfluencerPhotoshootSettingsUpdateBody,
  options?: RequestInit,
): Promise<InfluencerPhotoshootSettings> => {
  return customFetch<InfluencerPhotoshootSettings>(
    getAdminUpdateInfluencerPhotoshootSettingsUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(influencerPhotoshootSettingsUpdateBody),
    },
  );
};

export const getAdminUpdateInfluencerPhotoshootSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateInfluencerPhotoshootSettings>>,
    TError,
    { data: BodyType<InfluencerPhotoshootSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateInfluencerPhotoshootSettings>>,
  TError,
  { data: BodyType<InfluencerPhotoshootSettingsUpdateBody> },
  TContext
> => {
  const mutationKey = ["adminUpdateInfluencerPhotoshootSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateInfluencerPhotoshootSettings>>,
    { data: BodyType<InfluencerPhotoshootSettingsUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUpdateInfluencerPhotoshootSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateInfluencerPhotoshootSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateInfluencerPhotoshootSettings>>
>;
export type AdminUpdateInfluencerPhotoshootSettingsMutationBody =
  BodyType<InfluencerPhotoshootSettingsUpdateBody>;
export type AdminUpdateInfluencerPhotoshootSettingsMutationError =
  ErrorType<unknown>;

export const useAdminUpdateInfluencerPhotoshootSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateInfluencerPhotoshootSettings>>,
    TError,
    { data: BodyType<InfluencerPhotoshootSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateInfluencerPhotoshootSettings>>,
  TError,
  { data: BodyType<InfluencerPhotoshootSettingsUpdateBody> },
  TContext
> => {
  return useMutation(
    getAdminUpdateInfluencerPhotoshootSettingsMutationOptions(options),
  );
};

/**
 * @summary Preview the resolved resolution + aspect ratio + per-image cost for a given image model
 */
export const getAdminGetInfluencerPhotoshootModelDefaultsUrl = (
  params: AdminGetInfluencerPhotoshootModelDefaultsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/influencer-photoshoot-settings/model-defaults?${stringifiedParams}`
    : `/api/v1/admin/influencer-photoshoot-settings/model-defaults`;
};

export const adminGetInfluencerPhotoshootModelDefaults = async (
  params: AdminGetInfluencerPhotoshootModelDefaultsParams,
  options?: RequestInit,
): Promise<PlanContentModelDefaults> => {
  return customFetch<PlanContentModelDefaults>(
    getAdminGetInfluencerPhotoshootModelDefaultsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetInfluencerPhotoshootModelDefaultsQueryKey = (
  params?: AdminGetInfluencerPhotoshootModelDefaultsParams,
) => {
  return [
    `/api/v1/admin/influencer-photoshoot-settings/model-defaults`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetInfluencerPhotoshootModelDefaultsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetInfluencerPhotoshootModelDefaults>>,
  TError = ErrorType<unknown>,
>(
  params: AdminGetInfluencerPhotoshootModelDefaultsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetInfluencerPhotoshootModelDefaults>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminGetInfluencerPhotoshootModelDefaultsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetInfluencerPhotoshootModelDefaults>>
  > = ({ signal }) =>
    adminGetInfluencerPhotoshootModelDefaults(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetInfluencerPhotoshootModelDefaults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetInfluencerPhotoshootModelDefaultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetInfluencerPhotoshootModelDefaults>>
>;
export type AdminGetInfluencerPhotoshootModelDefaultsQueryError =
  ErrorType<unknown>;

/**
 * @summary Preview the resolved resolution + aspect ratio + per-image cost for a given image model
 */

export function useAdminGetInfluencerPhotoshootModelDefaults<
  TData = Awaited<ReturnType<typeof adminGetInfluencerPhotoshootModelDefaults>>,
  TError = ErrorType<unknown>,
>(
  params: AdminGetInfluencerPhotoshootModelDefaultsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetInfluencerPhotoshootModelDefaults>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetInfluencerPhotoshootModelDefaultsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Influencer Photoshoot — one batched LLM call returns N caption variants, then N images are generated. Returns the array of new draft posts (in `generating` state).
 */
export const getPlanContentInfluencerPhotoshootUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/influencer-photoshoot`;
};

export const planContentInfluencerPhotoshoot = async (
  id: number,
  influencerPhotoshootRequestBody?: InfluencerPhotoshootRequestBody,
  options?: RequestInit,
): Promise<PlanContentPost[]> => {
  return customFetch<PlanContentPost[]>(
    getPlanContentInfluencerPhotoshootUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(influencerPhotoshootRequestBody),
    },
  );
};

export const getPlanContentInfluencerPhotoshootMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentInfluencerPhotoshoot>>,
    TError,
    { id: number; data: BodyType<InfluencerPhotoshootRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentInfluencerPhotoshoot>>,
  TError,
  { id: number; data: BodyType<InfluencerPhotoshootRequestBody> },
  TContext
> => {
  const mutationKey = ["planContentInfluencerPhotoshoot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentInfluencerPhotoshoot>>,
    { id: number; data: BodyType<InfluencerPhotoshootRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentInfluencerPhotoshoot(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentInfluencerPhotoshootMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentInfluencerPhotoshoot>>
>;
export type PlanContentInfluencerPhotoshootMutationBody =
  BodyType<InfluencerPhotoshootRequestBody>;
export type PlanContentInfluencerPhotoshootMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Influencer Photoshoot — one batched LLM call returns N caption variants, then N images are generated. Returns the array of new draft posts (in `generating` state).
 */
export const usePlanContentInfluencerPhotoshoot = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentInfluencerPhotoshoot>>,
    TError,
    { id: number; data: BodyType<InfluencerPhotoshootRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentInfluencerPhotoshoot>>,
  TError,
  { id: number; data: BodyType<InfluencerPhotoshootRequestBody> },
  TContext
> => {
  return useMutation(
    getPlanContentInfluencerPhotoshootMutationOptions(options),
  );
};

/**
 * @summary Per-image and total cost preview for the Influencer Photoshoot flow
 */
export const getPlanContentInfluencerPhotoshootCostUrl = (
  id: number,
  params?: PlanContentInfluencerPhotoshootCostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/plan-content/posts/${id}/influencer-photoshoot/cost?${stringifiedParams}`
    : `/api/v1/plan-content/posts/${id}/influencer-photoshoot/cost`;
};

export const planContentInfluencerPhotoshootCost = async (
  id: number,
  params?: PlanContentInfluencerPhotoshootCostParams,
  options?: RequestInit,
): Promise<InfluencerPhotoshootCost> => {
  return customFetch<InfluencerPhotoshootCost>(
    getPlanContentInfluencerPhotoshootCostUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentInfluencerPhotoshootCostQueryKey = (
  id: number,
  params?: PlanContentInfluencerPhotoshootCostParams,
) => {
  return [
    `/api/v1/plan-content/posts/${id}/influencer-photoshoot/cost`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlanContentInfluencerPhotoshootCostQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentInfluencerPhotoshootCost>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: PlanContentInfluencerPhotoshootCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentInfluencerPhotoshootCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlanContentInfluencerPhotoshootCostQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentInfluencerPhotoshootCost>>
  > = ({ signal }) =>
    planContentInfluencerPhotoshootCost(id, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentInfluencerPhotoshootCost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentInfluencerPhotoshootCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentInfluencerPhotoshootCost>>
>;
export type PlanContentInfluencerPhotoshootCostQueryError = ErrorType<unknown>;

/**
 * @summary Per-image and total cost preview for the Influencer Photoshoot flow
 */

export function usePlanContentInfluencerPhotoshootCost<
  TData = Awaited<ReturnType<typeof planContentInfluencerPhotoshootCost>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: PlanContentInfluencerPhotoshootCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentInfluencerPhotoshootCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentInfluencerPhotoshootCostQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminGetPartyPhotoshootSettingsUrl = () => {
  return `/api/v1/admin/party-photoshoot-settings`;
};

export const adminGetPartyPhotoshootSettings = async (
  options?: RequestInit,
): Promise<PartyPhotoshootSettings> => {
  return customFetch<PartyPhotoshootSettings>(
    getAdminGetPartyPhotoshootSettingsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetPartyPhotoshootSettingsQueryKey = () => {
  return [`/api/v1/admin/party-photoshoot-settings`] as const;
};

export const getAdminGetPartyPhotoshootSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetPartyPhotoshootSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPartyPhotoshootSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetPartyPhotoshootSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetPartyPhotoshootSettings>>
  > = ({ signal }) =>
    adminGetPartyPhotoshootSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPartyPhotoshootSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetPartyPhotoshootSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetPartyPhotoshootSettings>>
>;
export type AdminGetPartyPhotoshootSettingsQueryError = ErrorType<unknown>;

export function useAdminGetPartyPhotoshootSettings<
  TData = Awaited<ReturnType<typeof adminGetPartyPhotoshootSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPartyPhotoshootSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetPartyPhotoshootSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminUpdatePartyPhotoshootSettingsUrl = () => {
  return `/api/v1/admin/party-photoshoot-settings`;
};

export const adminUpdatePartyPhotoshootSettings = async (
  partyPhotoshootSettingsUpdateBody: PartyPhotoshootSettingsUpdateBody,
  options?: RequestInit,
): Promise<PartyPhotoshootSettings> => {
  return customFetch<PartyPhotoshootSettings>(
    getAdminUpdatePartyPhotoshootSettingsUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(partyPhotoshootSettingsUpdateBody),
    },
  );
};

export const getAdminUpdatePartyPhotoshootSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdatePartyPhotoshootSettings>>,
    TError,
    { data: BodyType<PartyPhotoshootSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdatePartyPhotoshootSettings>>,
  TError,
  { data: BodyType<PartyPhotoshootSettingsUpdateBody> },
  TContext
> => {
  const mutationKey = ["adminUpdatePartyPhotoshootSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdatePartyPhotoshootSettings>>,
    { data: BodyType<PartyPhotoshootSettingsUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUpdatePartyPhotoshootSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdatePartyPhotoshootSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdatePartyPhotoshootSettings>>
>;
export type AdminUpdatePartyPhotoshootSettingsMutationBody =
  BodyType<PartyPhotoshootSettingsUpdateBody>;
export type AdminUpdatePartyPhotoshootSettingsMutationError =
  ErrorType<unknown>;

export const useAdminUpdatePartyPhotoshootSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdatePartyPhotoshootSettings>>,
    TError,
    { data: BodyType<PartyPhotoshootSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdatePartyPhotoshootSettings>>,
  TError,
  { data: BodyType<PartyPhotoshootSettingsUpdateBody> },
  TContext
> => {
  return useMutation(
    getAdminUpdatePartyPhotoshootSettingsMutationOptions(options),
  );
};

/**
 * @summary Preview the resolved resolution + aspect ratio + per-image cost for a given image model (Party Photoshoot)
 */
export const getAdminGetPartyPhotoshootModelDefaultsUrl = (
  params: AdminGetPartyPhotoshootModelDefaultsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/party-photoshoot-settings/model-defaults?${stringifiedParams}`
    : `/api/v1/admin/party-photoshoot-settings/model-defaults`;
};

export const adminGetPartyPhotoshootModelDefaults = async (
  params: AdminGetPartyPhotoshootModelDefaultsParams,
  options?: RequestInit,
): Promise<PlanContentModelDefaults> => {
  return customFetch<PlanContentModelDefaults>(
    getAdminGetPartyPhotoshootModelDefaultsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetPartyPhotoshootModelDefaultsQueryKey = (
  params?: AdminGetPartyPhotoshootModelDefaultsParams,
) => {
  return [
    `/api/v1/admin/party-photoshoot-settings/model-defaults`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetPartyPhotoshootModelDefaultsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetPartyPhotoshootModelDefaults>>,
  TError = ErrorType<unknown>,
>(
  params: AdminGetPartyPhotoshootModelDefaultsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetPartyPhotoshootModelDefaults>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminGetPartyPhotoshootModelDefaultsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetPartyPhotoshootModelDefaults>>
  > = ({ signal }) =>
    adminGetPartyPhotoshootModelDefaults(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetPartyPhotoshootModelDefaults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetPartyPhotoshootModelDefaultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetPartyPhotoshootModelDefaults>>
>;
export type AdminGetPartyPhotoshootModelDefaultsQueryError = ErrorType<unknown>;

/**
 * @summary Preview the resolved resolution + aspect ratio + per-image cost for a given image model (Party Photoshoot)
 */

export function useAdminGetPartyPhotoshootModelDefaults<
  TData = Awaited<ReturnType<typeof adminGetPartyPhotoshootModelDefaults>>,
  TError = ErrorType<unknown>,
>(
  params: AdminGetPartyPhotoshootModelDefaultsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof adminGetPartyPhotoshootModelDefaults>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetPartyPhotoshootModelDefaultsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Party Photoshoot — one batched LLM call returns N caption variants for a party-lineage post, then N group images are generated. Returns the array of new draft posts (in `generating` state).
 */
export const getPlanContentPartyPhotoshootUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/party-photoshoot`;
};

export const planContentPartyPhotoshoot = async (
  id: number,
  partyPhotoshootRequestBody?: PartyPhotoshootRequestBody,
  options?: RequestInit,
): Promise<PlanContentPost[]> => {
  return customFetch<PlanContentPost[]>(getPlanContentPartyPhotoshootUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(partyPhotoshootRequestBody),
  });
};

export const getPlanContentPartyPhotoshootMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyPhotoshoot>>,
    TError,
    { id: number; data: BodyType<PartyPhotoshootRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentPartyPhotoshoot>>,
  TError,
  { id: number; data: BodyType<PartyPhotoshootRequestBody> },
  TContext
> => {
  const mutationKey = ["planContentPartyPhotoshoot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentPartyPhotoshoot>>,
    { id: number; data: BodyType<PartyPhotoshootRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentPartyPhotoshoot(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentPartyPhotoshootMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentPartyPhotoshoot>>
>;
export type PlanContentPartyPhotoshootMutationBody =
  BodyType<PartyPhotoshootRequestBody>;
export type PlanContentPartyPhotoshootMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Party Photoshoot — one batched LLM call returns N caption variants for a party-lineage post, then N group images are generated. Returns the array of new draft posts (in `generating` state).
 */
export const usePlanContentPartyPhotoshoot = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyPhotoshoot>>,
    TError,
    { id: number; data: BodyType<PartyPhotoshootRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentPartyPhotoshoot>>,
  TError,
  { id: number; data: BodyType<PartyPhotoshootRequestBody> },
  TContext
> => {
  return useMutation(getPlanContentPartyPhotoshootMutationOptions(options));
};

/**
 * @summary Per-image and total cost preview for the Party Photoshoot flow
 */
export const getPlanContentPartyPhotoshootCostUrl = (
  id: number,
  params?: PlanContentPartyPhotoshootCostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/plan-content/posts/${id}/party-photoshoot/cost?${stringifiedParams}`
    : `/api/v1/plan-content/posts/${id}/party-photoshoot/cost`;
};

export const planContentPartyPhotoshootCost = async (
  id: number,
  params?: PlanContentPartyPhotoshootCostParams,
  options?: RequestInit,
): Promise<PartyPhotoshootCost> => {
  return customFetch<PartyPhotoshootCost>(
    getPlanContentPartyPhotoshootCostUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentPartyPhotoshootCostQueryKey = (
  id: number,
  params?: PlanContentPartyPhotoshootCostParams,
) => {
  return [
    `/api/v1/plan-content/posts/${id}/party-photoshoot/cost`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlanContentPartyPhotoshootCostQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentPartyPhotoshootCost>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: PlanContentPartyPhotoshootCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentPartyPhotoshootCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlanContentPartyPhotoshootCostQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentPartyPhotoshootCost>>
  > = ({ signal }) =>
    planContentPartyPhotoshootCost(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentPartyPhotoshootCost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentPartyPhotoshootCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentPartyPhotoshootCost>>
>;
export type PlanContentPartyPhotoshootCostQueryError = ErrorType<unknown>;

/**
 * @summary Per-image and total cost preview for the Party Photoshoot flow
 */

export function usePlanContentPartyPhotoshootCost<
  TData = Awaited<ReturnType<typeof planContentPartyPhotoshootCost>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: PlanContentPartyPhotoshootCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentPartyPhotoshootCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentPartyPhotoshootCostQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Kick off a Generate Posts run (1 LLM call → N parallel image generations)
 */
export const getPlanContentGenerateUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/generate`;
};

export const planContentGenerate = async (
  id: number,
  planContentGenerateBody: PlanContentGenerateBody,
  options?: RequestInit,
): Promise<PlanContentGenerateResponse> => {
  return customFetch<PlanContentGenerateResponse>(
    getPlanContentGenerateUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentGenerateBody),
    },
  );
};

export const getPlanContentGenerateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentGenerate>>,
    TError,
    { id: number; data: BodyType<PlanContentGenerateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentGenerate>>,
  TError,
  { id: number; data: BodyType<PlanContentGenerateBody> },
  TContext
> => {
  const mutationKey = ["planContentGenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentGenerate>>,
    { id: number; data: BodyType<PlanContentGenerateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentGenerate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentGenerate>>
>;
export type PlanContentGenerateMutationBody = BodyType<PlanContentGenerateBody>;
export type PlanContentGenerateMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Kick off a Generate Posts run (1 LLM call → N parallel image generations)
 */
export const usePlanContentGenerate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentGenerate>>,
    TError,
    { id: number; data: BodyType<PlanContentGenerateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentGenerate>>,
  TError,
  { id: number; data: BodyType<PlanContentGenerateBody> },
  TContext
> => {
  return useMutation(getPlanContentGenerateMutationOptions(options));
};

/**
 * @summary List the current user's plan content posts for this influencer (newest first)
 */
export const getPlanContentListPostsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/posts`;
};

export const planContentListPosts = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentPost[]> => {
  return customFetch<PlanContentPost[]>(getPlanContentListPostsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getPlanContentListPostsQueryKey = (id: number) => {
  return [`/api/v1/influencers/${id}/plan-content/posts`] as const;
};

export const getPlanContentListPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentListPosts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListPosts>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentListPostsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentListPosts>>
  > = ({ signal }) => planContentListPosts(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentListPosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentListPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentListPosts>>
>;
export type PlanContentListPostsQueryError = ErrorType<unknown>;

/**
 * @summary List the current user's plan content posts for this influencer (newest first)
 */

export function usePlanContentListPosts<
  TData = Awaited<ReturnType<typeof planContentListPosts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListPosts>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentListPostsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List edits / upscales whose lineage origin is one of this influencer's plan content posts. Powers the "Show Edited Content Related to photoshoot outputs" toggle.
 */
export const getPlanContentListEditedDescendantsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/edited-descendants`;
};

export const planContentListEditedDescendants = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentEditedDescendant[]> => {
  return customFetch<PlanContentEditedDescendant[]>(
    getPlanContentListEditedDescendantsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentListEditedDescendantsQueryKey = (id: number) => {
  return [`/api/v1/influencers/${id}/plan-content/edited-descendants`] as const;
};

export const getPlanContentListEditedDescendantsQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentListEditedDescendants>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListEditedDescendants>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentListEditedDescendantsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentListEditedDescendants>>
  > = ({ signal }) =>
    planContentListEditedDescendants(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentListEditedDescendants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentListEditedDescendantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentListEditedDescendants>>
>;
export type PlanContentListEditedDescendantsQueryError = ErrorType<unknown>;

/**
 * @summary List edits / upscales whose lineage origin is one of this influencer's plan content posts. Powers the "Show Edited Content Related to photoshoot outputs" toggle.
 */

export function usePlanContentListEditedDescendants<
  TData = Awaited<ReturnType<typeof planContentListEditedDescendants>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListEditedDescendants>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentListEditedDescendantsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Soft-delete an edited descendant (sets hiddenAt on the underlying edit_history / upscale_history row).
 */
export const getPlanContentDeleteEditedDescendantUrl = (
  source: "edit" | "upscale",
  id: number,
) => {
  return `/api/v1/plan-content/edited-descendant/${source}/${id}`;
};

export const planContentDeleteEditedDescendant = async (
  source: "edit" | "upscale",
  id: number,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(
    getPlanContentDeleteEditedDescendantUrl(source, id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getPlanContentDeleteEditedDescendantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDeleteEditedDescendant>>,
    TError,
    { source: "edit" | "upscale"; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentDeleteEditedDescendant>>,
  TError,
  { source: "edit" | "upscale"; id: number },
  TContext
> => {
  const mutationKey = ["planContentDeleteEditedDescendant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentDeleteEditedDescendant>>,
    { source: "edit" | "upscale"; id: number }
  > = (props) => {
    const { source, id } = props ?? {};

    return planContentDeleteEditedDescendant(source, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentDeleteEditedDescendantMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentDeleteEditedDescendant>>
>;

export type PlanContentDeleteEditedDescendantMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete an edited descendant (sets hiddenAt on the underlying edit_history / upscale_history row).
 */
export const usePlanContentDeleteEditedDescendant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDeleteEditedDescendant>>,
    TError,
    { source: "edit" | "upscale"; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentDeleteEditedDescendant>>,
  TError,
  { source: "edit" | "upscale"; id: number },
  TContext
> => {
  return useMutation(
    getPlanContentDeleteEditedDescendantMutationOptions(options),
  );
};

/**
 * @summary Promote an edited descendant into a real plan_content_posts row that inherits caption / first comment / hashtags from its origin post. Optionally approves it in one step (drag-to-approved).
 */
export const getPlanContentCreatePostFromDescendantUrl = () => {
  return `/api/v1/plan-content/from-descendant`;
};

export const planContentCreatePostFromDescendant = async (
  planContentCreatePostFromDescendantBody: PlanContentCreatePostFromDescendantBody,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(
    getPlanContentCreatePostFromDescendantUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentCreatePostFromDescendantBody),
    },
  );
};

export const getPlanContentCreatePostFromDescendantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCreatePostFromDescendant>>,
    TError,
    { data: BodyType<PlanContentCreatePostFromDescendantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentCreatePostFromDescendant>>,
  TError,
  { data: BodyType<PlanContentCreatePostFromDescendantBody> },
  TContext
> => {
  const mutationKey = ["planContentCreatePostFromDescendant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentCreatePostFromDescendant>>,
    { data: BodyType<PlanContentCreatePostFromDescendantBody> }
  > = (props) => {
    const { data } = props ?? {};

    return planContentCreatePostFromDescendant(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentCreatePostFromDescendantMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentCreatePostFromDescendant>>
>;
export type PlanContentCreatePostFromDescendantMutationBody =
  BodyType<PlanContentCreatePostFromDescendantBody>;
export type PlanContentCreatePostFromDescendantMutationError =
  ErrorType<unknown>;

/**
 * @summary Promote an edited descendant into a real plan_content_posts row that inherits caption / first comment / hashtags from its origin post. Optionally approves it in one step (drag-to-approved).
 */
export const usePlanContentCreatePostFromDescendant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCreatePostFromDescendant>>,
    TError,
    { data: BodyType<PlanContentCreatePostFromDescendantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentCreatePostFromDescendant>>,
  TError,
  { data: BodyType<PlanContentCreatePostFromDescendantBody> },
  TContext
> => {
  return useMutation(
    getPlanContentCreatePostFromDescendantMutationOptions(options),
  );
};

export const getPlanContentDeletePostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}`;
};

export const planContentDeletePost = async (
  id: number,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getPlanContentDeletePostUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getPlanContentDeletePostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDeletePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentDeletePost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["planContentDeletePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentDeletePost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return planContentDeletePost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentDeletePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentDeletePost>>
>;

export type PlanContentDeletePostMutationError = ErrorType<unknown>;

export const usePlanContentDeletePost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDeletePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentDeletePost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPlanContentDeletePostMutationOptions(options));
};

/**
 * @summary Run a fresh single-post LLM + image pipeline; result is added as a new card (original is NOT replaced)
 */
export const getPlanContentRegeneratePostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/regenerate`;
};

export const planContentRegeneratePost = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentRegeneratePostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPlanContentRegeneratePostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentRegeneratePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentRegeneratePost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["planContentRegeneratePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentRegeneratePost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return planContentRegeneratePost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentRegeneratePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentRegeneratePost>>
>;

export type PlanContentRegeneratePostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Run a fresh single-post LLM + image pipeline; result is added as a new card (original is NOT replaced)
 */
export const usePlanContentRegeneratePost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentRegeneratePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentRegeneratePost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPlanContentRegeneratePostMutationOptions(options));
};

/**
 * @summary Retry image generation on a FAILED post using the same image_prompt (no new LLM call)
 */
export const getPlanContentRetryPostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/retry`;
};

export const planContentRetryPost = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentRetryPostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPlanContentRetryPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentRetryPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentRetryPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["planContentRetryPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentRetryPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return planContentRetryPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentRetryPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentRetryPost>>
>;

export type PlanContentRetryPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Retry image generation on a FAILED post using the same image_prompt (no new LLM call)
 */
export const usePlanContentRetryPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentRetryPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentRetryPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPlanContentRetryPostMutationOptions(options));
};

/**
 * @summary Plan Content Dress — creates a NEW post (alongside the original) by re-dressing the source image with an outfit description (the post's stored description, or the user-supplied override). Uses the admin-configured Plan Content Dress prompt + models. Original post is never mutated. Charges credits on success only. Optional `selectedViews` chooses which body-proportion views (front/back) to send as references. Optional `outfitDescriptionOverride` lets the user edit the outfit description in the dialog without mutating the source post.
 */
export const getPlanContentDressPostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/dress`;
};

export const planContentDressPost = async (
  id: number,
  planContentDressBody?: PlanContentDressBody,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentDressPostUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(planContentDressBody),
  });
};

export const getPlanContentDressPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentDressBody> },
  TContext
> => {
  const mutationKey = ["planContentDressPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentDressPost>>,
    { id: number; data: BodyType<PlanContentDressBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentDressPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentDressPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentDressPost>>
>;
export type PlanContentDressPostMutationBody = BodyType<PlanContentDressBody>;
export type PlanContentDressPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Plan Content Dress — creates a NEW post (alongside the original) by re-dressing the source image with an outfit description (the post's stored description, or the user-supplied override). Uses the admin-configured Plan Content Dress prompt + models. Original post is never mutated. Charges credits on success only. Optional `selectedViews` chooses which body-proportion views (front/back) to send as references. Optional `outfitDescriptionOverride` lets the user edit the outfit description in the dialog without mutating the source post.
 */
export const usePlanContentDressPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentDressBody> },
  TContext
> => {
  return useMutation(getPlanContentDressPostMutationOptions(options));
};

/**
 * @summary Body Smash — creates a NEW post (alongside the original) regenerating the image with the influencer's body proportion view(s) as a body-shape guide. Pose, framing, lighting, clothing, and expression are preserved. The new post is tagged with bodySmashFromPostId. Charges credits on success only. `selectedViews` picks which uploaded views to send (must include at least one).
 */
export const getPlanContentBodySmashPostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/body-smash`;
};

export const planContentBodySmashPost = async (
  id: number,
  planContentBodyReferenceBody: PlanContentBodyReferenceBody,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentBodySmashPostUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(planContentBodyReferenceBody),
  });
};

export const getPlanContentBodySmashPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentBodySmashPost>>,
    TError,
    { id: number; data: BodyType<PlanContentBodyReferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentBodySmashPost>>,
  TError,
  { id: number; data: BodyType<PlanContentBodyReferenceBody> },
  TContext
> => {
  const mutationKey = ["planContentBodySmashPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentBodySmashPost>>,
    { id: number; data: BodyType<PlanContentBodyReferenceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentBodySmashPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentBodySmashPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentBodySmashPost>>
>;
export type PlanContentBodySmashPostMutationBody =
  BodyType<PlanContentBodyReferenceBody>;
export type PlanContentBodySmashPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Body Smash — creates a NEW post (alongside the original) regenerating the image with the influencer's body proportion view(s) as a body-shape guide. Pose, framing, lighting, clothing, and expression are preserved. The new post is tagged with bodySmashFromPostId. Charges credits on success only. `selectedViews` picks which uploaded views to send (must include at least one).
 */
export const usePlanContentBodySmashPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentBodySmashPost>>,
    TError,
    { id: number; data: BodyType<PlanContentBodyReferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentBodySmashPost>>,
  TError,
  { id: number; data: BodyType<PlanContentBodyReferenceBody> },
  TContext
> => {
  return useMutation(getPlanContentBodySmashPostMutationOptions(options));
};

/**
 * @summary Per-image credit cost preview for the Body Smash flow. Returns `configured: false` when an admin has not finished setup.
 */
export const getPlanContentGetBodySmashCostUrl = () => {
  return `/api/v1/plan-content/body-smash-cost`;
};

export const planContentGetBodySmashCost = async (
  options?: RequestInit,
): Promise<PlanContentDressCost> => {
  return customFetch<PlanContentDressCost>(
    getPlanContentGetBodySmashCostUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentGetBodySmashCostQueryKey = () => {
  return [`/api/v1/plan-content/body-smash-cost`] as const;
};

export const getPlanContentGetBodySmashCostQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentGetBodySmashCost>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof planContentGetBodySmashCost>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentGetBodySmashCostQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentGetBodySmashCost>>
  > = ({ signal }) =>
    planContentGetBodySmashCost({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentGetBodySmashCost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentGetBodySmashCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentGetBodySmashCost>>
>;
export type PlanContentGetBodySmashCostQueryError = ErrorType<unknown>;

/**
 * @summary Per-image credit cost preview for the Body Smash flow. Returns `configured: false` when an admin has not finished setup.
 */

export function usePlanContentGetBodySmashCost<
  TData = Awaited<ReturnType<typeof planContentGetBodySmashCost>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof planContentGetBodySmashCost>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentGetBodySmashCostQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Per-image credit cost preview for the Plan Content Safe-Clothes Dress flow. Used to render the cost in the confirmation dialog. Returns `configured: false` when an admin has not finished setup. Pass `postId` to resolve cost against the pet variant when the source post belongs to a pet influencer.
 */
export const getPlanContentGetDressCostUrl = (
  params?: PlanContentGetDressCostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/plan-content/dress-cost?${stringifiedParams}`
    : `/api/v1/plan-content/dress-cost`;
};

export const planContentGetDressCost = async (
  params?: PlanContentGetDressCostParams,
  options?: RequestInit,
): Promise<PlanContentDressCost> => {
  return customFetch<PlanContentDressCost>(
    getPlanContentGetDressCostUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentGetDressCostQueryKey = (
  params?: PlanContentGetDressCostParams,
) => {
  return [
    `/api/v1/plan-content/dress-cost`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlanContentGetDressCostQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentGetDressCost>>,
  TError = ErrorType<unknown>,
>(
  params?: PlanContentGetDressCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentGetDressCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentGetDressCostQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentGetDressCost>>
  > = ({ signal }) =>
    planContentGetDressCost(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentGetDressCost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentGetDressCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentGetDressCost>>
>;
export type PlanContentGetDressCostQueryError = ErrorType<unknown>;

/**
 * @summary Per-image credit cost preview for the Plan Content Safe-Clothes Dress flow. Used to render the cost in the confirmation dialog. Returns `configured: false` when an admin has not finished setup. Pass `postId` to resolve cost against the pet variant when the source post belongs to a pet influencer.
 */

export function usePlanContentGetDressCost<
  TData = Awaited<ReturnType<typeof planContentGetDressCost>>,
  TError = ErrorType<unknown>,
>(
  params?: PlanContentGetDressCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentGetDressCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentGetDressCostQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Per-image credit cost preview + max reference image cap for the Plan Content Custom Dress flow (Tab 2 of the Dress dialog). Returns `configured: false` when an admin has not finished setup. Pass `postId` to resolve cost against the pet variant when the source post belongs to a pet influencer.
 */
export const getPlanContentGetCustomDressCostUrl = (
  params?: PlanContentGetCustomDressCostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/plan-content/custom-dress-cost?${stringifiedParams}`
    : `/api/v1/plan-content/custom-dress-cost`;
};

export const planContentGetCustomDressCost = async (
  params?: PlanContentGetCustomDressCostParams,
  options?: RequestInit,
): Promise<PlanContentCustomDressCost> => {
  return customFetch<PlanContentCustomDressCost>(
    getPlanContentGetCustomDressCostUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentGetCustomDressCostQueryKey = (
  params?: PlanContentGetCustomDressCostParams,
) => {
  return [
    `/api/v1/plan-content/custom-dress-cost`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlanContentGetCustomDressCostQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentGetCustomDressCost>>,
  TError = ErrorType<unknown>,
>(
  params?: PlanContentGetCustomDressCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentGetCustomDressCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentGetCustomDressCostQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentGetCustomDressCost>>
  > = ({ signal }) =>
    planContentGetCustomDressCost(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentGetCustomDressCost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentGetCustomDressCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentGetCustomDressCost>>
>;
export type PlanContentGetCustomDressCostQueryError = ErrorType<unknown>;

/**
 * @summary Per-image credit cost preview + max reference image cap for the Plan Content Custom Dress flow (Tab 2 of the Dress dialog). Returns `configured: false` when an admin has not finished setup. Pass `postId` to resolve cost against the pet variant when the source post belongs to a pet influencer.
 */

export function usePlanContentGetCustomDressCost<
  TData = Awaited<ReturnType<typeof planContentGetCustomDressCost>>,
  TError = ErrorType<unknown>,
>(
  params?: PlanContentGetCustomDressCostParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentGetCustomDressCost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentGetCustomDressCostQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Plan Content Custom Dress — creates a NEW post (alongside the original) by re-dressing the source image with user-supplied reference clothes images plus an optional text direction, using the admin-configured Custom Dress prompt + models. Original post is never mutated. Charges credits on success only.
 */
export const getPlanContentCustomDressPostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/custom-dress`;
};

export const planContentCustomDressPost = async (
  id: number,
  planContentCustomDressBody: PlanContentCustomDressBody,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentCustomDressPostUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(planContentCustomDressBody),
  });
};

export const getPlanContentCustomDressPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCustomDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentCustomDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentCustomDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentCustomDressBody> },
  TContext
> => {
  const mutationKey = ["planContentCustomDressPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentCustomDressPost>>,
    { id: number; data: BodyType<PlanContentCustomDressBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentCustomDressPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentCustomDressPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentCustomDressPost>>
>;
export type PlanContentCustomDressPostMutationBody =
  BodyType<PlanContentCustomDressBody>;
export type PlanContentCustomDressPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Plan Content Custom Dress — creates a NEW post (alongside the original) by re-dressing the source image with user-supplied reference clothes images plus an optional text direction, using the admin-configured Custom Dress prompt + models. Original post is never mutated. Charges credits on success only.
 */
export const usePlanContentCustomDressPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCustomDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentCustomDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentCustomDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentCustomDressBody> },
  TContext
> => {
  return useMutation(getPlanContentCustomDressPostMutationOptions(options));
};

/**
 * @summary Multi-Model Party Dress — lineage probe. The Dress dialog calls this when opening on any Plan Content card. Returns isParty=true when the post (or any ancestor reached by walking dressedFromPostId / aiFilteredFromPostId / regeneratedFromPostId / lineageRootPostId) is a party post; in that case `source.positionalModels` is the ordered list of (name, positionalDescriptor, outfitText, resolvedModelProfileId, thumbnail) the dialog renders as checkboxes + per-model outfit slots. Also returns admin configuration state + per-image credit costs so the dialog can gate the Confirm button and render the live cost label without a second round-trip.
 */
export const getPlanContentPartyLineageCheckUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/party-lineage-check`;
};

export const planContentPartyLineageCheck = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentPartyLineageCheck> => {
  return customFetch<PlanContentPartyLineageCheck>(
    getPlanContentPartyLineageCheckUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentPartyLineageCheckQueryKey = (id: number) => {
  return [`/api/v1/plan-content/posts/${id}/party-lineage-check`] as const;
};

export const getPlanContentPartyLineageCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentPartyLineageCheck>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentPartyLineageCheck>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentPartyLineageCheckQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentPartyLineageCheck>>
  > = ({ signal }) =>
    planContentPartyLineageCheck(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentPartyLineageCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentPartyLineageCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentPartyLineageCheck>>
>;
export type PlanContentPartyLineageCheckQueryError = ErrorType<unknown>;

/**
 * @summary Multi-Model Party Dress — lineage probe. The Dress dialog calls this when opening on any Plan Content card. Returns isParty=true when the post (or any ancestor reached by walking dressedFromPostId / aiFilteredFromPostId / regeneratedFromPostId / lineageRootPostId) is a party post; in that case `source.positionalModels` is the ordered list of (name, positionalDescriptor, outfitText, resolvedModelProfileId, thumbnail) the dialog renders as checkboxes + per-model outfit slots. Also returns admin configuration state + per-image credit costs so the dialog can gate the Confirm button and render the live cost label without a second round-trip.
 */

export function usePlanContentPartyLineageCheck<
  TData = Awaited<ReturnType<typeof planContentPartyLineageCheck>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentPartyLineageCheck>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentPartyLineageCheckQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Task #646 — Batch variant of party-lineage-check. Accepts up to 50 post ids and returns a `{ results: { [postId]: PlanContentPartyLineageCheck } }` map so the Create Content column can resolve a whole page of cards in one round-trip instead of N. Posts the caller does not own are silently omitted; the FE treats missing keys the same way it treats a still-loading single fetch.
 */
export const getPlanContentPartyLineageCheckBatchUrl = () => {
  return `/api/v1/plan-content/party-lineage-check`;
};

export const planContentPartyLineageCheckBatch = async (
  planContentPartyLineageCheckBatchBody: PlanContentPartyLineageCheckBatchBody,
  options?: RequestInit,
): Promise<PlanContentPartyLineageCheckBatchResponse> => {
  return customFetch<PlanContentPartyLineageCheckBatchResponse>(
    getPlanContentPartyLineageCheckBatchUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentPartyLineageCheckBatchBody),
    },
  );
};

export const getPlanContentPartyLineageCheckBatchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyLineageCheckBatch>>,
    TError,
    { data: BodyType<PlanContentPartyLineageCheckBatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentPartyLineageCheckBatch>>,
  TError,
  { data: BodyType<PlanContentPartyLineageCheckBatchBody> },
  TContext
> => {
  const mutationKey = ["planContentPartyLineageCheckBatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentPartyLineageCheckBatch>>,
    { data: BodyType<PlanContentPartyLineageCheckBatchBody> }
  > = (props) => {
    const { data } = props ?? {};

    return planContentPartyLineageCheckBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentPartyLineageCheckBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentPartyLineageCheckBatch>>
>;
export type PlanContentPartyLineageCheckBatchMutationBody =
  BodyType<PlanContentPartyLineageCheckBatchBody>;
export type PlanContentPartyLineageCheckBatchMutationError = ErrorType<unknown>;

/**
 * @summary Task #646 — Batch variant of party-lineage-check. Accepts up to 50 post ids and returns a `{ results: { [postId]: PlanContentPartyLineageCheck } }` map so the Create Content column can resolve a whole page of cards in one round-trip instead of N. Posts the caller does not own are silently omitted; the FE treats missing keys the same way it treats a still-loading single fetch.
 */
export const usePlanContentPartyLineageCheckBatch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyLineageCheckBatch>>,
    TError,
    { data: BodyType<PlanContentPartyLineageCheckBatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentPartyLineageCheckBatch>>,
  TError,
  { data: BodyType<PlanContentPartyLineageCheckBatchBody> },
  TContext
> => {
  return useMutation(
    getPlanContentPartyLineageCheckBatchMutationOptions(options),
  );
};

/**
 * @summary Multi-Model Party Dress — Safe Clothes tab. Creates a NEW post (alongside the original) re-dressing the party scene using each model's current (or user-edited) outfit text, with admin-configured party prompts + model. Original post is never mutated; credits are charged on success only.
 */
export const getPlanContentPartyDressPostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/party-dress`;
};

export const planContentPartyDressPost = async (
  id: number,
  planContentPartyDressBody: PlanContentPartyDressBody,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentPartyDressPostUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(planContentPartyDressBody),
  });
};

export const getPlanContentPartyDressPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentPartyDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentPartyDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentPartyDressBody> },
  TContext
> => {
  const mutationKey = ["planContentPartyDressPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentPartyDressPost>>,
    { id: number; data: BodyType<PlanContentPartyDressBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentPartyDressPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentPartyDressPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentPartyDressPost>>
>;
export type PlanContentPartyDressPostMutationBody =
  BodyType<PlanContentPartyDressBody>;
export type PlanContentPartyDressPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Multi-Model Party Dress — Safe Clothes tab. Creates a NEW post (alongside the original) re-dressing the party scene using each model's current (or user-edited) outfit text, with admin-configured party prompts + model. Original post is never mutated; credits are charged on success only.
 */
export const usePlanContentPartyDressPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentPartyDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentPartyDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentPartyDressBody> },
  TContext
> => {
  return useMutation(getPlanContentPartyDressPostMutationOptions(options));
};

/**
 * @summary Multi-Model Party Dress — Provide Reference Clothes tab. Same as party-dress but each selected model may attach 1..N reference clothes images (N from admin partyCustomDressMaxRefImagesPerModel, hard-capped at 2).
 */
export const getPlanContentPartyCustomDressPostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/party-custom-dress`;
};

export const planContentPartyCustomDressPost = async (
  id: number,
  planContentPartyCustomDressBody: PlanContentPartyCustomDressBody,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(
    getPlanContentPartyCustomDressPostUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentPartyCustomDressBody),
    },
  );
};

export const getPlanContentPartyCustomDressPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyCustomDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentPartyCustomDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentPartyCustomDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentPartyCustomDressBody> },
  TContext
> => {
  const mutationKey = ["planContentPartyCustomDressPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentPartyCustomDressPost>>,
    { id: number; data: BodyType<PlanContentPartyCustomDressBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentPartyCustomDressPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentPartyCustomDressPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentPartyCustomDressPost>>
>;
export type PlanContentPartyCustomDressPostMutationBody =
  BodyType<PlanContentPartyCustomDressBody>;
export type PlanContentPartyCustomDressPostMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Multi-Model Party Dress — Provide Reference Clothes tab. Same as party-dress but each selected model may attach 1..N reference clothes images (N from admin partyCustomDressMaxRefImagesPerModel, hard-capped at 2).
 */
export const usePlanContentPartyCustomDressPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentPartyCustomDressPost>>,
    TError,
    { id: number; data: BodyType<PlanContentPartyCustomDressBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentPartyCustomDressPost>>,
  TError,
  { id: number; data: BodyType<PlanContentPartyCustomDressBody> },
  TContext
> => {
  return useMutation(
    getPlanContentPartyCustomDressPostMutationOptions(options),
  );
};

/**
 * @summary Inline-edit the LLM-generated post copy (caption, first comment, hashtags) on a draft card.
 */
export const getPlanContentUpdatePostTextUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/text`;
};

export const planContentUpdatePostText = async (
  id: number,
  planContentPostTextUpdate: PlanContentPostTextUpdate,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentUpdatePostTextUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(planContentPostTextUpdate),
  });
};

export const getPlanContentUpdatePostTextMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUpdatePostText>>,
    TError,
    { id: number; data: BodyType<PlanContentPostTextUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentUpdatePostText>>,
  TError,
  { id: number; data: BodyType<PlanContentPostTextUpdate> },
  TContext
> => {
  const mutationKey = ["planContentUpdatePostText"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentUpdatePostText>>,
    { id: number; data: BodyType<PlanContentPostTextUpdate> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentUpdatePostText(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentUpdatePostTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentUpdatePostText>>
>;
export type PlanContentUpdatePostTextMutationBody =
  BodyType<PlanContentPostTextUpdate>;
export type PlanContentUpdatePostTextMutationError = ErrorType<unknown>;

/**
 * @summary Inline-edit the LLM-generated post copy (caption, first comment, hashtags) on a draft card.
 */
export const usePlanContentUpdatePostText = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUpdatePostText>>,
    TError,
    { id: number; data: BodyType<PlanContentPostTextUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentUpdatePostText>>,
  TError,
  { id: number; data: BodyType<PlanContentPostTextUpdate> },
  TContext
> => {
  return useMutation(getPlanContentUpdatePostTextMutationOptions(options));
};

/**
 * @summary Approve a completed Plan Content post (move it from Drafts to Approved column).
 */
export const getPlanContentApprovePostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/approve`;
};

export const planContentApprovePost = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentApprovePostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPlanContentApprovePostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentApprovePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentApprovePost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["planContentApprovePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentApprovePost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return planContentApprovePost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentApprovePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentApprovePost>>
>;

export type PlanContentApprovePostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Approve a completed Plan Content post (move it from Drafts to Approved column).
 */
export const usePlanContentApprovePost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentApprovePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentApprovePost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPlanContentApprovePostMutationOptions(options));
};

/**
 * @summary Move an approved post back to Drafts.
 */
export const getPlanContentUnapprovePostUrl = (id: number) => {
  return `/api/v1/plan-content/posts/${id}/unapprove`;
};

export const planContentUnapprovePost = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentPost> => {
  return customFetch<PlanContentPost>(getPlanContentUnapprovePostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPlanContentUnapprovePostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUnapprovePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentUnapprovePost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["planContentUnapprovePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentUnapprovePost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return planContentUnapprovePost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentUnapprovePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentUnapprovePost>>
>;

export type PlanContentUnapprovePostMutationError = ErrorType<unknown>;

/**
 * @summary Move an approved post back to Drafts.
 */
export const usePlanContentUnapprovePost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUnapprovePost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentUnapprovePost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPlanContentUnapprovePostMutationOptions(options));
};

/**
 * @summary Approve many Plan Content posts in one batched, single-transaction request. Replaces the per-post sequential approve loop. Display order is computed server-side in a single pass so the top-of-Drafts post ends up at the top of Approved.
 */
export const getPlanContentApproveBatchUrl = () => {
  return `/api/v1/plan-content/posts/approve-batch`;
};

export const planContentApproveBatch = async (
  planContentBatchLifecycleBody: PlanContentBatchLifecycleBody,
  options?: RequestInit,
): Promise<PlanContentBatchLifecycleResult> => {
  return customFetch<PlanContentBatchLifecycleResult>(
    getPlanContentApproveBatchUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentBatchLifecycleBody),
    },
  );
};

export const getPlanContentApproveBatchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentApproveBatch>>,
    TError,
    { data: BodyType<PlanContentBatchLifecycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentApproveBatch>>,
  TError,
  { data: BodyType<PlanContentBatchLifecycleBody> },
  TContext
> => {
  const mutationKey = ["planContentApproveBatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentApproveBatch>>,
    { data: BodyType<PlanContentBatchLifecycleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return planContentApproveBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentApproveBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentApproveBatch>>
>;
export type PlanContentApproveBatchMutationBody =
  BodyType<PlanContentBatchLifecycleBody>;
export type PlanContentApproveBatchMutationError = ErrorType<unknown>;

/**
 * @summary Approve many Plan Content posts in one batched, single-transaction request. Replaces the per-post sequential approve loop. Display order is computed server-side in a single pass so the top-of-Drafts post ends up at the top of Approved.
 */
export const usePlanContentApproveBatch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentApproveBatch>>,
    TError,
    { data: BodyType<PlanContentBatchLifecycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentApproveBatch>>,
  TError,
  { data: BodyType<PlanContentBatchLifecycleBody> },
  TContext
> => {
  return useMutation(getPlanContentApproveBatchMutationOptions(options));
};

/**
 * @summary Move many approved posts back to Drafts in one batched, single-transaction request. Replaces the per-post sequential unapprove loop. Display order is computed server-side so the top-of-Approved post ends up at the top of Drafts.
 */
export const getPlanContentUnapproveBatchUrl = () => {
  return `/api/v1/plan-content/posts/unapprove-batch`;
};

export const planContentUnapproveBatch = async (
  planContentBatchLifecycleBody: PlanContentBatchLifecycleBody,
  options?: RequestInit,
): Promise<PlanContentBatchLifecycleResult> => {
  return customFetch<PlanContentBatchLifecycleResult>(
    getPlanContentUnapproveBatchUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentBatchLifecycleBody),
    },
  );
};

export const getPlanContentUnapproveBatchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUnapproveBatch>>,
    TError,
    { data: BodyType<PlanContentBatchLifecycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentUnapproveBatch>>,
  TError,
  { data: BodyType<PlanContentBatchLifecycleBody> },
  TContext
> => {
  const mutationKey = ["planContentUnapproveBatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentUnapproveBatch>>,
    { data: BodyType<PlanContentBatchLifecycleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return planContentUnapproveBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentUnapproveBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentUnapproveBatch>>
>;
export type PlanContentUnapproveBatchMutationBody =
  BodyType<PlanContentBatchLifecycleBody>;
export type PlanContentUnapproveBatchMutationError = ErrorType<unknown>;

/**
 * @summary Move many approved posts back to Drafts in one batched, single-transaction request. Replaces the per-post sequential unapprove loop. Display order is computed server-side so the top-of-Approved post ends up at the top of Drafts.
 */
export const usePlanContentUnapproveBatch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUnapproveBatch>>,
    TError,
    { data: BodyType<PlanContentBatchLifecycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentUnapproveBatch>>,
  TError,
  { data: BodyType<PlanContentBatchLifecycleBody> },
  TContext
> => {
  return useMutation(getPlanContentUnapproveBatchMutationOptions(options));
};

/**
 * @summary List effective active state of every reference image in the influencer context
 */
export const getGetInfluencerReferenceImageSettingsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/reference-image-settings`;
};

export const getInfluencerReferenceImageSettings = async (
  id: number,
  options?: RequestInit,
): Promise<InfluencerReferenceImageSetting[]> => {
  return customFetch<InfluencerReferenceImageSetting[]>(
    getGetInfluencerReferenceImageSettingsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInfluencerReferenceImageSettingsQueryKey = (id: number) => {
  return [`/api/v1/influencers/${id}/reference-image-settings`] as const;
};

export const getGetInfluencerReferenceImageSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfluencerReferenceImageSettings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencerReferenceImageSettings>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInfluencerReferenceImageSettingsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInfluencerReferenceImageSettings>>
  > = ({ signal }) =>
    getInfluencerReferenceImageSettings(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfluencerReferenceImageSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInfluencerReferenceImageSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInfluencerReferenceImageSettings>>
>;
export type GetInfluencerReferenceImageSettingsQueryError = ErrorType<unknown>;

/**
 * @summary List effective active state of every reference image in the influencer context
 */

export function useGetInfluencerReferenceImageSettings<
  TData = Awaited<ReturnType<typeof getInfluencerReferenceImageSettings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencerReferenceImageSettings>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInfluencerReferenceImageSettingsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Toggle a non-primary reference image's influencer-context active state (upserts)
 */
export const getSetInfluencerReferenceImageActiveUrl = (
  id: number,
  imageId: number,
) => {
  return `/api/v1/influencers/${id}/reference-image-settings/${imageId}`;
};

export const setInfluencerReferenceImageActive = async (
  id: number,
  imageId: number,
  setInfluencerReferenceImageActiveBody: SetInfluencerReferenceImageActiveBody,
  options?: RequestInit,
): Promise<InfluencerReferenceImageSetting> => {
  return customFetch<InfluencerReferenceImageSetting>(
    getSetInfluencerReferenceImageActiveUrl(id, imageId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setInfluencerReferenceImageActiveBody),
    },
  );
};

export const getSetInfluencerReferenceImageActiveMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setInfluencerReferenceImageActive>>,
    TError,
    {
      id: number;
      imageId: number;
      data: BodyType<SetInfluencerReferenceImageActiveBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setInfluencerReferenceImageActive>>,
  TError,
  {
    id: number;
    imageId: number;
    data: BodyType<SetInfluencerReferenceImageActiveBody>;
  },
  TContext
> => {
  const mutationKey = ["setInfluencerReferenceImageActive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setInfluencerReferenceImageActive>>,
    {
      id: number;
      imageId: number;
      data: BodyType<SetInfluencerReferenceImageActiveBody>;
    }
  > = (props) => {
    const { id, imageId, data } = props ?? {};

    return setInfluencerReferenceImageActive(id, imageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetInfluencerReferenceImageActiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof setInfluencerReferenceImageActive>>
>;
export type SetInfluencerReferenceImageActiveMutationBody =
  BodyType<SetInfluencerReferenceImageActiveBody>;
export type SetInfluencerReferenceImageActiveMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Toggle a non-primary reference image's influencer-context active state (upserts)
 */
export const useSetInfluencerReferenceImageActive = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setInfluencerReferenceImageActive>>,
    TError,
    {
      id: number;
      imageId: number;
      data: BodyType<SetInfluencerReferenceImageActiveBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setInfluencerReferenceImageActive>>,
  TError,
  {
    id: number;
    imageId: number;
    data: BodyType<SetInfluencerReferenceImageActiveBody>;
  },
  TContext
> => {
  return useMutation(
    getSetInfluencerReferenceImageActiveMutationOptions(options),
  );
};

/**
 * @summary Get the per-(user, influencer) scheduling settings (slot times + IANA timezone). Returns the row, creating it lazily with sensible defaults if it does not exist yet.
 */
export const getPlanContentGetScheduleSettingsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/schedule-settings`;
};

export const planContentGetScheduleSettings = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentScheduleSettings> => {
  return customFetch<PlanContentScheduleSettings>(
    getPlanContentGetScheduleSettingsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentGetScheduleSettingsQueryKey = (id: number) => {
  return [`/api/v1/influencers/${id}/plan-content/schedule-settings`] as const;
};

export const getPlanContentGetScheduleSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentGetScheduleSettings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentGetScheduleSettings>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentGetScheduleSettingsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentGetScheduleSettings>>
  > = ({ signal }) =>
    planContentGetScheduleSettings(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentGetScheduleSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentGetScheduleSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentGetScheduleSettings>>
>;
export type PlanContentGetScheduleSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get the per-(user, influencer) scheduling settings (slot times + IANA timezone). Returns the row, creating it lazily with sensible defaults if it does not exist yet.
 */

export function usePlanContentGetScheduleSettings<
  TData = Awaited<ReturnType<typeof planContentGetScheduleSettings>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentGetScheduleSettings>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentGetScheduleSettingsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update slot times / timezone for this influencer
 */
export const getPlanContentUpdateScheduleSettingsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/schedule-settings`;
};

export const planContentUpdateScheduleSettings = async (
  id: number,
  planContentScheduleSettingsUpdateBody: PlanContentScheduleSettingsUpdateBody,
  options?: RequestInit,
): Promise<PlanContentScheduleSettings> => {
  return customFetch<PlanContentScheduleSettings>(
    getPlanContentUpdateScheduleSettingsUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentScheduleSettingsUpdateBody),
    },
  );
};

export const getPlanContentUpdateScheduleSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUpdateScheduleSettings>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduleSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentUpdateScheduleSettings>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduleSettingsUpdateBody> },
  TContext
> => {
  const mutationKey = ["planContentUpdateScheduleSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentUpdateScheduleSettings>>,
    { id: number; data: BodyType<PlanContentScheduleSettingsUpdateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentUpdateScheduleSettings(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentUpdateScheduleSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentUpdateScheduleSettings>>
>;
export type PlanContentUpdateScheduleSettingsMutationBody =
  BodyType<PlanContentScheduleSettingsUpdateBody>;
export type PlanContentUpdateScheduleSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update slot times / timezone for this influencer
 */
export const usePlanContentUpdateScheduleSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUpdateScheduleSettings>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduleSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentUpdateScheduleSettings>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduleSettingsUpdateBody> },
  TContext
> => {
  return useMutation(
    getPlanContentUpdateScheduleSettingsMutationOptions(options),
  );
};

/**
 * @summary List scheduled posts for an influencer in a date range (inclusive). Items array is ordered by position.
 */
export const getPlanContentListScheduledPostsUrl = (
  id: number,
  params: PlanContentListScheduledPostsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/influencers/${id}/plan-content/scheduled-posts?${stringifiedParams}`
    : `/api/v1/influencers/${id}/plan-content/scheduled-posts`;
};

export const planContentListScheduledPosts = async (
  id: number,
  params: PlanContentListScheduledPostsParams,
  options?: RequestInit,
): Promise<PlanContentScheduledPost[]> => {
  return customFetch<PlanContentScheduledPost[]>(
    getPlanContentListScheduledPostsUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentListScheduledPostsQueryKey = (
  id: number,
  params?: PlanContentListScheduledPostsParams,
) => {
  return [
    `/api/v1/influencers/${id}/plan-content/scheduled-posts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlanContentListScheduledPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentListScheduledPosts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params: PlanContentListScheduledPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListScheduledPosts>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlanContentListScheduledPostsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentListScheduledPosts>>
  > = ({ signal }) =>
    planContentListScheduledPosts(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentListScheduledPosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentListScheduledPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentListScheduledPosts>>
>;
export type PlanContentListScheduledPostsQueryError = ErrorType<unknown>;

/**
 * @summary List scheduled posts for an influencer in a date range (inclusive). Items array is ordered by position.
 */

export function usePlanContentListScheduledPosts<
  TData = Awaited<ReturnType<typeof planContentListScheduledPosts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params: PlanContentListScheduledPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListScheduledPosts>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentListScheduledPostsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a scheduled slot (single image or carousel). Caption / firstComment / hashtags are seeded from the primary item's approved post when omitted. Conflicts (existing slot for same date+slot) return 409 — the FE then offers merge or swap.
 */
export const getPlanContentCreateScheduledPostUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/scheduled-posts`;
};

export const planContentCreateScheduledPost = async (
  id: number,
  planContentScheduledPostCreateBody: PlanContentScheduledPostCreateBody,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getPlanContentCreateScheduledPostUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentScheduledPostCreateBody),
    },
  );
};

export const getPlanContentCreateScheduledPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCreateScheduledPost>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduledPostCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentCreateScheduledPost>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduledPostCreateBody> },
  TContext
> => {
  const mutationKey = ["planContentCreateScheduledPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentCreateScheduledPost>>,
    { id: number; data: BodyType<PlanContentScheduledPostCreateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentCreateScheduledPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentCreateScheduledPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentCreateScheduledPost>>
>;
export type PlanContentCreateScheduledPostMutationBody =
  BodyType<PlanContentScheduledPostCreateBody>;
export type PlanContentCreateScheduledPostMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Create a scheduled slot (single image or carousel). Caption / firstComment / hashtags are seeded from the primary item's approved post when omitted. Conflicts (existing slot for same date+slot) return 409 — the FE then offers merge or swap.
 */
export const usePlanContentCreateScheduledPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCreateScheduledPost>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduledPostCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentCreateScheduledPost>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduledPostCreateBody> },
  TContext
> => {
  return useMutation(getPlanContentCreateScheduledPostMutationOptions(options));
};

/**
 * @summary List all "Post immediately" (manually posted) records for an influencer, newest first.
 */
export const getPlanContentListManualPostsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/manual-posts`;
};

export const planContentListManualPosts = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentManualPost[]> => {
  return customFetch<PlanContentManualPost[]>(
    getPlanContentListManualPostsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentListManualPostsQueryKey = (id: number) => {
  return [`/api/v1/influencers/${id}/plan-content/manual-posts`] as const;
};

export const getPlanContentListManualPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentListManualPosts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListManualPosts>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentListManualPostsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentListManualPosts>>
  > = ({ signal }) =>
    planContentListManualPosts(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentListManualPosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentListManualPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentListManualPosts>>
>;
export type PlanContentListManualPostsQueryError = ErrorType<unknown>;

/**
 * @summary List all "Post immediately" (manually posted) records for an influencer, newest first.
 */

export function usePlanContentListManualPosts<
  TData = Awaited<ReturnType<typeof planContentListManualPosts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListManualPosts>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentListManualPostsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Trigger an immediate (non-scheduled) post via upload-post.com for one or more approved posts. Persists a record only after upload-post returns a job_id.
 */
export const getPlanContentCreateManualPostUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/manual-posts`;
};

export const planContentCreateManualPost = async (
  id: number,
  planContentManualPostCreateBody: PlanContentManualPostCreateBody,
  options?: RequestInit,
): Promise<PlanContentManualPost> => {
  return customFetch<PlanContentManualPost>(
    getPlanContentCreateManualPostUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentManualPostCreateBody),
    },
  );
};

export const getPlanContentCreateManualPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCreateManualPost>>,
    TError,
    { id: number; data: BodyType<PlanContentManualPostCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentCreateManualPost>>,
  TError,
  { id: number; data: BodyType<PlanContentManualPostCreateBody> },
  TContext
> => {
  const mutationKey = ["planContentCreateManualPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentCreateManualPost>>,
    { id: number; data: BodyType<PlanContentManualPostCreateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentCreateManualPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentCreateManualPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentCreateManualPost>>
>;
export type PlanContentCreateManualPostMutationBody =
  BodyType<PlanContentManualPostCreateBody>;
export type PlanContentCreateManualPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Trigger an immediate (non-scheduled) post via upload-post.com for one or more approved posts. Persists a record only after upload-post returns a job_id.
 */
export const usePlanContentCreateManualPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentCreateManualPost>>,
    TError,
    { id: number; data: BodyType<PlanContentManualPostCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentCreateManualPost>>,
  TError,
  { id: number; data: BodyType<PlanContentManualPostCreateBody> },
  TContext
> => {
  return useMutation(getPlanContentCreateManualPostMutationOptions(options));
};

/**
 * @summary Auto-assign all currently-unscheduled approved posts into the next available slots, grouping carousels by lineage root and respecting the user's selected slot ordering. Skips already-occupied slots. Returns the count of newly-created scheduled posts.
 */
export const getPlanContentAutoAssignScheduledPostsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/scheduled-posts/auto-assign`;
};

export const planContentAutoAssignScheduledPosts = async (
  id: number,
  planContentAutoAssignBody: PlanContentAutoAssignBody,
  options?: RequestInit,
): Promise<PlanContentAutoAssignResult> => {
  return customFetch<PlanContentAutoAssignResult>(
    getPlanContentAutoAssignScheduledPostsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentAutoAssignBody),
    },
  );
};

export const getPlanContentAutoAssignScheduledPostsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentAutoAssignScheduledPosts>>,
    TError,
    { id: number; data: BodyType<PlanContentAutoAssignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentAutoAssignScheduledPosts>>,
  TError,
  { id: number; data: BodyType<PlanContentAutoAssignBody> },
  TContext
> => {
  const mutationKey = ["planContentAutoAssignScheduledPosts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentAutoAssignScheduledPosts>>,
    { id: number; data: BodyType<PlanContentAutoAssignBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentAutoAssignScheduledPosts(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentAutoAssignScheduledPostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentAutoAssignScheduledPosts>>
>;
export type PlanContentAutoAssignScheduledPostsMutationBody =
  BodyType<PlanContentAutoAssignBody>;
export type PlanContentAutoAssignScheduledPostsMutationError =
  ErrorType<unknown>;

/**
 * @summary Auto-assign all currently-unscheduled approved posts into the next available slots, grouping carousels by lineage root and respecting the user's selected slot ordering. Skips already-occupied slots. Returns the count of newly-created scheduled posts.
 */
export const usePlanContentAutoAssignScheduledPosts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentAutoAssignScheduledPosts>>,
    TError,
    { id: number; data: BodyType<PlanContentAutoAssignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentAutoAssignScheduledPosts>>,
  TError,
  { id: number; data: BodyType<PlanContentAutoAssignBody> },
  TContext
> => {
  return useMutation(
    getPlanContentAutoAssignScheduledPostsMutationOptions(options),
  );
};

/**
 * @summary Update caption / first comment / hashtags on a scheduled slot (independent copy — does not mutate the source approved post).
 */
export const getPlanContentUpdateScheduledPostUrl = (id: number) => {
  return `/api/v1/plan-content/scheduled-posts/${id}`;
};

export const planContentUpdateScheduledPost = async (
  id: number,
  planContentScheduledPostUpdateBody: PlanContentScheduledPostUpdateBody,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getPlanContentUpdateScheduledPostUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentScheduledPostUpdateBody),
    },
  );
};

export const getPlanContentUpdateScheduledPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUpdateScheduledPost>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduledPostUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentUpdateScheduledPost>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduledPostUpdateBody> },
  TContext
> => {
  const mutationKey = ["planContentUpdateScheduledPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentUpdateScheduledPost>>,
    { id: number; data: BodyType<PlanContentScheduledPostUpdateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentUpdateScheduledPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentUpdateScheduledPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentUpdateScheduledPost>>
>;
export type PlanContentUpdateScheduledPostMutationBody =
  BodyType<PlanContentScheduledPostUpdateBody>;
export type PlanContentUpdateScheduledPostMutationError = ErrorType<unknown>;

/**
 * @summary Update caption / first comment / hashtags on a scheduled slot (independent copy — does not mutate the source approved post).
 */
export const usePlanContentUpdateScheduledPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentUpdateScheduledPost>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduledPostUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentUpdateScheduledPost>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduledPostUpdateBody> },
  TContext
> => {
  return useMutation(getPlanContentUpdateScheduledPostMutationOptions(options));
};

/**
 * @summary Unschedule a slot (removes the scheduled post + all carousel items). Source approved posts are NOT deleted.
 */
export const getPlanContentDeleteScheduledPostUrl = (id: number) => {
  return `/api/v1/plan-content/scheduled-posts/${id}`;
};

export const planContentDeleteScheduledPost = async (
  id: number,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(
    getPlanContentDeleteScheduledPostUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getPlanContentDeleteScheduledPostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDeleteScheduledPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentDeleteScheduledPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["planContentDeleteScheduledPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentDeleteScheduledPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return planContentDeleteScheduledPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentDeleteScheduledPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentDeleteScheduledPost>>
>;

export type PlanContentDeleteScheduledPostMutationError = ErrorType<unknown>;

/**
 * @summary Unschedule a slot (removes the scheduled post + all carousel items). Source approved posts are NOT deleted.
 */
export const usePlanContentDeleteScheduledPost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentDeleteScheduledPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentDeleteScheduledPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPlanContentDeleteScheduledPostMutationOptions(options));
};

/**
 * @summary Move a scheduled slot to a new date+slot. If the destination is occupied, behaviour is determined by `onConflict` ("error" — 409, "swap" — exchange the two slots, or "merge" — append source items into destination as a carousel).
 */
export const getPlanContentMoveScheduledPostUrl = (id: number) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/move`;
};

export const planContentMoveScheduledPost = async (
  id: number,
  planContentScheduledPostMoveBody: PlanContentScheduledPostMoveBody,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getPlanContentMoveScheduledPostUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentScheduledPostMoveBody),
    },
  );
};

export const getPlanContentMoveScheduledPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentMoveScheduledPost>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduledPostMoveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentMoveScheduledPost>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduledPostMoveBody> },
  TContext
> => {
  const mutationKey = ["planContentMoveScheduledPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentMoveScheduledPost>>,
    { id: number; data: BodyType<PlanContentScheduledPostMoveBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentMoveScheduledPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentMoveScheduledPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentMoveScheduledPost>>
>;
export type PlanContentMoveScheduledPostMutationBody =
  BodyType<PlanContentScheduledPostMoveBody>;
export type PlanContentMoveScheduledPostMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Move a scheduled slot to a new date+slot. If the destination is occupied, behaviour is determined by `onConflict` ("error" — 409, "swap" — exchange the two slots, or "merge" — append source items into destination as a carousel).
 */
export const usePlanContentMoveScheduledPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentMoveScheduledPost>>,
    TError,
    { id: number; data: BodyType<PlanContentScheduledPostMoveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentMoveScheduledPost>>,
  TError,
  { id: number; data: BodyType<PlanContentScheduledPostMoveBody> },
  TContext
> => {
  return useMutation(getPlanContentMoveScheduledPostMutationOptions(options));
};

/**
 * @summary Reorder carousel items within a scheduled slot. Body lists item ids in the desired order.
 */
export const getPlanContentReorderScheduledItemsUrl = (id: number) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/items/reorder`;
};

export const planContentReorderScheduledItems = async (
  id: number,
  planContentReorderScheduledItemsBody: PlanContentReorderScheduledItemsBody,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getPlanContentReorderScheduledItemsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentReorderScheduledItemsBody),
    },
  );
};

export const getPlanContentReorderScheduledItemsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentReorderScheduledItems>>,
    TError,
    { id: number; data: BodyType<PlanContentReorderScheduledItemsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentReorderScheduledItems>>,
  TError,
  { id: number; data: BodyType<PlanContentReorderScheduledItemsBody> },
  TContext
> => {
  const mutationKey = ["planContentReorderScheduledItems"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentReorderScheduledItems>>,
    { id: number; data: BodyType<PlanContentReorderScheduledItemsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentReorderScheduledItems(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentReorderScheduledItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentReorderScheduledItems>>
>;
export type PlanContentReorderScheduledItemsMutationBody =
  BodyType<PlanContentReorderScheduledItemsBody>;
export type PlanContentReorderScheduledItemsMutationError = ErrorType<unknown>;

/**
 * @summary Reorder carousel items within a scheduled slot. Body lists item ids in the desired order.
 */
export const usePlanContentReorderScheduledItems = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentReorderScheduledItems>>,
    TError,
    { id: number; data: BodyType<PlanContentReorderScheduledItemsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentReorderScheduledItems>>,
  TError,
  { id: number; data: BodyType<PlanContentReorderScheduledItemsBody> },
  TContext
> => {
  return useMutation(
    getPlanContentReorderScheduledItemsMutationOptions(options),
  );
};

/**
 * @summary Remove a single item from a scheduled slot. If the slot has only one item left it is also deleted.
 */
export const getPlanContentRemoveScheduledItemUrl = (
  id: number,
  itemId: number,
) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/items/${itemId}`;
};

export const planContentRemoveScheduledItem = async (
  id: number,
  itemId: number,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(
    getPlanContentRemoveScheduledItemUrl(id, itemId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getPlanContentRemoveScheduledItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentRemoveScheduledItem>>,
    TError,
    { id: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentRemoveScheduledItem>>,
  TError,
  { id: number; itemId: number },
  TContext
> => {
  const mutationKey = ["planContentRemoveScheduledItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentRemoveScheduledItem>>,
    { id: number; itemId: number }
  > = (props) => {
    const { id, itemId } = props ?? {};

    return planContentRemoveScheduledItem(id, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentRemoveScheduledItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentRemoveScheduledItem>>
>;

export type PlanContentRemoveScheduledItemMutationError = ErrorType<unknown>;

/**
 * @summary Remove a single item from a scheduled slot. If the slot has only one item left it is also deleted.
 */
export const usePlanContentRemoveScheduledItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentRemoveScheduledItem>>,
    TError,
    { id: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentRemoveScheduledItem>>,
  TError,
  { id: number; itemId: number },
  TContext
> => {
  return useMutation(getPlanContentRemoveScheduledItemMutationOptions(options));
};

/**
 * @summary User-controlled reorder of the Approved Posts strip / column. Body lists the approved post ids in the desired order; the server stamps approved_display_order = index for each.
 */
export const getPlanContentReorderApprovedUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/posts/reorder-approved`;
};

export const planContentReorderApproved = async (
  id: number,
  planContentReorderApprovedBody: PlanContentReorderApprovedBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getPlanContentReorderApprovedUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(planContentReorderApprovedBody),
  });
};

export const getPlanContentReorderApprovedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentReorderApproved>>,
    TError,
    { id: number; data: BodyType<PlanContentReorderApprovedBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentReorderApproved>>,
  TError,
  { id: number; data: BodyType<PlanContentReorderApprovedBody> },
  TContext
> => {
  const mutationKey = ["planContentReorderApproved"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentReorderApproved>>,
    { id: number; data: BodyType<PlanContentReorderApprovedBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentReorderApproved(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentReorderApprovedMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentReorderApproved>>
>;
export type PlanContentReorderApprovedMutationBody =
  BodyType<PlanContentReorderApprovedBody>;
export type PlanContentReorderApprovedMutationError = ErrorType<unknown>;

/**
 * @summary User-controlled reorder of the Approved Posts strip / column. Body lists the approved post ids in the desired order; the server stamps approved_display_order = index for each.
 */
export const usePlanContentReorderApproved = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentReorderApproved>>,
    TError,
    { id: number; data: BodyType<PlanContentReorderApprovedBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentReorderApproved>>,
  TError,
  { id: number; data: BodyType<PlanContentReorderApprovedBody> },
  TContext
> => {
  return useMutation(getPlanContentReorderApprovedMutationOptions(options));
};

/**
 * @summary List the scheduled slots that currently reference this approved post. Used by the delete-confirmation flow on Create Content cards.
 */
export const getPlanContentListScheduledOccurrencesForPostUrl = (
  id: number,
) => {
  return `/api/v1/plan-content/posts/${id}/scheduled-occurrences`;
};

export const planContentListScheduledOccurrencesForPost = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentScheduledPostOccurrence[]> => {
  return customFetch<PlanContentScheduledPostOccurrence[]>(
    getPlanContentListScheduledOccurrencesForPostUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPlanContentListScheduledOccurrencesForPostQueryKey = (
  id: number,
) => {
  return [`/api/v1/plan-content/posts/${id}/scheduled-occurrences`] as const;
};

export const getPlanContentListScheduledOccurrencesForPostQueryOptions = <
  TData = Awaited<
    ReturnType<typeof planContentListScheduledOccurrencesForPost>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListScheduledOccurrencesForPost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlanContentListScheduledOccurrencesForPostQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentListScheduledOccurrencesForPost>>
  > = ({ signal }) =>
    planContentListScheduledOccurrencesForPost(id, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentListScheduledOccurrencesForPost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentListScheduledOccurrencesForPostQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentListScheduledOccurrencesForPost>>
>;
export type PlanContentListScheduledOccurrencesForPostQueryError =
  ErrorType<unknown>;

/**
 * @summary List the scheduled slots that currently reference this approved post. Used by the delete-confirmation flow on Create Content cards.
 */

export function usePlanContentListScheduledOccurrencesForPost<
  TData = Awaited<
    ReturnType<typeof planContentListScheduledOccurrencesForPost>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof planContentListScheduledOccurrencesForPost>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getPlanContentListScheduledOccurrencesForPostQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Returns settings + risk-level descriptions needed to render the Generate Posts dialog
 */
export const getPlanContentDialogConfigUrl = () => {
  return `/api/v1/plan-content/dialog-config`;
};

export const planContentDialogConfig = async (
  options?: RequestInit,
): Promise<PlanContentDialogConfig> => {
  return customFetch<PlanContentDialogConfig>(getPlanContentDialogConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getPlanContentDialogConfigQueryKey = () => {
  return [`/api/v1/plan-content/dialog-config`] as const;
};

export const getPlanContentDialogConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof planContentDialogConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof planContentDialogConfig>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlanContentDialogConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof planContentDialogConfig>>
  > = ({ signal }) => planContentDialogConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof planContentDialogConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PlanContentDialogConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof planContentDialogConfig>>
>;
export type PlanContentDialogConfigQueryError = ErrorType<unknown>;

/**
 * @summary Returns settings + risk-level descriptions needed to render the Generate Posts dialog
 */

export function usePlanContentDialogConfig<
  TData = Awaited<ReturnType<typeof planContentDialogConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof planContentDialogConfig>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPlanContentDialogConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Returns whether the Generate Party Content feature is enabled (and its caps) for this deployment
 */
export const getGetPlanContentPartyConfigUrl = () => {
  return `/api/v1/plan-content/party-config`;
};

export const getPlanContentPartyConfig = async (
  options?: RequestInit,
): Promise<PlanContentPartyConfig> => {
  return customFetch<PlanContentPartyConfig>(
    getGetPlanContentPartyConfigUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPlanContentPartyConfigQueryKey = () => {
  return [`/api/v1/plan-content/party-config`] as const;
};

export const getGetPlanContentPartyConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanContentPartyConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getPlanContentPartyConfig>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlanContentPartyConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlanContentPartyConfig>>
  > = ({ signal }) => getPlanContentPartyConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanContentPartyConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlanContentPartyConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanContentPartyConfig>>
>;
export type GetPlanContentPartyConfigQueryError = ErrorType<unknown>;

/**
 * @summary Returns whether the Generate Party Content feature is enabled (and its caps) for this deployment
 */

export function useGetPlanContentPartyConfig<
  TData = Awaited<ReturnType<typeof getPlanContentPartyConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getPlanContentPartyConfig>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlanContentPartyConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Kick off a multi-model Party Content generation run (orchestrator + N doers)
 */
export const getPlanContentGeneratePartyUrl = (id: number) => {
  return `/api/v1/influencers/${id}/plan-content/generate-party`;
};

export const planContentGenerateParty = async (
  id: number,
  planContentGeneratePartyBody: PlanContentGeneratePartyBody,
  options?: RequestInit,
): Promise<PlanContentGenerateResponse> => {
  return customFetch<PlanContentGenerateResponse>(
    getPlanContentGeneratePartyUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentGeneratePartyBody),
    },
  );
};

export const getPlanContentGeneratePartyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentGenerateParty>>,
    TError,
    { id: number; data: BodyType<PlanContentGeneratePartyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planContentGenerateParty>>,
  TError,
  { id: number; data: BodyType<PlanContentGeneratePartyBody> },
  TContext
> => {
  const mutationKey = ["planContentGenerateParty"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planContentGenerateParty>>,
    { id: number; data: BodyType<PlanContentGeneratePartyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return planContentGenerateParty(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanContentGeneratePartyMutationResult = NonNullable<
  Awaited<ReturnType<typeof planContentGenerateParty>>
>;
export type PlanContentGeneratePartyMutationBody =
  BodyType<PlanContentGeneratePartyBody>;
export type PlanContentGeneratePartyMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Kick off a multi-model Party Content generation run (orchestrator + N doers)
 */
export const usePlanContentGenerateParty = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planContentGenerateParty>>,
    TError,
    { id: number; data: BodyType<PlanContentGeneratePartyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof planContentGenerateParty>>,
  TError,
  { id: number; data: BodyType<PlanContentGeneratePartyBody> },
  TContext
> => {
  return useMutation(getPlanContentGeneratePartyMutationOptions(options));
};

/**
 * @summary Get an influencer's automatic-posting settings, platform connections (IG + Threads), and last 10 posting-history rows
 */
export const getGetInfluencerAutoPostingUrl = (id: number) => {
  return `/api/v1/influencers/${id}/auto-posting`;
};

export const getInfluencerAutoPosting = async (
  id: number,
  options?: RequestInit,
): Promise<AutoPostingTabResponse> => {
  return customFetch<AutoPostingTabResponse>(
    getGetInfluencerAutoPostingUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInfluencerAutoPostingQueryKey = (id: number) => {
  return [`/api/v1/influencers/${id}/auto-posting`] as const;
};

export const getGetInfluencerAutoPostingQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfluencerAutoPosting>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencerAutoPosting>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInfluencerAutoPostingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInfluencerAutoPosting>>
  > = ({ signal }) =>
    getInfluencerAutoPosting(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfluencerAutoPosting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInfluencerAutoPostingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInfluencerAutoPosting>>
>;
export type GetInfluencerAutoPostingQueryError = ErrorType<unknown>;

/**
 * @summary Get an influencer's automatic-posting settings, platform connections (IG + Threads), and last 10 posting-history rows
 */

export function useGetInfluencerAutoPosting<
  TData = Awaited<ReturnType<typeof getInfluencerAutoPosting>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencerAutoPosting>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInfluencerAutoPostingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update master + per-platform automatic-posting toggles for an influencer
 */
export const getUpdateInfluencerAutoPostingUrl = (id: number) => {
  return `/api/v1/influencers/${id}/auto-posting`;
};

export const updateInfluencerAutoPosting = async (
  id: number,
  updateAutoPostingTabBody: UpdateAutoPostingTabBody,
  options?: RequestInit,
): Promise<AutoPostingTabResponse> => {
  return customFetch<AutoPostingTabResponse>(
    getUpdateInfluencerAutoPostingUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateAutoPostingTabBody),
    },
  );
};

export const getUpdateInfluencerAutoPostingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencerAutoPosting>>,
    TError,
    { id: number; data: BodyType<UpdateAutoPostingTabBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInfluencerAutoPosting>>,
  TError,
  { id: number; data: BodyType<UpdateAutoPostingTabBody> },
  TContext
> => {
  const mutationKey = ["updateInfluencerAutoPosting"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInfluencerAutoPosting>>,
    { id: number; data: BodyType<UpdateAutoPostingTabBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInfluencerAutoPosting(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInfluencerAutoPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInfluencerAutoPosting>>
>;
export type UpdateInfluencerAutoPostingMutationBody =
  BodyType<UpdateAutoPostingTabBody>;
export type UpdateInfluencerAutoPostingMutationError = ErrorType<unknown>;

/**
 * @summary Update master + per-platform automatic-posting toggles for an influencer
 */
export const useUpdateInfluencerAutoPosting = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInfluencerAutoPosting>>,
    TError,
    { id: number; data: BodyType<UpdateAutoPostingTabBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInfluencerAutoPosting>>,
  TError,
  { id: number; data: BodyType<UpdateAutoPostingTabBody> },
  TContext
> => {
  return useMutation(getUpdateInfluencerAutoPostingMutationOptions(options));
};

/**
 * @summary Ensure upload-post.com profile and return a JWT URL for connecting social accounts
 */
export const getConnectInfluencerAutoPostingUrl = (id: number) => {
  return `/api/v1/influencers/${id}/auto-posting/connect`;
};

export const connectInfluencerAutoPosting = async (
  id: number,
  options?: RequestInit,
): Promise<AutoPostingConnectResponse> => {
  return customFetch<AutoPostingConnectResponse>(
    getConnectInfluencerAutoPostingUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getConnectInfluencerAutoPostingMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectInfluencerAutoPosting>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectInfluencerAutoPosting>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["connectInfluencerAutoPosting"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectInfluencerAutoPosting>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return connectInfluencerAutoPosting(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectInfluencerAutoPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectInfluencerAutoPosting>>
>;

export type ConnectInfluencerAutoPostingMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Ensure upload-post.com profile and return a JWT URL for connecting social accounts
 */
export const useConnectInfluencerAutoPosting = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectInfluencerAutoPosting>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof connectInfluencerAutoPosting>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getConnectInfluencerAutoPostingMutationOptions(options));
};

/**
 * @summary Mark all platform connections for this influencer as disconnected (frees a quota slot). Does NOT revoke tokens on upload-post.com — the user must do that separately.
 */
export const getDisconnectInfluencerAutoPostingUrl = (id: number) => {
  return `/api/v1/influencers/${id}/auto-posting/disconnect`;
};

export const disconnectInfluencerAutoPosting = async (
  id: number,
  options?: RequestInit,
): Promise<AutoPostingTabResponse> => {
  return customFetch<AutoPostingTabResponse>(
    getDisconnectInfluencerAutoPostingUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getDisconnectInfluencerAutoPostingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectInfluencerAutoPosting>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectInfluencerAutoPosting>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["disconnectInfluencerAutoPosting"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectInfluencerAutoPosting>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return disconnectInfluencerAutoPosting(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectInfluencerAutoPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectInfluencerAutoPosting>>
>;

export type DisconnectInfluencerAutoPostingMutationError = ErrorType<unknown>;

/**
 * @summary Mark all platform connections for this influencer as disconnected (frees a quota slot). Does NOT revoke tokens on upload-post.com — the user must do that separately.
 */
export const useDisconnectInfluencerAutoPosting = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectInfluencerAutoPosting>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectInfluencerAutoPosting>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getDisconnectInfluencerAutoPostingMutationOptions(options),
  );
};

/**
 * @summary Ensure the upload-post.com profile exists and return a JWT URL
scoped to a single platform's OAuth flow. The platform must be
enabled in the admin "Upload Post Settings" allowlist.

 */
export const getConnectInfluencerAutoPostingPlatformUrl = (
  id: number,
  platform: string,
) => {
  return `/api/v1/influencers/${id}/auto-posting/connect/${platform}`;
};

export const connectInfluencerAutoPostingPlatform = async (
  id: number,
  platform: string,
  options?: RequestInit,
): Promise<AutoPostingConnectResponse> => {
  return customFetch<AutoPostingConnectResponse>(
    getConnectInfluencerAutoPostingPlatformUrl(id, platform),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getConnectInfluencerAutoPostingPlatformMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectInfluencerAutoPostingPlatform>>,
    TError,
    { id: number; platform: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectInfluencerAutoPostingPlatform>>,
  TError,
  { id: number; platform: string },
  TContext
> => {
  const mutationKey = ["connectInfluencerAutoPostingPlatform"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectInfluencerAutoPostingPlatform>>,
    { id: number; platform: string }
  > = (props) => {
    const { id, platform } = props ?? {};

    return connectInfluencerAutoPostingPlatform(id, platform, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectInfluencerAutoPostingPlatformMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectInfluencerAutoPostingPlatform>>
>;

export type ConnectInfluencerAutoPostingPlatformMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Ensure the upload-post.com profile exists and return a JWT URL
scoped to a single platform's OAuth flow. The platform must be
enabled in the admin "Upload Post Settings" allowlist.

 */
export const useConnectInfluencerAutoPostingPlatform = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectInfluencerAutoPostingPlatform>>,
    TError,
    { id: number; platform: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof connectInfluencerAutoPostingPlatform>>,
  TError,
  { id: number; platform: string },
  TContext
> => {
  return useMutation(
    getConnectInfluencerAutoPostingPlatformMutationOptions(options),
  );
};

/**
 * @summary Disconnect a single platform for this influencer by calling
upload-post.com's `DELETE /api/social_accounts` revoke endpoint.
Connection state is finalized by the existing
`social.account.disconnected` webhook (this route does not write
state locally to avoid racing the webhook receiver). Frees the
influencer's quota slot once no platform remains `connected`.

 */
export const getDisconnectInfluencerAutoPostingPlatformUrl = (
  id: number,
  platform: string,
) => {
  return `/api/v1/influencers/${id}/auto-posting/disconnect/${platform}`;
};

export const disconnectInfluencerAutoPostingPlatform = async (
  id: number,
  platform: string,
  options?: RequestInit,
): Promise<AutoPostingTabResponse> => {
  return customFetch<AutoPostingTabResponse>(
    getDisconnectInfluencerAutoPostingPlatformUrl(id, platform),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getDisconnectInfluencerAutoPostingPlatformMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectInfluencerAutoPostingPlatform>>,
    TError,
    { id: number; platform: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectInfluencerAutoPostingPlatform>>,
  TError,
  { id: number; platform: string },
  TContext
> => {
  const mutationKey = ["disconnectInfluencerAutoPostingPlatform"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectInfluencerAutoPostingPlatform>>,
    { id: number; platform: string }
  > = (props) => {
    const { id, platform } = props ?? {};

    return disconnectInfluencerAutoPostingPlatform(
      id,
      platform,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectInfluencerAutoPostingPlatformMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectInfluencerAutoPostingPlatform>>
>;

export type DisconnectInfluencerAutoPostingPlatformMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Disconnect a single platform for this influencer by calling
upload-post.com's `DELETE /api/social_accounts` revoke endpoint.
Connection state is finalized by the existing
`social.account.disconnected` webhook (this route does not write
state locally to avoid racing the webhook receiver). Frees the
influencer's quota slot once no platform remains `connected`.

 */
export const useDisconnectInfluencerAutoPostingPlatform = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectInfluencerAutoPostingPlatform>>,
    TError,
    { id: number; platform: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectInfluencerAutoPostingPlatform>>,
  TError,
  { id: number; platform: string },
  TContext
> => {
  return useMutation(
    getDisconnectInfluencerAutoPostingPlatformMutationOptions(options),
  );
};

/**
 * @summary Return the admin allowlist of upload-post.com platforms that
influencer owners are permitted to connect from the in-app
Automatic Posting tab. Drives the per-platform connect list in
AutomaticPostingTab.

 */
export const getGetAutoPostingEnabledPlatformsUrl = () => {
  return `/api/v1/auto-posting/enabled-platforms`;
};

export const getAutoPostingEnabledPlatforms = async (
  options?: RequestInit,
): Promise<AutoPostingEnabledPlatformsResponse> => {
  return customFetch<AutoPostingEnabledPlatformsResponse>(
    getGetAutoPostingEnabledPlatformsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAutoPostingEnabledPlatformsQueryKey = () => {
  return [`/api/v1/auto-posting/enabled-platforms`] as const;
};

export const getGetAutoPostingEnabledPlatformsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAutoPostingEnabledPlatforms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAutoPostingEnabledPlatforms>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAutoPostingEnabledPlatformsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAutoPostingEnabledPlatforms>>
  > = ({ signal }) =>
    getAutoPostingEnabledPlatforms({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAutoPostingEnabledPlatforms>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAutoPostingEnabledPlatformsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAutoPostingEnabledPlatforms>>
>;
export type GetAutoPostingEnabledPlatformsQueryError = ErrorType<unknown>;

/**
 * @summary Return the admin allowlist of upload-post.com platforms that
influencer owners are permitted to connect from the in-app
Automatic Posting tab. Drives the per-platform connect list in
AutomaticPostingTab.

 */

export function useGetAutoPostingEnabledPlatforms<
  TData = Awaited<ReturnType<typeof getAutoPostingEnabledPlatforms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAutoPostingEnabledPlatforms>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAutoPostingEnabledPlatformsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Per-user social-connector capacity summary for the Billing page.
Returns the current connected-account quota, how many slots are
used across all influencers owned by the user, and a per-
influencer breakdown of every platform connection row so the
user can see exactly which accounts are connected, need re-auth,
or were disabled by a plan downgrade.

 */
export const getGetBillingSocialConnectorsUrl = () => {
  return `/api/v1/billing/social-connectors`;
};

export const getBillingSocialConnectors = async (
  options?: RequestInit,
): Promise<BillingSocialConnectorsResponse> => {
  return customFetch<BillingSocialConnectorsResponse>(
    getGetBillingSocialConnectorsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBillingSocialConnectorsQueryKey = () => {
  return [`/api/v1/billing/social-connectors`] as const;
};

export const getGetBillingSocialConnectorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingSocialConnectors>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getBillingSocialConnectors>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBillingSocialConnectorsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillingSocialConnectors>>
  > = ({ signal }) => getBillingSocialConnectors({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingSocialConnectors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingSocialConnectorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingSocialConnectors>>
>;
export type GetBillingSocialConnectorsQueryError = ErrorType<unknown>;

/**
 * @summary Per-user social-connector capacity summary for the Billing page.
Returns the current connected-account quota, how many slots are
used across all influencers owned by the user, and a per-
influencer breakdown of every platform connection row so the
user can see exactly which accounts are connected, need re-auth,
or were disabled by a plan downgrade.

 */

export function useGetBillingSocialConnectors<
  TData = Awaited<ReturnType<typeof getBillingSocialConnectors>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getBillingSocialConnectors>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingSocialConnectorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the latest per-platform analytics snapshot plus the trailing 90-day trend for an influencer
 */
export const getGetInfluencerAnalyticsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/analytics`;
};

export const getInfluencerAnalytics = async (
  id: number,
  options?: RequestInit,
): Promise<InfluencerAnalyticsResponse> => {
  return customFetch<InfluencerAnalyticsResponse>(
    getGetInfluencerAnalyticsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInfluencerAnalyticsQueryKey = (id: number) => {
  return [`/api/v1/influencers/${id}/analytics`] as const;
};

export const getGetInfluencerAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfluencerAnalytics>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencerAnalytics>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInfluencerAnalyticsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInfluencerAnalytics>>
  > = ({ signal }) => getInfluencerAnalytics(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfluencerAnalytics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInfluencerAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInfluencerAnalytics>>
>;
export type GetInfluencerAnalyticsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the latest per-platform analytics snapshot plus the trailing 90-day trend for an influencer
 */

export function useGetInfluencerAnalytics<
  TData = Awaited<ReturnType<typeof getInfluencerAnalytics>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getInfluencerAnalytics>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInfluencerAnalyticsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Pull a fresh analytics snapshot from upload-post.com on demand (rate-limited to once per 5 min per influencer)
 */
export const getRefreshInfluencerAnalyticsUrl = (id: number) => {
  return `/api/v1/influencers/${id}/analytics/refresh`;
};

export const refreshInfluencerAnalytics = async (
  id: number,
  options?: RequestInit,
): Promise<InfluencerAnalyticsResponse> => {
  return customFetch<InfluencerAnalyticsResponse>(
    getRefreshInfluencerAnalyticsUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRefreshInfluencerAnalyticsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshInfluencerAnalytics>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshInfluencerAnalytics>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["refreshInfluencerAnalytics"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshInfluencerAnalytics>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return refreshInfluencerAnalytics(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshInfluencerAnalyticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshInfluencerAnalytics>>
>;

export type RefreshInfluencerAnalyticsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Pull a fresh analytics snapshot from upload-post.com on demand (rate-limited to once per 5 min per influencer)
 */
export const useRefreshInfluencerAnalytics = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshInfluencerAnalytics>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshInfluencerAnalytics>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRefreshInfluencerAnalyticsMutationOptions(options));
};

/**
 * @summary Get the singleton automatic-posting settings + env API key presence
 */
export const getGetAutoPostSettingsUrl = () => {
  return `/api/v1/admin/auto-post-settings`;
};

export const getAutoPostSettings = async (
  options?: RequestInit,
): Promise<AutoPostSettingsResponse> => {
  return customFetch<AutoPostSettingsResponse>(getGetAutoPostSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAutoPostSettingsQueryKey = () => {
  return [`/api/v1/admin/auto-post-settings`] as const;
};

export const getGetAutoPostSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAutoPostSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAutoPostSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAutoPostSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAutoPostSettings>>
  > = ({ signal }) => getAutoPostSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAutoPostSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAutoPostSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAutoPostSettings>>
>;
export type GetAutoPostSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get the singleton automatic-posting settings + env API key presence
 */

export function useGetAutoPostSettings<
  TData = Awaited<ReturnType<typeof getAutoPostSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getAutoPostSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAutoPostSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update editable automatic-posting settings
 */
export const getUpdateAutoPostSettingsUrl = () => {
  return `/api/v1/admin/auto-post-settings`;
};

export const updateAutoPostSettings = async (
  updateAutoPostSettingsBody: UpdateAutoPostSettingsBody,
  options?: RequestInit,
): Promise<AutoPostSettingsResponse> => {
  return customFetch<AutoPostSettingsResponse>(getUpdateAutoPostSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAutoPostSettingsBody),
  });
};

export const getUpdateAutoPostSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAutoPostSettings>>,
    TError,
    { data: BodyType<UpdateAutoPostSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAutoPostSettings>>,
  TError,
  { data: BodyType<UpdateAutoPostSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateAutoPostSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAutoPostSettings>>,
    { data: BodyType<UpdateAutoPostSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateAutoPostSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAutoPostSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAutoPostSettings>>
>;
export type UpdateAutoPostSettingsMutationBody =
  BodyType<UpdateAutoPostSettingsBody>;
export type UpdateAutoPostSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update editable automatic-posting settings
 */
export const useUpdateAutoPostSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAutoPostSettings>>,
    TError,
    { data: BodyType<UpdateAutoPostSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAutoPostSettings>>,
  TError,
  { data: BodyType<UpdateAutoPostSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateAutoPostSettingsMutationOptions(options));
};

/**
 * @summary Push webhook config to upload-post.com (writes webhookConfiguredAt on success)
 */
export const getConfigureAutoPostWebhookUrl = () => {
  return `/api/v1/admin/auto-post-settings/configure-webhook`;
};

export const configureAutoPostWebhook = async (
  options?: RequestInit,
): Promise<AutoPostSettingsResponse> => {
  return customFetch<AutoPostSettingsResponse>(
    getConfigureAutoPostWebhookUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getConfigureAutoPostWebhookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof configureAutoPostWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof configureAutoPostWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["configureAutoPostWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof configureAutoPostWebhook>>,
    void
  > = () => {
    return configureAutoPostWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfigureAutoPostWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof configureAutoPostWebhook>>
>;

export type ConfigureAutoPostWebhookMutationError = ErrorType<unknown>;

/**
 * @summary Push webhook config to upload-post.com (writes webhookConfiguredAt on success)
 */
export const useConfigureAutoPostWebhook = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof configureAutoPostWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof configureAutoPostWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getConfigureAutoPostWebhookMutationOptions(options));
};

/**
 * @summary Admin trigger — run the auto-post main batch immediately, bypassing CAS
 */
export const getRunAutoPostBatchNowUrl = () => {
  return `/api/v1/admin/auto-post-settings/run-batch-now`;
};

export const runAutoPostBatchNow = async (
  options?: RequestInit,
): Promise<RunAutoPostBatchResponse> => {
  return customFetch<RunAutoPostBatchResponse>(getRunAutoPostBatchNowUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRunAutoPostBatchNowMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAutoPostBatchNow>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runAutoPostBatchNow>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runAutoPostBatchNow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runAutoPostBatchNow>>,
    void
  > = () => {
    return runAutoPostBatchNow(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunAutoPostBatchNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof runAutoPostBatchNow>>
>;

export type RunAutoPostBatchNowMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Admin trigger — run the auto-post main batch immediately, bypassing CAS
 */
export const useRunAutoPostBatchNow = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAutoPostBatchNow>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runAutoPostBatchNow>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunAutoPostBatchNowMutationOptions(options));
};

/**
 * @summary Admin trigger — run the auto-post retry batch immediately, bypassing CAS
 */
export const getRunAutoPostRetryBatchNowUrl = () => {
  return `/api/v1/admin/auto-post-settings/run-retry-batch-now`;
};

export const runAutoPostRetryBatchNow = async (
  options?: RequestInit,
): Promise<RunAutoPostBatchResponse> => {
  return customFetch<RunAutoPostBatchResponse>(
    getRunAutoPostRetryBatchNowUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRunAutoPostRetryBatchNowMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAutoPostRetryBatchNow>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runAutoPostRetryBatchNow>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runAutoPostRetryBatchNow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runAutoPostRetryBatchNow>>,
    void
  > = () => {
    return runAutoPostRetryBatchNow(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunAutoPostRetryBatchNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof runAutoPostRetryBatchNow>>
>;

export type RunAutoPostRetryBatchNowMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Admin trigger — run the auto-post retry batch immediately, bypassing CAS
 */
export const useRunAutoPostRetryBatchNow = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAutoPostRetryBatchNow>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runAutoPostRetryBatchNow>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunAutoPostRetryBatchNowMutationOptions(options));
};

/**
 * @summary Cancel an in-flight upload-post submission for a scheduled post
 */
export const getCancelPlanContentScheduledPostPostingUrl = (id: number) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/cancel-posting`;
};

export const cancelPlanContentScheduledPostPosting = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getCancelPlanContentScheduledPostPostingUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelPlanContentScheduledPostPostingMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelPlanContentScheduledPostPosting>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelPlanContentScheduledPostPosting>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["cancelPlanContentScheduledPostPosting"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelPlanContentScheduledPostPosting>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return cancelPlanContentScheduledPostPosting(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelPlanContentScheduledPostPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelPlanContentScheduledPostPosting>>
>;

export type CancelPlanContentScheduledPostPostingMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Cancel an in-flight upload-post submission for a scheduled post
 */
export const useCancelPlanContentScheduledPostPosting = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelPlanContentScheduledPostPosting>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelPlanContentScheduledPostPosting>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getCancelPlanContentScheduledPostPostingMutationOptions(options),
  );
};

/**
 * @summary Resolve a cancellation_uncertain post by reporting actual outcome
 */
export const getResolvePlanContentScheduledPostCancellationUrl = (
  id: number,
) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/resolve-cancellation`;
};

export const resolvePlanContentScheduledPostCancellation = async (
  id: number,
  planContentResolveCancellationBody: PlanContentResolveCancellationBody,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getResolvePlanContentScheduledPostCancellationUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(planContentResolveCancellationBody),
    },
  );
};

export const getResolvePlanContentScheduledPostCancellationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePlanContentScheduledPostCancellation>>,
    TError,
    { id: number; data: BodyType<PlanContentResolveCancellationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolvePlanContentScheduledPostCancellation>>,
  TError,
  { id: number; data: BodyType<PlanContentResolveCancellationBody> },
  TContext
> => {
  const mutationKey = ["resolvePlanContentScheduledPostCancellation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolvePlanContentScheduledPostCancellation>>,
    { id: number; data: BodyType<PlanContentResolveCancellationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resolvePlanContentScheduledPostCancellation(
      id,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolvePlanContentScheduledPostCancellationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof resolvePlanContentScheduledPostCancellation>>
  >;
export type ResolvePlanContentScheduledPostCancellationMutationBody =
  BodyType<PlanContentResolveCancellationBody>;
export type ResolvePlanContentScheduledPostCancellationMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Resolve a cancellation_uncertain post by reporting actual outcome
 */
export const useResolvePlanContentScheduledPostCancellation = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePlanContentScheduledPostCancellation>>,
    TError,
    { id: number; data: BodyType<PlanContentResolveCancellationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolvePlanContentScheduledPostCancellation>>,
  TError,
  { id: number; data: BodyType<PlanContentResolveCancellationBody> },
  TContext
> => {
  return useMutation(
    getResolvePlanContentScheduledPostCancellationMutationOptions(options),
  );
};

/**
 * @summary Mark a scheduled post as posted by hand (terminal posted state)
 */
export const getMarkPlanContentScheduledPostManuallyPostedUrl = (
  id: number,
) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/mark-manually-posted`;
};

export const markPlanContentScheduledPostManuallyPosted = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getMarkPlanContentScheduledPostManuallyPostedUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMarkPlanContentScheduledPostManuallyPostedMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markPlanContentScheduledPostManuallyPosted>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markPlanContentScheduledPostManuallyPosted>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["markPlanContentScheduledPostManuallyPosted"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markPlanContentScheduledPostManuallyPosted>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return markPlanContentScheduledPostManuallyPosted(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkPlanContentScheduledPostManuallyPostedMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof markPlanContentScheduledPostManuallyPosted>>
  >;

export type MarkPlanContentScheduledPostManuallyPostedMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Mark a scheduled post as posted by hand (terminal posted state)
 */
export const useMarkPlanContentScheduledPostManuallyPosted = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markPlanContentScheduledPostManuallyPosted>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markPlanContentScheduledPostManuallyPosted>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getMarkPlanContentScheduledPostManuallyPostedMutationOptions(options),
  );
};

/**
 * @summary Unmark a "Post immediately" manual post as posted (Task
 */
export const getRetractPlanContentManualPostPostedUrl = (id: number) => {
  return `/api/v1/plan-content/manual-posts/${id}/retract-posted`;
};

export const retractPlanContentManualPostPosted = async (
  id: number,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(
    getRetractPlanContentManualPostPostedUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetractPlanContentManualPostPostedMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retractPlanContentManualPostPosted>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retractPlanContentManualPostPosted>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["retractPlanContentManualPostPosted"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retractPlanContentManualPostPosted>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return retractPlanContentManualPostPosted(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetractPlanContentManualPostPostedMutationResult = NonNullable<
  Awaited<ReturnType<typeof retractPlanContentManualPostPosted>>
>;

export type RetractPlanContentManualPostPostedMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Unmark a "Post immediately" manual post as posted (Task
 */
export const useRetractPlanContentManualPostPosted = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retractPlanContentManualPostPosted>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retractPlanContentManualPostPosted>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getRetractPlanContentManualPostPostedMutationOptions(options),
  );
};

/**
 * @summary Retract a slot's Posted status back to unlocked (Task
 */
export const getRetractPlanContentScheduledPostPostedUrl = (id: number) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/retract-posted`;
};

export const retractPlanContentScheduledPostPosted = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getRetractPlanContentScheduledPostPostedUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetractPlanContentScheduledPostPostedMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retractPlanContentScheduledPostPosted>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retractPlanContentScheduledPostPosted>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["retractPlanContentScheduledPostPosted"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retractPlanContentScheduledPostPosted>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return retractPlanContentScheduledPostPosted(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetractPlanContentScheduledPostPostedMutationResult = NonNullable<
  Awaited<ReturnType<typeof retractPlanContentScheduledPostPosted>>
>;

export type RetractPlanContentScheduledPostPostedMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Retract a slot's Posted status back to unlocked (Task
 */
export const useRetractPlanContentScheduledPostPosted = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retractPlanContentScheduledPostPosted>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retractPlanContentScheduledPostPosted>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getRetractPlanContentScheduledPostPostedMutationOptions(options),
  );
};

/**
 * @summary Read-only credit costs for the 2-step Expand Headshot to Body pipeline.
 */
export const getGetUserBodyshotSettingsUrl = () => {
  return `/api/v1/user/bodyshot-settings`;
};

export const getUserBodyshotSettings = async (
  options?: RequestInit,
): Promise<BodyshotUserSettings> => {
  return customFetch<BodyshotUserSettings>(getGetUserBodyshotSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetUserBodyshotSettingsQueryKey = () => {
  return [`/api/v1/user/bodyshot-settings`] as const;
};

export const getGetUserBodyshotSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserBodyshotSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getUserBodyshotSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserBodyshotSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserBodyshotSettings>>
  > = ({ signal }) => getUserBodyshotSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserBodyshotSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserBodyshotSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserBodyshotSettings>>
>;
export type GetUserBodyshotSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Read-only credit costs for the 2-step Expand Headshot to Body pipeline.
 */

export function useGetUserBodyshotSettings<
  TData = Awaited<ReturnType<typeof getUserBodyshotSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getUserBodyshotSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserBodyshotSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminGetBodyshotSettingsUrl = () => {
  return `/api/v1/admin/bodyshot-settings`;
};

export const adminGetBodyshotSettings = async (
  options?: RequestInit,
): Promise<BodyshotSettings> => {
  return customFetch<BodyshotSettings>(getAdminGetBodyshotSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetBodyshotSettingsQueryKey = () => {
  return [`/api/v1/admin/bodyshot-settings`] as const;
};

export const getAdminGetBodyshotSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetBodyshotSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetBodyshotSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetBodyshotSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetBodyshotSettings>>
  > = ({ signal }) => adminGetBodyshotSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetBodyshotSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetBodyshotSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetBodyshotSettings>>
>;
export type AdminGetBodyshotSettingsQueryError = ErrorType<unknown>;

export function useAdminGetBodyshotSettings<
  TData = Awaited<ReturnType<typeof adminGetBodyshotSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetBodyshotSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetBodyshotSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminUpdateBodyshotSettingsUrl = () => {
  return `/api/v1/admin/bodyshot-settings`;
};

export const adminUpdateBodyshotSettings = async (
  bodyshotSettingsUpdateBody: BodyshotSettingsUpdateBody,
  options?: RequestInit,
): Promise<BodyshotSettings> => {
  return customFetch<BodyshotSettings>(getAdminUpdateBodyshotSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bodyshotSettingsUpdateBody),
  });
};

export const getAdminUpdateBodyshotSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateBodyshotSettings>>,
    TError,
    { data: BodyType<BodyshotSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateBodyshotSettings>>,
  TError,
  { data: BodyType<BodyshotSettingsUpdateBody> },
  TContext
> => {
  const mutationKey = ["adminUpdateBodyshotSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateBodyshotSettings>>,
    { data: BodyType<BodyshotSettingsUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUpdateBodyshotSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateBodyshotSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateBodyshotSettings>>
>;
export type AdminUpdateBodyshotSettingsMutationBody =
  BodyType<BodyshotSettingsUpdateBody>;
export type AdminUpdateBodyshotSettingsMutationError = ErrorType<unknown>;

export const useAdminUpdateBodyshotSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateBodyshotSettings>>,
    TError,
    { data: BodyType<BodyshotSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateBodyshotSettings>>,
  TError,
  { data: BodyType<BodyshotSettingsUpdateBody> },
  TContext
> => {
  return useMutation(getAdminUpdateBodyshotSettingsMutationOptions(options));
};

/**
 * @summary List admin-managed Body References (filtered by gender / profile).
 */
export const getListBodyReferencesUrl = (params?: ListBodyReferencesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/body-references?${stringifiedParams}`
    : `/api/v1/body-references`;
};

export const listBodyReferences = async (
  params?: ListBodyReferencesParams,
  options?: RequestInit,
): Promise<BodyReferencePublic[]> => {
  return customFetch<BodyReferencePublic[]>(getListBodyReferencesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListBodyReferencesQueryKey = (
  params?: ListBodyReferencesParams,
) => {
  return [`/api/v1/body-references`, ...(params ? [params] : [])] as const;
};

export const getListBodyReferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBodyReferences>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBodyReferencesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listBodyReferences>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBodyReferencesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBodyReferences>>
  > = ({ signal }) => listBodyReferences(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBodyReferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBodyReferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBodyReferences>>
>;
export type ListBodyReferencesQueryError = ErrorType<unknown>;

/**
 * @summary List admin-managed Body References (filtered by gender / profile).
 */

export function useListBodyReferences<
  TData = Awaited<ReturnType<typeof listBodyReferences>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBodyReferencesParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listBodyReferences>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBodyReferencesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListBodyshotGenerationsUrl = (id: number) => {
  return `/api/v1/user/models/${id}/bodyshot-generations`;
};

export const listBodyshotGenerations = async (
  id: number,
  options?: RequestInit,
): Promise<BodyshotGeneration[]> => {
  return customFetch<BodyshotGeneration[]>(getListBodyshotGenerationsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListBodyshotGenerationsQueryKey = (id: number) => {
  return [`/api/v1/user/models/${id}/bodyshot-generations`] as const;
};

export const getListBodyshotGenerationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBodyshotGenerations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listBodyshotGenerations>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBodyshotGenerationsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBodyshotGenerations>>
  > = ({ signal }) =>
    listBodyshotGenerations(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBodyshotGenerations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBodyshotGenerationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBodyshotGenerations>>
>;
export type ListBodyshotGenerationsQueryError = ErrorType<unknown>;

export function useListBodyshotGenerations<
  TData = Awaited<ReturnType<typeof listBodyshotGenerations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listBodyshotGenerations>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBodyshotGenerationsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateBodyshotGenerationUrl = (id: number) => {
  return `/api/v1/user/models/${id}/bodyshot-generations`;
};

export const createBodyshotGeneration = async (
  id: number,
  bodyshotGenerationCreateBody: BodyshotGenerationCreateBody,
  options?: RequestInit,
): Promise<BodyshotGeneration> => {
  return customFetch<BodyshotGeneration>(getCreateBodyshotGenerationUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bodyshotGenerationCreateBody),
  });
};

export const getCreateBodyshotGenerationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBodyshotGeneration>>,
    TError,
    { id: number; data: BodyType<BodyshotGenerationCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBodyshotGeneration>>,
  TError,
  { id: number; data: BodyType<BodyshotGenerationCreateBody> },
  TContext
> => {
  const mutationKey = ["createBodyshotGeneration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBodyshotGeneration>>,
    { id: number; data: BodyType<BodyshotGenerationCreateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createBodyshotGeneration(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBodyshotGenerationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBodyshotGeneration>>
>;
export type CreateBodyshotGenerationMutationBody =
  BodyType<BodyshotGenerationCreateBody>;
export type CreateBodyshotGenerationMutationError = ErrorType<unknown>;

export const useCreateBodyshotGeneration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBodyshotGeneration>>,
    TError,
    { id: number; data: BodyType<BodyshotGenerationCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBodyshotGeneration>>,
  TError,
  { id: number; data: BodyType<BodyshotGenerationCreateBody> },
  TContext
> => {
  return useMutation(getCreateBodyshotGenerationMutationOptions(options));
};

export const getRetryBodyshotStep2Url = (id: number, gid: number) => {
  return `/api/v1/user/models/${id}/bodyshot-generations/${gid}/retry-step2`;
};

export const retryBodyshotStep2 = async (
  id: number,
  gid: number,
  options?: RequestInit,
): Promise<BodyshotGeneration> => {
  return customFetch<BodyshotGeneration>(getRetryBodyshotStep2Url(id, gid), {
    ...options,
    method: "POST",
  });
};

export const getRetryBodyshotStep2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryBodyshotStep2>>,
    TError,
    { id: number; gid: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryBodyshotStep2>>,
  TError,
  { id: number; gid: number },
  TContext
> => {
  const mutationKey = ["retryBodyshotStep2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryBodyshotStep2>>,
    { id: number; gid: number }
  > = (props) => {
    const { id, gid } = props ?? {};

    return retryBodyshotStep2(id, gid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryBodyshotStep2MutationResult = NonNullable<
  Awaited<ReturnType<typeof retryBodyshotStep2>>
>;

export type RetryBodyshotStep2MutationError = ErrorType<unknown>;

export const useRetryBodyshotStep2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryBodyshotStep2>>,
    TError,
    { id: number; gid: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryBodyshotStep2>>,
  TError,
  { id: number; gid: number },
  TContext
> => {
  return useMutation(getRetryBodyshotStep2MutationOptions(options));
};

export const getSelectBodyshotResultUrl = (id: number, gid: number) => {
  return `/api/v1/user/models/${id}/bodyshot-generations/${gid}/select`;
};

export const selectBodyshotResult = async (
  id: number,
  gid: number,
  bodyshotSelectBody?: BodyshotSelectBody,
  options?: RequestInit,
): Promise<ModelReferenceImage> => {
  return customFetch<ModelReferenceImage>(getSelectBodyshotResultUrl(id, gid), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bodyshotSelectBody),
  });
};

export const getSelectBodyshotResultMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectBodyshotResult>>,
    TError,
    { id: number; gid: number; data: BodyType<BodyshotSelectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectBodyshotResult>>,
  TError,
  { id: number; gid: number; data: BodyType<BodyshotSelectBody> },
  TContext
> => {
  const mutationKey = ["selectBodyshotResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectBodyshotResult>>,
    { id: number; gid: number; data: BodyType<BodyshotSelectBody> }
  > = (props) => {
    const { id, gid, data } = props ?? {};

    return selectBodyshotResult(id, gid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectBodyshotResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof selectBodyshotResult>>
>;
export type SelectBodyshotResultMutationBody = BodyType<BodyshotSelectBody>;
export type SelectBodyshotResultMutationError = ErrorType<unknown>;

export const useSelectBodyshotResult = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectBodyshotResult>>,
    TError,
    { id: number; gid: number; data: BodyType<BodyshotSelectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectBodyshotResult>>,
  TError,
  { id: number; gid: number; data: BodyType<BodyshotSelectBody> },
  TContext
> => {
  return useMutation(getSelectBodyshotResultMutationOptions(options));
};

export const getSaveBodyshotToLibraryUrl = (id: number, gid: number) => {
  return `/api/v1/user/models/${id}/bodyshot-generations/${gid}/save-to-library`;
};

export const saveBodyshotToLibrary = async (
  id: number,
  gid: number,
  bodyshotSaveToLibraryBody?: BodyshotSaveToLibraryBody,
  options?: RequestInit,
): Promise<BodyshotGeneration> => {
  return customFetch<BodyshotGeneration>(getSaveBodyshotToLibraryUrl(id, gid), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bodyshotSaveToLibraryBody),
  });
};

export const getSaveBodyshotToLibraryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveBodyshotToLibrary>>,
    TError,
    { id: number; gid: number; data: BodyType<BodyshotSaveToLibraryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveBodyshotToLibrary>>,
  TError,
  { id: number; gid: number; data: BodyType<BodyshotSaveToLibraryBody> },
  TContext
> => {
  const mutationKey = ["saveBodyshotToLibrary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveBodyshotToLibrary>>,
    { id: number; gid: number; data: BodyType<BodyshotSaveToLibraryBody> }
  > = (props) => {
    const { id, gid, data } = props ?? {};

    return saveBodyshotToLibrary(id, gid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveBodyshotToLibraryMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveBodyshotToLibrary>>
>;
export type SaveBodyshotToLibraryMutationBody =
  BodyType<BodyshotSaveToLibraryBody>;
export type SaveBodyshotToLibraryMutationError = ErrorType<unknown>;

export const useSaveBodyshotToLibrary = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveBodyshotToLibrary>>,
    TError,
    { id: number; gid: number; data: BodyType<BodyshotSaveToLibraryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveBodyshotToLibrary>>,
  TError,
  { id: number; gid: number; data: BodyType<BodyshotSaveToLibraryBody> },
  TContext
> => {
  return useMutation(getSaveBodyshotToLibraryMutationOptions(options));
};

export const getCancelBodyshotGenerationUrl = (id: number, gid: number) => {
  return `/api/v1/user/models/${id}/bodyshot-generations/${gid}/cancel`;
};

export const cancelBodyshotGeneration = async (
  id: number,
  gid: number,
  options?: RequestInit,
): Promise<BodyshotGeneration> => {
  return customFetch<BodyshotGeneration>(
    getCancelBodyshotGenerationUrl(id, gid),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelBodyshotGenerationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelBodyshotGeneration>>,
    TError,
    { id: number; gid: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelBodyshotGeneration>>,
  TError,
  { id: number; gid: number },
  TContext
> => {
  const mutationKey = ["cancelBodyshotGeneration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelBodyshotGeneration>>,
    { id: number; gid: number }
  > = (props) => {
    const { id, gid } = props ?? {};

    return cancelBodyshotGeneration(id, gid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelBodyshotGenerationMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelBodyshotGeneration>>
>;

export type CancelBodyshotGenerationMutationError = ErrorType<unknown>;

export const useCancelBodyshotGeneration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelBodyshotGeneration>>,
    TError,
    { id: number; gid: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelBodyshotGeneration>>,
  TError,
  { id: number; gid: number },
  TContext
> => {
  return useMutation(getCancelBodyshotGenerationMutationOptions(options));
};

export const getDiscardBodyshotGenerationUrl = (id: number, gid: number) => {
  return `/api/v1/user/models/${id}/bodyshot-generations/${gid}`;
};

export const discardBodyshotGeneration = async (
  id: number,
  gid: number,
  options?: RequestInit,
): Promise<BodyshotGeneration> => {
  return customFetch<BodyshotGeneration>(
    getDiscardBodyshotGenerationUrl(id, gid),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDiscardBodyshotGenerationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardBodyshotGeneration>>,
    TError,
    { id: number; gid: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof discardBodyshotGeneration>>,
  TError,
  { id: number; gid: number },
  TContext
> => {
  const mutationKey = ["discardBodyshotGeneration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof discardBodyshotGeneration>>,
    { id: number; gid: number }
  > = (props) => {
    const { id, gid } = props ?? {};

    return discardBodyshotGeneration(id, gid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DiscardBodyshotGenerationMutationResult = NonNullable<
  Awaited<ReturnType<typeof discardBodyshotGeneration>>
>;

export type DiscardBodyshotGenerationMutationError = ErrorType<unknown>;

export const useDiscardBodyshotGeneration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardBodyshotGeneration>>,
    TError,
    { id: number; gid: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof discardBodyshotGeneration>>,
  TError,
  { id: number; gid: number },
  TContext
> => {
  return useMutation(getDiscardBodyshotGenerationMutationOptions(options));
};

export const getListModelEditSessionsUrl = (id: number) => {
  return `/api/v1/user/models/${id}/edit-sessions`;
};

export const listModelEditSessions = async (
  id: number,
  options?: RequestInit,
): Promise<ModelEditSession[]> => {
  return customFetch<ModelEditSession[]>(getListModelEditSessionsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListModelEditSessionsQueryKey = (id: number) => {
  return [`/api/v1/user/models/${id}/edit-sessions`] as const;
};

export const getListModelEditSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listModelEditSessions>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listModelEditSessions>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListModelEditSessionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listModelEditSessions>>
  > = ({ signal }) => listModelEditSessions(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listModelEditSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListModelEditSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModelEditSessions>>
>;
export type ListModelEditSessionsQueryError = ErrorType<unknown>;

export function useListModelEditSessions<
  TData = Awaited<ReturnType<typeof listModelEditSessions>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof listModelEditSessions>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListModelEditSessionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateModelEditSessionUrl = (id: number) => {
  return `/api/v1/user/models/${id}/edit-sessions`;
};

export const createModelEditSession = async (
  id: number,
  modelEditSessionCreateBody: ModelEditSessionCreateBody,
  options?: RequestInit,
): Promise<ModelEditSession> => {
  return customFetch<ModelEditSession>(getCreateModelEditSessionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(modelEditSessionCreateBody),
  });
};

export const getCreateModelEditSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelEditSession>>,
    TError,
    { id: number; data: BodyType<ModelEditSessionCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModelEditSession>>,
  TError,
  { id: number; data: BodyType<ModelEditSessionCreateBody> },
  TContext
> => {
  const mutationKey = ["createModelEditSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModelEditSession>>,
    { id: number; data: BodyType<ModelEditSessionCreateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createModelEditSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModelEditSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModelEditSession>>
>;
export type CreateModelEditSessionMutationBody =
  BodyType<ModelEditSessionCreateBody>;
export type CreateModelEditSessionMutationError = ErrorType<unknown>;

export const useCreateModelEditSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelEditSession>>,
    TError,
    { id: number; data: BodyType<ModelEditSessionCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createModelEditSession>>,
  TError,
  { id: number; data: BodyType<ModelEditSessionCreateBody> },
  TContext
> => {
  return useMutation(getCreateModelEditSessionMutationOptions(options));
};

export const getGetModelEditSessionUrl = (id: number, sessionId: number) => {
  return `/api/v1/user/models/${id}/edit-sessions/${sessionId}`;
};

export const getModelEditSession = async (
  id: number,
  sessionId: number,
  options?: RequestInit,
): Promise<ModelEditSession> => {
  return customFetch<ModelEditSession>(
    getGetModelEditSessionUrl(id, sessionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetModelEditSessionQueryKey = (
  id: number,
  sessionId: number,
) => {
  return [`/api/v1/user/models/${id}/edit-sessions/${sessionId}`] as const;
};

export const getGetModelEditSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getModelEditSession>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  sessionId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getModelEditSession>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetModelEditSessionQueryKey(id, sessionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModelEditSession>>
  > = ({ signal }) =>
    getModelEditSession(id, sessionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && sessionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getModelEditSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetModelEditSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModelEditSession>>
>;
export type GetModelEditSessionQueryError = ErrorType<unknown>;

export function useGetModelEditSession<
  TData = Awaited<ReturnType<typeof getModelEditSession>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  sessionId: number,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getModelEditSession>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetModelEditSessionQueryOptions(
    id,
    sessionId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateModelEditSessionUrl = (id: number, sessionId: number) => {
  return `/api/v1/user/models/${id}/edit-sessions/${sessionId}`;
};

export const updateModelEditSession = async (
  id: number,
  sessionId: number,
  modelEditSessionUpdateBody: ModelEditSessionUpdateBody,
  options?: RequestInit,
): Promise<ModelEditSession> => {
  return customFetch<ModelEditSession>(
    getUpdateModelEditSessionUrl(id, sessionId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(modelEditSessionUpdateBody),
    },
  );
};

export const getUpdateModelEditSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelEditSession>>,
    TError,
    {
      id: number;
      sessionId: number;
      data: BodyType<ModelEditSessionUpdateBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModelEditSession>>,
  TError,
  { id: number; sessionId: number; data: BodyType<ModelEditSessionUpdateBody> },
  TContext
> => {
  const mutationKey = ["updateModelEditSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModelEditSession>>,
    {
      id: number;
      sessionId: number;
      data: BodyType<ModelEditSessionUpdateBody>;
    }
  > = (props) => {
    const { id, sessionId, data } = props ?? {};

    return updateModelEditSession(id, sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelEditSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModelEditSession>>
>;
export type UpdateModelEditSessionMutationBody =
  BodyType<ModelEditSessionUpdateBody>;
export type UpdateModelEditSessionMutationError = ErrorType<unknown>;

export const useUpdateModelEditSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelEditSession>>,
    TError,
    {
      id: number;
      sessionId: number;
      data: BodyType<ModelEditSessionUpdateBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModelEditSession>>,
  TError,
  { id: number; sessionId: number; data: BodyType<ModelEditSessionUpdateBody> },
  TContext
> => {
  return useMutation(getUpdateModelEditSessionMutationOptions(options));
};

export const getDeleteModelEditSessionUrl = (id: number, sessionId: number) => {
  return `/api/v1/user/models/${id}/edit-sessions/${sessionId}`;
};

export const deleteModelEditSession = async (
  id: number,
  sessionId: number,
  options?: RequestInit,
): Promise<DeleteModelEditSession200> => {
  return customFetch<DeleteModelEditSession200>(
    getDeleteModelEditSessionUrl(id, sessionId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteModelEditSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelEditSession>>,
    TError,
    { id: number; sessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModelEditSession>>,
  TError,
  { id: number; sessionId: number },
  TContext
> => {
  const mutationKey = ["deleteModelEditSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModelEditSession>>,
    { id: number; sessionId: number }
  > = (props) => {
    const { id, sessionId } = props ?? {};

    return deleteModelEditSession(id, sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelEditSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModelEditSession>>
>;

export type DeleteModelEditSessionMutationError = ErrorType<unknown>;

export const useDeleteModelEditSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelEditSession>>,
    TError,
    { id: number; sessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModelEditSession>>,
  TError,
  { id: number; sessionId: number },
  TContext
> => {
  return useMutation(getDeleteModelEditSessionMutationOptions(options));
};

export const getCommitModelEditSessionUrl = (id: number, sessionId: number) => {
  return `/api/v1/user/models/${id}/edit-sessions/${sessionId}/commit`;
};

export const commitModelEditSession = async (
  id: number,
  sessionId: number,
  modelEditSessionCommitBody: ModelEditSessionCommitBody,
  options?: RequestInit,
): Promise<CommitModelEditSession200> => {
  return customFetch<CommitModelEditSession200>(
    getCommitModelEditSessionUrl(id, sessionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(modelEditSessionCommitBody),
    },
  );
};

export const getCommitModelEditSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commitModelEditSession>>,
    TError,
    {
      id: number;
      sessionId: number;
      data: BodyType<ModelEditSessionCommitBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof commitModelEditSession>>,
  TError,
  { id: number; sessionId: number; data: BodyType<ModelEditSessionCommitBody> },
  TContext
> => {
  const mutationKey = ["commitModelEditSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof commitModelEditSession>>,
    {
      id: number;
      sessionId: number;
      data: BodyType<ModelEditSessionCommitBody>;
    }
  > = (props) => {
    const { id, sessionId, data } = props ?? {};

    return commitModelEditSession(id, sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommitModelEditSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof commitModelEditSession>>
>;
export type CommitModelEditSessionMutationBody =
  BodyType<ModelEditSessionCommitBody>;
export type CommitModelEditSessionMutationError = ErrorType<unknown>;

export const useCommitModelEditSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commitModelEditSession>>,
    TError,
    {
      id: number;
      sessionId: number;
      data: BodyType<ModelEditSessionCommitBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof commitModelEditSession>>,
  TError,
  { id: number; sessionId: number; data: BodyType<ModelEditSessionCommitBody> },
  TContext
> => {
  return useMutation(getCommitModelEditSessionMutationOptions(options));
};

/**
 * @summary Reset a failed scheduled post to unlocked so the next batch retries it
 */
export const getRetryPlanContentScheduledPostNowUrl = (id: number) => {
  return `/api/v1/plan-content/scheduled-posts/${id}/retry-now`;
};

export const retryPlanContentScheduledPostNow = async (
  id: number,
  options?: RequestInit,
): Promise<PlanContentScheduledPost> => {
  return customFetch<PlanContentScheduledPost>(
    getRetryPlanContentScheduledPostNowUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetryPlanContentScheduledPostNowMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryPlanContentScheduledPostNow>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryPlanContentScheduledPostNow>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["retryPlanContentScheduledPostNow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryPlanContentScheduledPostNow>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return retryPlanContentScheduledPostNow(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryPlanContentScheduledPostNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryPlanContentScheduledPostNow>>
>;

export type RetryPlanContentScheduledPostNowMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Reset a failed scheduled post to unlocked so the next batch retries it
 */
export const useRetryPlanContentScheduledPostNow = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryPlanContentScheduledPostNow>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryPlanContentScheduledPostNow>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getRetryPlanContentScheduledPostNowMutationOptions(options),
  );
};

/**
 * @summary List all editable email templates
 */
export const getListEmailTemplatesUrl = () => {
  return `/api/v1/admin/email-templates`;
};

export const listEmailTemplates = async (
  options?: RequestInit,
): Promise<EmailTemplateListResponse> => {
  return customFetch<EmailTemplateListResponse>(getListEmailTemplatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListEmailTemplatesQueryKey = () => {
  return [`/api/v1/admin/email-templates`] as const;
};

export const getListEmailTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEmailTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listEmailTemplates>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEmailTemplatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEmailTemplates>>
  > = ({ signal }) => listEmailTemplates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEmailTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEmailTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEmailTemplates>>
>;
export type ListEmailTemplatesQueryError = ErrorType<unknown>;

/**
 * @summary List all editable email templates
 */

export function useListEmailTemplates<
  TData = Awaited<ReturnType<typeof listEmailTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof listEmailTemplates>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEmailTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single email template by key
 */
export const getGetEmailTemplateUrl = (key: string) => {
  return `/api/v1/admin/email-templates/${key}`;
};

export const getEmailTemplate = async (
  key: string,
  options?: RequestInit,
): Promise<EmailTemplateDetail> => {
  return customFetch<EmailTemplateDetail>(getGetEmailTemplateUrl(key), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailTemplateQueryKey = (key: string) => {
  return [`/api/v1/admin/email-templates/${key}`] as const;
};

export const getGetEmailTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailTemplate>>,
  TError = ErrorType<ErrorResponse>,
>(
  key: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getEmailTemplate>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailTemplateQueryKey(key);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailTemplate>>
  > = ({ signal }) => getEmailTemplate(key, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!key,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailTemplate>>
>;
export type GetEmailTemplateQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a single email template by key
 */

export function useGetEmailTemplate<
  TData = Awaited<ReturnType<typeof getEmailTemplate>>,
  TError = ErrorType<ErrorResponse>,
>(
  key: string,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getEmailTemplate>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailTemplateQueryOptions(key, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an email template
 */
export const getUpdateEmailTemplateUrl = (key: string) => {
  return `/api/v1/admin/email-templates/${key}`;
};

export const updateEmailTemplate = async (
  key: string,
  updateEmailTemplateBody: UpdateEmailTemplateBody,
  options?: RequestInit,
): Promise<EmailTemplate> => {
  return customFetch<EmailTemplate>(getUpdateEmailTemplateUrl(key), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEmailTemplateBody),
  });
};

export const getUpdateEmailTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailTemplate>>,
    TError,
    { key: string; data: BodyType<UpdateEmailTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailTemplate>>,
  TError,
  { key: string; data: BodyType<UpdateEmailTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateEmailTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailTemplate>>,
    { key: string; data: BodyType<UpdateEmailTemplateBody> }
  > = (props) => {
    const { key, data } = props ?? {};

    return updateEmailTemplate(key, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailTemplate>>
>;
export type UpdateEmailTemplateMutationBody = BodyType<UpdateEmailTemplateBody>;
export type UpdateEmailTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Update an email template
 */
export const useUpdateEmailTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailTemplate>>,
    TError,
    { key: string; data: BodyType<UpdateEmailTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailTemplate>>,
  TError,
  { key: string; data: BodyType<UpdateEmailTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateEmailTemplateMutationOptions(options));
};

/**
 * @summary Reset template to compiled-in default
 */
export const getResetEmailTemplateUrl = (key: string) => {
  return `/api/v1/admin/email-templates/${key}/reset`;
};

export const resetEmailTemplate = async (
  key: string,
  options?: RequestInit,
): Promise<EmailTemplate> => {
  return customFetch<EmailTemplate>(getResetEmailTemplateUrl(key), {
    ...options,
    method: "POST",
  });
};

export const getResetEmailTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetEmailTemplate>>,
    TError,
    { key: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetEmailTemplate>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ["resetEmailTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetEmailTemplate>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return resetEmailTemplate(key, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetEmailTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetEmailTemplate>>
>;

export type ResetEmailTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Reset template to compiled-in default
 */
export const useResetEmailTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetEmailTemplate>>,
    TError,
    { key: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetEmailTemplate>>,
  TError,
  { key: string },
  TContext
> => {
  return useMutation(getResetEmailTemplateMutationOptions(options));
};

/**
 * @summary Render template (with optional unsaved overrides) and return HTML
 */
export const getPreviewEmailTemplateUrl = (key: string) => {
  return `/api/v1/admin/email-templates/${key}/preview`;
};

export const previewEmailTemplate = async (
  key: string,
  previewEmailTemplateBody: PreviewEmailTemplateBody,
  options?: RequestInit,
): Promise<EmailTemplatePreviewResponse> => {
  return customFetch<EmailTemplatePreviewResponse>(
    getPreviewEmailTemplateUrl(key),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(previewEmailTemplateBody),
    },
  );
};

export const getPreviewEmailTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewEmailTemplate>>,
    TError,
    { key: string; data: BodyType<PreviewEmailTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewEmailTemplate>>,
  TError,
  { key: string; data: BodyType<PreviewEmailTemplateBody> },
  TContext
> => {
  const mutationKey = ["previewEmailTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewEmailTemplate>>,
    { key: string; data: BodyType<PreviewEmailTemplateBody> }
  > = (props) => {
    const { key, data } = props ?? {};

    return previewEmailTemplate(key, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewEmailTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewEmailTemplate>>
>;
export type PreviewEmailTemplateMutationBody =
  BodyType<PreviewEmailTemplateBody>;
export type PreviewEmailTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Render template (with optional unsaved overrides) and return HTML
 */
export const usePreviewEmailTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewEmailTemplate>>,
    TError,
    { key: string; data: BodyType<PreviewEmailTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewEmailTemplate>>,
  TError,
  { key: string; data: BodyType<PreviewEmailTemplateBody> },
  TContext
> => {
  return useMutation(getPreviewEmailTemplateMutationOptions(options));
};

/**
 * @summary Send a test email using sample variable values
 */
export const getTestSendEmailTemplateUrl = (key: string) => {
  return `/api/v1/admin/email-templates/${key}/test-send`;
};

export const testSendEmailTemplate = async (
  key: string,
  testSendEmailBody: TestSendEmailBody,
  options?: RequestInit,
): Promise<TestSendEmailResponse> => {
  return customFetch<TestSendEmailResponse>(getTestSendEmailTemplateUrl(key), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(testSendEmailBody),
  });
};

export const getTestSendEmailTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testSendEmailTemplate>>,
    TError,
    { key: string; data: BodyType<TestSendEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testSendEmailTemplate>>,
  TError,
  { key: string; data: BodyType<TestSendEmailBody> },
  TContext
> => {
  const mutationKey = ["testSendEmailTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testSendEmailTemplate>>,
    { key: string; data: BodyType<TestSendEmailBody> }
  > = (props) => {
    const { key, data } = props ?? {};

    return testSendEmailTemplate(key, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestSendEmailTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof testSendEmailTemplate>>
>;
export type TestSendEmailTemplateMutationBody = BodyType<TestSendEmailBody>;
export type TestSendEmailTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Send a test email using sample variable values
 */
export const useTestSendEmailTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testSendEmailTemplate>>,
    TError,
    { key: string; data: BodyType<TestSendEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testSendEmailTemplate>>,
  TError,
  { key: string; data: BodyType<TestSendEmailBody> },
  TContext
> => {
  return useMutation(getTestSendEmailTemplateMutationOptions(options));
};

/**
 * @summary Get global header/footer/signature/brand settings
 */
export const getGetEmailGlobalSettingsUrl = () => {
  return `/api/v1/admin/email-global-settings`;
};

export const getEmailGlobalSettings = async (
  options?: RequestInit,
): Promise<EmailGlobalSettings> => {
  return customFetch<EmailGlobalSettings>(getGetEmailGlobalSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailGlobalSettingsQueryKey = () => {
  return [`/api/v1/admin/email-global-settings`] as const;
};

export const getGetEmailGlobalSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailGlobalSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getEmailGlobalSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEmailGlobalSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailGlobalSettings>>
  > = ({ signal }) => getEmailGlobalSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailGlobalSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailGlobalSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailGlobalSettings>>
>;
export type GetEmailGlobalSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get global header/footer/signature/brand settings
 */

export function useGetEmailGlobalSettings<
  TData = Awaited<ReturnType<typeof getEmailGlobalSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof getEmailGlobalSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailGlobalSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update global header/footer/signature/brand settings
 */
export const getUpdateEmailGlobalSettingsUrl = () => {
  return `/api/v1/admin/email-global-settings`;
};

export const updateEmailGlobalSettings = async (
  updateEmailGlobalSettingsBody: UpdateEmailGlobalSettingsBody,
  options?: RequestInit,
): Promise<EmailGlobalSettings> => {
  return customFetch<EmailGlobalSettings>(getUpdateEmailGlobalSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEmailGlobalSettingsBody),
  });
};

export const getUpdateEmailGlobalSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailGlobalSettings>>,
    TError,
    { data: BodyType<UpdateEmailGlobalSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailGlobalSettings>>,
  TError,
  { data: BodyType<UpdateEmailGlobalSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateEmailGlobalSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailGlobalSettings>>,
    { data: BodyType<UpdateEmailGlobalSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmailGlobalSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailGlobalSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailGlobalSettings>>
>;
export type UpdateEmailGlobalSettingsMutationBody =
  BodyType<UpdateEmailGlobalSettingsBody>;
export type UpdateEmailGlobalSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update global header/footer/signature/brand settings
 */
export const useUpdateEmailGlobalSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailGlobalSettings>>,
    TError,
    { data: BodyType<UpdateEmailGlobalSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailGlobalSettings>>,
  TError,
  { data: BodyType<UpdateEmailGlobalSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateEmailGlobalSettingsMutationOptions(options));
};

/**
 * @summary Reset global settings to compiled-in defaults
 */
export const getResetEmailGlobalSettingsUrl = () => {
  return `/api/v1/admin/email-global-settings/reset`;
};

export const resetEmailGlobalSettings = async (
  options?: RequestInit,
): Promise<EmailGlobalSettings> => {
  return customFetch<EmailGlobalSettings>(getResetEmailGlobalSettingsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getResetEmailGlobalSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetEmailGlobalSettings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetEmailGlobalSettings>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resetEmailGlobalSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetEmailGlobalSettings>>,
    void
  > = () => {
    return resetEmailGlobalSettings(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetEmailGlobalSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetEmailGlobalSettings>>
>;

export type ResetEmailGlobalSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Reset global settings to compiled-in defaults
 */
export const useResetEmailGlobalSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetEmailGlobalSettings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetEmailGlobalSettings>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getResetEmailGlobalSettingsMutationOptions(options));
};

/**
 * @summary Convert a Create-Content card image into a short AI video via Kie.ai
 */
export const getGenerateVideoUrl = () => {
  return `/api/v1/videos/generate`;
};

export const generateVideo = async (
  generateVideoBody: GenerateVideoBody,
  options?: RequestInit,
): Promise<VideoGenerateResponse> => {
  return customFetch<VideoGenerateResponse>(getGenerateVideoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateVideoBody),
  });
};

export const getGenerateVideoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateVideo>>,
    TError,
    { data: BodyType<GenerateVideoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateVideo>>,
  TError,
  { data: BodyType<GenerateVideoBody> },
  TContext
> => {
  const mutationKey = ["generateVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateVideo>>,
    { data: BodyType<GenerateVideoBody> }
  > = (props) => {
    const { data } = props ?? {};

    return generateVideo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateVideo>>
>;
export type GenerateVideoMutationBody = BodyType<GenerateVideoBody>;
export type GenerateVideoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Convert a Create-Content card image into a short AI video via Kie.ai
 */
export const useGenerateVideo = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateVideo>>,
    TError,
    { data: BodyType<GenerateVideoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateVideo>>,
  TError,
  { data: BodyType<GenerateVideoBody> },
  TContext
> => {
  return useMutation(getGenerateVideoMutationOptions(options));
};

/**
 * @summary Live charge preview for a (model, tier, duration) — same source as the actual charge
 */
export const getGetVideoCostPreviewUrl = (
  params: GetVideoCostPreviewParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/videos/cost?${stringifiedParams}`
    : `/api/v1/videos/cost`;
};

export const getVideoCostPreview = async (
  params: GetVideoCostPreviewParams,
  options?: RequestInit,
): Promise<VideoCostPreview> => {
  return customFetch<VideoCostPreview>(getGetVideoCostPreviewUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetVideoCostPreviewQueryKey = (
  params?: GetVideoCostPreviewParams,
) => {
  return [`/api/v1/videos/cost`, ...(params ? [params] : [])] as const;
};

export const getGetVideoCostPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideoCostPreview>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetVideoCostPreviewParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getVideoCostPreview>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVideoCostPreviewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVideoCostPreview>>
  > = ({ signal }) =>
    getVideoCostPreview(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideoCostPreview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVideoCostPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVideoCostPreview>>
>;
export type GetVideoCostPreviewQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Live charge preview for a (model, tier, duration) — same source as the actual charge
 */

export function useGetVideoCostPreview<
  TData = Awaited<ReturnType<typeof getVideoCostPreview>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetVideoCostPreviewParams,
  options?: {
    query?: Partial<UseQueryOptions<
      Awaited<ReturnType<typeof getVideoCostPreview>>,
      TError,
      TData
    >>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVideoCostPreviewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List enabled video models (and their declarative control schemas) for the Direction dialog
 */
export const getVideoDirectorListModelsUrl = () => {
  return `/api/v1/video-director/models`;
};

export const videoDirectorListModels = async (
  options?: RequestInit,
): Promise<VideoDirectorModelsResponse> => {
  return customFetch<VideoDirectorModelsResponse>(
    getVideoDirectorListModelsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getVideoDirectorListModelsQueryKey = () => {
  return [`/api/v1/video-director/models`] as const;
};

export const getVideoDirectorListModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof videoDirectorListModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof videoDirectorListModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getVideoDirectorListModelsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof videoDirectorListModels>>
  > = ({ signal }) => videoDirectorListModels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof videoDirectorListModels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type VideoDirectorListModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof videoDirectorListModels>>
>;
export type VideoDirectorListModelsQueryError = ErrorType<unknown>;

/**
 * @summary List enabled video models (and their declarative control schemas) for the Direction dialog
 */

export function useVideoDirectorListModels<
  TData = Awaited<ReturnType<typeof videoDirectorListModels>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof videoDirectorListModels>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getVideoDirectorListModelsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Produce 3 model-tuned video concept options from the source image + optional direction
 */
export const getVideoDirectorGenerateOptionsUrl = () => {
  return `/api/v1/video-director/generate-options`;
};

export const videoDirectorGenerateOptions = async (
  videoDirectorGenerateOptionsBody: VideoDirectorGenerateOptionsBody,
  options?: RequestInit,
): Promise<VideoDirectorGenerateOptionsResponse> => {
  return customFetch<VideoDirectorGenerateOptionsResponse>(
    getVideoDirectorGenerateOptionsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(videoDirectorGenerateOptionsBody),
    },
  );
};

export const getVideoDirectorGenerateOptionsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof videoDirectorGenerateOptions>>,
    TError,
    { data: BodyType<VideoDirectorGenerateOptionsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof videoDirectorGenerateOptions>>,
  TError,
  { data: BodyType<VideoDirectorGenerateOptionsBody> },
  TContext
> => {
  const mutationKey = ["videoDirectorGenerateOptions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof videoDirectorGenerateOptions>>,
    { data: BodyType<VideoDirectorGenerateOptionsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return videoDirectorGenerateOptions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VideoDirectorGenerateOptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof videoDirectorGenerateOptions>>
>;
export type VideoDirectorGenerateOptionsMutationBody =
  BodyType<VideoDirectorGenerateOptionsBody>;
export type VideoDirectorGenerateOptionsMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Produce 3 model-tuned video concept options from the source image + optional direction
 */
export const useVideoDirectorGenerateOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof videoDirectorGenerateOptions>>,
    TError,
    { data: BodyType<VideoDirectorGenerateOptionsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof videoDirectorGenerateOptions>>,
  TError,
  { data: BodyType<VideoDirectorGenerateOptionsBody> },
  TContext
> => {
  return useMutation(getVideoDirectorGenerateOptionsMutationOptions(options));
};

/**
 * @summary List all per-(model,tier) video cost rows
 */
export const getAdminListVideoCostsUrl = () => {
  return `/api/v1/admin/video-costs`;
};

export const adminListVideoCosts = async (
  options?: RequestInit,
): Promise<VideoAiCost[]> => {
  return customFetch<VideoAiCost[]>(getAdminListVideoCostsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListVideoCostsQueryKey = () => {
  return [`/api/v1/admin/video-costs`] as const;
};

export const getAdminListVideoCostsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListVideoCosts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListVideoCosts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListVideoCostsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListVideoCosts>>
  > = ({ signal }) => adminListVideoCosts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListVideoCosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListVideoCostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListVideoCosts>>
>;
export type AdminListVideoCostsQueryError = ErrorType<unknown>;

/**
 * @summary List all per-(model,tier) video cost rows
 */

export function useAdminListVideoCosts<
  TData = Awaited<ReturnType<typeof adminListVideoCosts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListVideoCosts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListVideoCostsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a video cost row for a (model, tier)
 */
export const getAdminCreateVideoCostUrl = () => {
  return `/api/v1/admin/video-costs`;
};

export const adminCreateVideoCost = async (
  videoCostCreateBody: VideoCostCreateBody,
  options?: RequestInit,
): Promise<VideoAiCost> => {
  return customFetch<VideoAiCost>(getAdminCreateVideoCostUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(videoCostCreateBody),
  });
};

export const getAdminCreateVideoCostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateVideoCost>>,
    TError,
    { data: BodyType<VideoCostCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateVideoCost>>,
  TError,
  { data: BodyType<VideoCostCreateBody> },
  TContext
> => {
  const mutationKey = ["adminCreateVideoCost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateVideoCost>>,
    { data: BodyType<VideoCostCreateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateVideoCost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateVideoCostMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateVideoCost>>
>;
export type AdminCreateVideoCostMutationBody = BodyType<VideoCostCreateBody>;
export type AdminCreateVideoCostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a video cost row for a (model, tier)
 */
export const useAdminCreateVideoCost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateVideoCost>>,
    TError,
    { data: BodyType<VideoCostCreateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateVideoCost>>,
  TError,
  { data: BodyType<VideoCostCreateBody> },
  TContext
> => {
  return useMutation(getAdminCreateVideoCostMutationOptions(options));
};

/**
 * @summary List declared (model, tier) combinations from the registry that have no cost row yet
 */
export const getAdminListMissingVideoCostsUrl = () => {
  return `/api/v1/admin/video-costs/missing`;
};

export const adminListMissingVideoCosts = async (
  options?: RequestInit,
): Promise<VideoCostMissingResponse> => {
  return customFetch<VideoCostMissingResponse>(
    getAdminListMissingVideoCostsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListMissingVideoCostsQueryKey = () => {
  return [`/api/v1/admin/video-costs/missing`] as const;
};

export const getAdminListMissingVideoCostsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListMissingVideoCosts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListMissingVideoCosts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListMissingVideoCostsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListMissingVideoCosts>>
  > = ({ signal }) => adminListMissingVideoCosts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListMissingVideoCosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListMissingVideoCostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListMissingVideoCosts>>
>;
export type AdminListMissingVideoCostsQueryError = ErrorType<unknown>;

/**
 * @summary List declared (model, tier) combinations from the registry that have no cost row yet
 */

export function useAdminListMissingVideoCosts<
  TData = Awaited<ReturnType<typeof adminListMissingVideoCosts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminListMissingVideoCosts>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListMissingVideoCostsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a video cost row
 */
export const getAdminUpdateVideoCostUrl = (id: number) => {
  return `/api/v1/admin/video-costs/${id}`;
};

export const adminUpdateVideoCost = async (
  id: number,
  videoCostUpdateBody: VideoCostUpdateBody,
  options?: RequestInit,
): Promise<VideoAiCost> => {
  return customFetch<VideoAiCost>(getAdminUpdateVideoCostUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(videoCostUpdateBody),
  });
};

export const getAdminUpdateVideoCostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateVideoCost>>,
    TError,
    { id: number; data: BodyType<VideoCostUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateVideoCost>>,
  TError,
  { id: number; data: BodyType<VideoCostUpdateBody> },
  TContext
> => {
  const mutationKey = ["adminUpdateVideoCost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateVideoCost>>,
    { id: number; data: BodyType<VideoCostUpdateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminUpdateVideoCost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateVideoCostMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateVideoCost>>
>;
export type AdminUpdateVideoCostMutationBody = BodyType<VideoCostUpdateBody>;
export type AdminUpdateVideoCostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a video cost row
 */
export const useAdminUpdateVideoCost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateVideoCost>>,
    TError,
    { id: number; data: BodyType<VideoCostUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateVideoCost>>,
  TError,
  { id: number; data: BodyType<VideoCostUpdateBody> },
  TContext
> => {
  return useMutation(getAdminUpdateVideoCostMutationOptions(options));
};

/**
 * @summary Delete a video cost row
 */
export const getAdminDeleteVideoCostUrl = (id: number) => {
  return `/api/v1/admin/video-costs/${id}`;
};

export const adminDeleteVideoCost = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getAdminDeleteVideoCostUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminDeleteVideoCostMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteVideoCost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteVideoCost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminDeleteVideoCost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteVideoCost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminDeleteVideoCost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteVideoCostMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteVideoCost>>
>;

export type AdminDeleteVideoCostMutationError = ErrorType<unknown>;

/**
 * @summary Delete a video cost row
 */
export const useAdminDeleteVideoCost = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteVideoCost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteVideoCost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminDeleteVideoCostMutationOptions(options));
};

/**
 * @summary Get video registry enable/disable state, global content filtering, and pool concurrency
 */
export const getAdminGetVideoSettingsUrl = () => {
  return `/api/v1/admin/video-settings`;
};

export const adminGetVideoSettings = async (
  options?: RequestInit,
): Promise<VideoSettings> => {
  return customFetch<VideoSettings>(getAdminGetVideoSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetVideoSettingsQueryKey = () => {
  return [`/api/v1/admin/video-settings`] as const;
};

export const getAdminGetVideoSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetVideoSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetVideoSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetVideoSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetVideoSettings>>
  > = ({ signal }) => adminGetVideoSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetVideoSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetVideoSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetVideoSettings>>
>;
export type AdminGetVideoSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get video registry enable/disable state, global content filtering, and pool concurrency
 */

export function useAdminGetVideoSettings<
  TData = Awaited<ReturnType<typeof adminGetVideoSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<
    Awaited<ReturnType<typeof adminGetVideoSettings>>,
    TError,
    TData
  >>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetVideoSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update global content filtering and/or the video reconcile pool concurrency
 */
export const getAdminUpdateVideoSettingsUrl = () => {
  return `/api/v1/admin/video-settings`;
};

export const adminUpdateVideoSettings = async (
  videoSettingsUpdateBody: VideoSettingsUpdateBody,
  options?: RequestInit,
): Promise<VideoSettings> => {
  return customFetch<VideoSettings>(getAdminUpdateVideoSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(videoSettingsUpdateBody),
  });
};

export const getAdminUpdateVideoSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateVideoSettings>>,
    TError,
    { data: BodyType<VideoSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateVideoSettings>>,
  TError,
  { data: BodyType<VideoSettingsUpdateBody> },
  TContext
> => {
  const mutationKey = ["adminUpdateVideoSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateVideoSettings>>,
    { data: BodyType<VideoSettingsUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUpdateVideoSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateVideoSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateVideoSettings>>
>;
export type AdminUpdateVideoSettingsMutationBody =
  BodyType<VideoSettingsUpdateBody>;
export type AdminUpdateVideoSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update global content filtering and/or the video reconcile pool concurrency
 */
export const useAdminUpdateVideoSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateVideoSettings>>,
    TError,
    { data: BodyType<VideoSettingsUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateVideoSettings>>,
  TError,
  { data: BodyType<VideoSettingsUpdateBody> },
  TContext
> => {
  return useMutation(getAdminUpdateVideoSettingsMutationOptions(options));
};

/**
 * @summary Enable or disable a single video model
 */
export const getAdminToggleVideoModelUrl = (id: string) => {
  return `/api/v1/admin/video-models/${id}`;
};

export const adminToggleVideoModel = async (
  id: string,
  videoModelToggleBody: VideoModelToggleBody,
  options?: RequestInit,
): Promise<VideoModelToggleResponse> => {
  return customFetch<VideoModelToggleResponse>(
    getAdminToggleVideoModelUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(videoModelToggleBody),
    },
  );
};

export const getAdminToggleVideoModelMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminToggleVideoModel>>,
    TError,
    { id: string; data: BodyType<VideoModelToggleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminToggleVideoModel>>,
  TError,
  { id: string; data: BodyType<VideoModelToggleBody> },
  TContext
> => {
  const mutationKey = ["adminToggleVideoModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminToggleVideoModel>>,
    { id: string; data: BodyType<VideoModelToggleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminToggleVideoModel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminToggleVideoModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminToggleVideoModel>>
>;
export type AdminToggleVideoModelMutationBody = BodyType<VideoModelToggleBody>;
export type AdminToggleVideoModelMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Enable or disable a single video model
 */
export const useAdminToggleVideoModel = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminToggleVideoModel>>,
    TError,
    { id: string; data: BodyType<VideoModelToggleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminToggleVideoModel>>,
  TError,
  { id: string; data: BodyType<VideoModelToggleBody> },
  TContext
> => {
  return useMutation(getAdminToggleVideoModelMutationOptions(options));
};
